/* tslint:disable */
/* eslint-disable */
/**
 * Bright Class API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject as _setApiKeyToObject,
  setBasicAuthToObject as _setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject as _setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded as _replaceWithSerializableTypeIfNeeded,
} from './common'
import type { RequestArgs } from './base'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base'

export interface AddStudentToGroupRequest {
  studentId?: string
}
export interface Assessment {
  id?: string
  name?: string
  category?: GetAssessmentCategoriesResponseCategoriesInner
  markingMethod?: object
  tenantId?: string
  academicYearId?: string
  createdBy?: string
}
export interface AssessmentCategory {
  id?: string
  name?: string
  colour?: AssessmentCategoryColourEnum
}

export const AssessmentCategoryColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type AssessmentCategoryColourEnum =
  (typeof AssessmentCategoryColourEnum)[keyof typeof AssessmentCategoryColourEnum]

export interface AssignTeacherToClassRequest {
  classId?: string
  subject?: string
  isPrimary?: boolean
}
export interface Assignment {
  id?: string
  assessmentId?: string
  assessmentName?: string
  weight?: number
  dateAssigned?: string
  dateDue?: string
  excludeFromFinalGrade?: boolean
  classId?: string
  markingMethod?: object
  category?: GetAssessmentCategoriesResponseCategoriesInner
}
export interface AssignmentGrade {
  id?: string
  studentId?: string
  markedAt?: string
  markedBy?: string
  comments?: Array<GradebookGradesInnerCommentsInner>
  assignment?: GradebookGradesInnerAssignment
  marking?: object
  grade?: number
}
export interface BootstrapTenantRequest {
  name?: string
  type?: BootstrapTenantRequestTypeEnum
  firstAcademicYear?: BootstrapTenantRequestFirstAcademicYear
  subjects?: Array<string>
  teachingYears?: Array<string>
  assessmentCategories?: Array<string>
}

export const BootstrapTenantRequestTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type BootstrapTenantRequestTypeEnum =
  (typeof BootstrapTenantRequestTypeEnum)[keyof typeof BootstrapTenantRequestTypeEnum]

export interface BootstrapTenantRequestFirstAcademicYear {
  label?: string
  startsAt?: string
  endsAt?: string
}
export interface ChangePasswordRequest {
  oldPassword?: string
  newPassword?: string
}
export interface CheckoutResponse {
  checkoutUrl?: string
}
export interface ClassAttendanceSummary {
  overallAttendancePercentage?: number
  lessons?: Array<ClassAttendanceSummaryLessonsInner>
}
export interface ClassAttendanceSummaryLessonsInner {
  lesson?: GetLessonAttendanceResponseLessonAttendanceLesson
  lateCount?: number
  absentCount?: number
  averageAttendancePercentage?: number
  hasAttendance?: boolean
}
export interface ClassDetails {
  id?: string
  name?: string
  colour?: ClassDetailsColourEnum
  studentCount?: number
  createdBy?: string
}

export const ClassDetailsColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type ClassDetailsColourEnum =
  (typeof ClassDetailsColourEnum)[keyof typeof ClassDetailsColourEnum]

export interface ClassGradingSetup {
  setup?: GradebookGradingSetup
  categories?: Array<GetAssessmentCategoriesResponseCategoriesInner>
}
export interface ClassNotes {
  notes?: Array<ClassNotesNotesInner>
}
export interface ClassNotesNotesInner {
  id?: string
  title?: string
  text?: string
  date?: string
}
export interface ClassOverview {
  classDetails?: GetAssignmentDetailsResponseAssignmentClassDetails
  students?: Array<GetAssignmentDetailsResponseAssignmentStudentsInnerStudent>
  upcomingBirthdays?: Array<GetAssignmentDetailsResponseAssignmentStudentsInnerStudent>
  averageAttendance?: number
}
export interface ClassPlanner {
  items?: Array<ClassTimelineItemsInner>
}
export interface ClassReportResponse {
  summary?: ReportsResponseSummarySummary
  students?: Array<ReportsResponseSummaryStudentsInner>
}
export interface ClassTimeline {
  items?: Array<ClassTimelineItemsInner>
  birthdays?: Array<GetAssignmentDetailsResponseAssignmentStudentsInnerStudent>
}
export interface ClassTimelineItemsInner {
  dateTime?: string
}
export interface ConfirmImportRequest {
  parseId?: string
  classId?: string
  columnMappings?: { [key: string]: ParseFileResponseSuggestedMappingsValue }
}
export interface CreateAcademicYearRequest {
  label?: string
  startsAt?: string
  endsAt?: string
}
export interface CreateActivityRequest {
  title?: string
  description?: string
  phase?: CreateActivityRequestPhaseEnum
  duration?: number
  position?: number
}

export const CreateActivityRequestPhaseEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateActivityRequestPhaseEnum =
  (typeof CreateActivityRequestPhaseEnum)[keyof typeof CreateActivityRequestPhaseEnum]

export interface CreateAssessmentCategoryRequest {
  name?: string
  colour?: CreateAssessmentCategoryRequestColourEnum
}

export const CreateAssessmentCategoryRequestColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateAssessmentCategoryRequestColourEnum =
  (typeof CreateAssessmentCategoryRequestColourEnum)[keyof typeof CreateAssessmentCategoryRequestColourEnum]

export interface CreateAssessmentRequest {
  name?: string
  categoryId?: string
  markingType?: CreateAssessmentRequestMarkingTypeEnum
  maxPoints?: number
  scaleId?: string
  rubricId?: string
}

export const CreateAssessmentRequestMarkingTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateAssessmentRequestMarkingTypeEnum =
  (typeof CreateAssessmentRequestMarkingTypeEnum)[keyof typeof CreateAssessmentRequestMarkingTypeEnum]

export interface CreateAssignmentRequest {
  assessmentId?: string
  classId?: string
  dateAssigned?: string
  dateDue?: string
  weight?: number
  excludeFromFinalGrade?: boolean
}
export interface CreateCheckoutRequest {
  priceId?: string
  successUrl?: string
  cancelUrl?: string
}
export interface CreateClassAssignmentRequest {
  assessmentName?: string
  categoryId?: string
  markingType?: CreateClassAssignmentRequestMarkingTypeEnum
  maxPoints?: number
  scaleId?: string
  rubricId?: string
  weight?: number
  dateAssigned?: string
  dateDue?: string
  excludeFromFinalGrade?: boolean
}

export const CreateClassAssignmentRequestMarkingTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateClassAssignmentRequestMarkingTypeEnum =
  (typeof CreateClassAssignmentRequestMarkingTypeEnum)[keyof typeof CreateClassAssignmentRequestMarkingTypeEnum]

export interface CreateClassNoteRequest {
  title?: string
  text?: string
  date?: string
  lessonId?: string
}
export interface CreateClassRequest {
  name?: string
  groupId?: string
  colour?: CreateClassRequestColourEnum
}

export const CreateClassRequestColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateClassRequestColourEnum =
  (typeof CreateClassRequestColourEnum)[keyof typeof CreateClassRequestColourEnum]

export interface CreateClassesRequest {
  classes?: Array<CreateClassesRequestClassesInner>
}
export interface CreateClassesRequestClassesInner {
  name?: string
  groupId?: string
  colour?: CreateClassesRequestClassesInnerColourEnum
}

export const CreateClassesRequestClassesInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateClassesRequestClassesInnerColourEnum =
  (typeof CreateClassesRequestClassesInnerColourEnum)[keyof typeof CreateClassesRequestClassesInnerColourEnum]

export interface CreateGradeRequest {
  assignmentId?: string
  studentId?: string
  numericPoints?: number
  scaleLevelId?: string
  submittedAt?: string
  markedAt?: string
  markedBy?: string
  comment?: string
}
export interface CreateGradingSetupRequest {
  rootComponents?: Array<CreateGradingSetupRequestRootComponentsInner>
}
export interface CreateGradingSetupRequestRootComponentsInner {
  parentComponentId?: string
  termId?: string
  categoryId?: string
  weight?: number
}
export interface CreateGroupRequest {
  name?: string
  colour?: CreateGroupRequestColourEnum
}

export const CreateGroupRequestColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateGroupRequestColourEnum =
  (typeof CreateGroupRequestColourEnum)[keyof typeof CreateGroupRequestColourEnum]

export interface CreateGroupsRequest {
  groups?: Array<CreateGroupsRequestGroupsInner>
}
export interface CreateGroupsRequestGroupsInner {
  name?: string
  colour?: CreateGroupsRequestGroupsInnerColourEnum
}

export const CreateGroupsRequestGroupsInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateGroupsRequestGroupsInnerColourEnum =
  (typeof CreateGroupsRequestGroupsInnerColourEnum)[keyof typeof CreateGroupsRequestGroupsInnerColourEnum]

export interface CreateLessonObjectiveRequest {
  objective?: string
  position?: number
}
export interface CreateLessonPlanRequest {
  title?: string
  overview?: string
  position?: number
  estimatedDuration?: number
}
export interface CreateLessonRequest {
  classId?: string
  startTime?: string
  endTime?: string
  room?: string
  title?: string
  tag?: string
}
export interface CreateLessonScheduleRequest {
  classId?: string
  description?: string
  startDate?: string
  endDate?: string
  frequency?: string
  sessions?: Array<CreateLessonScheduleRequestSessionsInner>
}
export interface CreateLessonScheduleRequestSessionsInner {
  dayOfWeek?: string
  startTime?: string
  endTime?: string
  room?: string
  title?: string
}
export interface CreateRelationRequest {
  name?: string
  email?: string
  mobile?: string
}
export interface CreateScaleRequest {
  name?: string
  levels?: Array<CreateScaleRequestLevelsInner>
}
export interface CreateScaleRequestLevelsInner {
  text?: string
  weight?: number
  iconId?: number
}
export interface CreateSchemeObjectiveRequest {
  objective?: string
  position?: number
}
export interface CreateSchemeRequest {
  name?: string
  description?: string
  courseId?: string
  colour?: CreateSchemeRequestColourEnum
  iconId?: string
}

export const CreateSchemeRequestColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateSchemeRequestColourEnum =
  (typeof CreateSchemeRequestColourEnum)[keyof typeof CreateSchemeRequestColourEnum]

export interface CreateSchemeTopicRequest {
  topic?: string
  position?: number
}
export interface CreateStudentRelationRequest {
  relationId?: string
  relationshipType?: CreateStudentRelationRequestRelationshipTypeEnum
  name?: string
  email?: string
  mobile?: string
}

export const CreateStudentRelationRequestRelationshipTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateStudentRelationRequestRelationshipTypeEnum =
  (typeof CreateStudentRelationRequestRelationshipTypeEnum)[keyof typeof CreateStudentRelationRequestRelationshipTypeEnum]

export interface CreateStudentRequest {
  firstName?: string
  middleName?: string
  lastName?: string
  gender?: string
  dob?: string
  schoolId?: string
  nationality?: string
  mobile?: string
  email?: string
}
export interface CreateStudentsBatchRequest {
  students?: Array<CreateStudentsBatchRequestStudentsInner>
}
export interface CreateStudentsBatchRequestStudentsInner {
  firstName?: string
  middleName?: string
  lastName?: string
  gender?: string
  dob?: string
  schoolId?: string
  nationality?: string
  mobile?: string
  email?: string
}
export interface CreateTeacherRequest {
  firstName?: string
  lastName?: string
  email?: string
  mobile?: string
}
export interface CreateTenantRequest {
  name?: string
  type?: CreateTenantRequestTypeEnum
}

export const CreateTenantRequestTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type CreateTenantRequestTypeEnum =
  (typeof CreateTenantRequestTypeEnum)[keyof typeof CreateTenantRequestTypeEnum]

export interface CreateTermsRequest {
  name?: string
  start?: string
  end?: string
}
export interface CreateUnitObjectiveRequest {
  objective?: string
  position?: number
}
export interface CreateUnitRequest {
  title?: string
  aim?: string
  position?: number
}
export interface EffectivePermissionsResponse {
  permissions?: Array<string>
  isAdmin?: boolean
  role?: string
}
export interface ForgotPasswordRequest {
  email?: string
}
export interface GenerateLessonPlanRequest {
  subject?: string
  yearGroup?: string
  lessonDurationMinutes?: number
  numberOfActivities?: number
  guidance?: string
}
export interface GenerateReportsRequest {
  termId?: string
  classId?: string
  studentIds?: Array<GradebookGradingSetupRootComponentsInnerId>
  customiser?: string
  classContext?: string
  courseContext?: string
}
export interface GenerateSchemeUnitsRequest {
  subject?: string
  yearGroup?: string
  curriculum?: string
  numberOfUnits?: number
  topics?: string
  guidance?: string
}
export interface GenerateUnitLessonsRequest {
  subject?: string
  yearGroup?: string
  numberOfLessons?: number
  guidance?: string
}
export interface GetAcademicYearsResponse {
  years?: Array<GetAcademicYearsResponseYearsInner>
}
export interface GetAcademicYearsResponseYearsInner {
  id?: string
  tenantId?: string
  label?: string
  startsAt?: string
  endsAt?: string
}
export interface GetAssessmentCategoriesResponse {
  categories?: Array<GetAssessmentCategoriesResponseCategoriesInner>
}
export interface GetAssessmentCategoriesResponseCategoriesInner {
  id?: string
  name?: string
  colour?: GetAssessmentCategoriesResponseCategoriesInnerColourEnum
}

export const GetAssessmentCategoriesResponseCategoriesInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type GetAssessmentCategoriesResponseCategoriesInnerColourEnum =
  (typeof GetAssessmentCategoriesResponseCategoriesInnerColourEnum)[keyof typeof GetAssessmentCategoriesResponseCategoriesInnerColourEnum]

export interface GetAssessmentSetupResponse {
  scales?: Array<GetAssessmentSetupResponseScalesInner>
  assessmentCategories?: Array<GetAssessmentCategoriesResponseCategoriesInner>
}
export interface GetAssessmentSetupResponseScalesInner {
  id?: string
  name?: string
  levels?: Array<GetAssessmentSetupResponseScalesInnerLevelsInner>
}
export interface GetAssessmentSetupResponseScalesInnerLevelsInner {
  id?: string
  weight?: number
  text?: string
  iconId?: number
}
export interface GetAssessmentsResponse {
  assessments?: Array<GetAssessmentsResponseAssessmentsInner>
}
export interface GetAssessmentsResponseAssessmentsInner {
  id?: string
  name?: string
  category?: GetAssessmentCategoriesResponseCategoriesInner
  markingMethod?: object
  tenantId?: string
  academicYearId?: string
  createdBy?: string
}
export interface GetAssignmentDetailsResponse {
  assignment?: GetAssignmentDetailsResponseAssignment
}
export interface GetAssignmentDetailsResponseAssignment {
  assignment?: GetAssignmentsResponseAssignmentsInner
  classDetails?: GetAssignmentDetailsResponseAssignmentClassDetails
  students?: Array<GetAssignmentDetailsResponseAssignmentStudentsInner>
  scale?: GetAssessmentSetupResponseScalesInner
}
export interface GetAssignmentDetailsResponseAssignmentClassDetails {
  id?: string
  name?: string
  colour?: GetAssignmentDetailsResponseAssignmentClassDetailsColourEnum
  studentCount?: number
  createdBy?: string
}

export const GetAssignmentDetailsResponseAssignmentClassDetailsColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type GetAssignmentDetailsResponseAssignmentClassDetailsColourEnum =
  (typeof GetAssignmentDetailsResponseAssignmentClassDetailsColourEnum)[keyof typeof GetAssignmentDetailsResponseAssignmentClassDetailsColourEnum]

export interface GetAssignmentDetailsResponseAssignmentStudentsInner {
  student?: GetAssignmentDetailsResponseAssignmentStudentsInnerStudent
  grade?: GetAssignmentDetailsResponseAssignmentStudentsInnerGrade
}
export interface GetAssignmentDetailsResponseAssignmentStudentsInnerGrade {
  id?: string
  markedAt?: string
  markedBy?: string
  grade?: number
  marking?: object
}
export interface GetAssignmentDetailsResponseAssignmentStudentsInnerStudent {
  id?: string
  firstName?: string
  middleName?: string
  lastName?: string
  displayName?: string
  schoolId?: string
  gender?: string
  dob?: string
  nationality?: string
  mobile?: string
  email?: string
  photoUrl?: string
  relations?: Array<GetAssignmentDetailsResponseAssignmentStudentsInnerStudentRelationsInner>
  classes?: Array<GetAssignmentDetailsResponseAssignmentClassDetails>
}
export interface GetAssignmentDetailsResponseAssignmentStudentsInnerStudentRelationsInner {
  id?: string
  name?: string
  relationship?: string
  email?: string
  mobile?: string
}
export interface GetAssignmentSummariesResponse {
  summaries?: Array<GetAssignmentSummariesResponseSummariesInner>
}
export interface GetAssignmentSummariesResponseSummariesInner {
  assignment?: GetAssignmentsResponseAssignmentsInner
  submittedCount?: number
  totalCount?: number
  averagePercentage?: number
}
export interface GetAssignmentsResponse {
  assignments?: Array<GetAssignmentsResponseAssignmentsInner>
}
export interface GetAssignmentsResponseAssignmentsInner {
  id?: string
  assessmentId?: string
  assessmentName?: string
  weight?: number
  dateAssigned?: string
  dateDue?: string
  excludeFromFinalGrade?: boolean
  classId?: string
  markingMethod?: object
  category?: GetAssessmentCategoriesResponseCategoriesInner
}
export interface GetAttendanceResponse {
  attendance?: Array<GetAttendanceResponseAttendanceInner>
}
export interface GetAttendanceResponseAttendanceInner {
  studentId?: string
  lessonId?: string
  state?: string
  reasonId?: string
  note?: string
  createdBy?: string
  createdAt?: string
}
export interface GetClassRegisterResponse {
  register?: GetClassRegisterResponseRegister
}
export interface GetClassRegisterResponseRegister {
  classId?: string
  termId?: string
  lessons?: Array<GetLessonAttendanceResponseLessonAttendanceLesson>
  students?: Array<GetClassRegisterResponseRegisterStudentsInner>
}
export interface GetClassRegisterResponseRegisterStudentsInner {
  student?: GetAssignmentDetailsResponseAssignmentStudentsInnerStudent
  attendance?: Array<GetClassRegisterResponseRegisterStudentsInnerAttendanceInner>
  summary?: GetClassRegisterResponseRegisterStudentsInnerSummary
}
export interface GetClassRegisterResponseRegisterStudentsInnerAttendanceInner {
  studentId?: string
  lessonId?: string
  state?: string
  recordedBy?: string
  recordedAt?: string
}
export interface GetClassRegisterResponseRegisterStudentsInnerSummary {
  averagePresentPercent?: number
  breakdown?: { [key: string]: number }
}
export interface GetLessonAttendanceResponse {
  lessonAttendance?: GetLessonAttendanceResponseLessonAttendance
}
export interface GetLessonAttendanceResponseLessonAttendance {
  lesson?: GetLessonAttendanceResponseLessonAttendanceLesson
  students?: Array<GetLessonAttendanceResponseLessonAttendanceStudentsInner>
  reasons?: Array<GetLessonAttendanceResponseLessonAttendanceReasonsInner>
  recordedAt?: GetLessonAttendanceResponseLessonAttendanceRecordedAt
}
export interface GetLessonAttendanceResponseLessonAttendanceLesson {
  id?: string
  classDetails?: GetAssignmentDetailsResponseAssignmentClassDetails
  startTime?: string
  endTime?: string
  room?: string
  title?: string
  tag?: string
  createdBy?: string
}
export interface GetLessonAttendanceResponseLessonAttendanceReasonsInner {
  id?: string
  code?: string
  label?: string
  category?: string
  appliesToAbsent?: boolean
  appliesToLate?: boolean
  appliesToClear?: boolean
  sortOrder?: number
}
export interface GetLessonAttendanceResponseLessonAttendanceRecordedAt {
  epochSeconds?: number
  nanosecondsOfSecond?: number
  value?: GetLessonAttendanceResponseLessonAttendanceRecordedAtValue
}
export interface GetLessonAttendanceResponseLessonAttendanceRecordedAtValue {
  seconds?: number
  nanos?: number
}
export interface GetLessonAttendanceResponseLessonAttendanceStudentsInner {
  student?: GetAssignmentDetailsResponseAssignmentStudentsInnerStudent
  attendance?: GetLessonAttendanceResponseLessonAttendanceStudentsInnerAttendance
}
export interface GetLessonAttendanceResponseLessonAttendanceStudentsInnerAttendance {
  status?: string
  reasonId?: string
  note?: string
}
export interface GlobalSearchResponse {
  query?: string
  students?: Array<GlobalSearchResponseStudentsInner>
  classes?: Array<GlobalSearchResponseClassesInner>
  planningSchemes?: Array<GlobalSearchResponsePlanningSchemesInner>
  assignments?: Array<GlobalSearchResponseAssignmentsInner>
}
export interface GlobalSearchResponseAssignmentsInner {
  id?: string
  name?: string
  className?: string
  classId?: string
  dateDue?: string
}
export interface GlobalSearchResponseClassesInner {
  id?: string
  name?: string
  colour?: string
  studentCount?: number
}
export interface GlobalSearchResponsePlanningSchemesInner {
  id?: string
  name?: string
  description?: string
  courseName?: string
  colour?: string
  unitCount?: number
}
export interface GlobalSearchResponseStudentsInner {
  id?: string
  firstName?: string
  lastName?: string
  displayName?: string
  schoolId?: string
  photoUrl?: string
}
export interface GoogleLoginRequest {
  idToken?: string
}
export interface Gradebook {
  assignments?: Array<GetAssignmentsResponseAssignmentsInner>
  grades?: Array<GradebookGradesInner>
  students?: Array<GetAssignmentDetailsResponseAssignmentStudentsInnerStudent>
  gradingSetup?: GradebookGradingSetup
  studentGrades?: Array<GradebookStudentGradesInner>
  scales?: Array<GetAssessmentSetupResponseScalesInner>
}
export interface GradebookGradesInner {
  id?: string
  studentId?: string
  markedAt?: string
  markedBy?: string
  comments?: Array<GradebookGradesInnerCommentsInner>
  assignment?: GradebookGradesInnerAssignment
  marking?: object
  grade?: number
}
export interface GradebookGradesInnerAssignment {
  id?: string
  assessmentId?: string
  assessmentName?: string
  weight?: number
  dateAssigned?: string
  dateDue?: string
  excludeFromFinalGrade?: boolean
  classId?: string
  category?: GetAssessmentCategoriesResponseCategoriesInner
}
export interface GradebookGradesInnerCommentsInner {
  body?: string
  authorId?: string
  authorRole?: string
  createdAt?: string
}
export interface GradebookGradingSetup {
  id?: string
  rootComponents?: Array<GradebookGradingSetupRootComponentsInner>
}
export interface GradebookGradingSetupRootComponentsInner {
  id?: GradebookGradingSetupRootComponentsInnerId
  weight?: number
}
export interface GradebookGradingSetupRootComponentsInnerId {
  mostSigBits?: number
  leastSigBits?: number
}
export interface GradebookStudentGradesInner {
  studentId?: string
  finalGrade?: GradebookStudentGradesInnerFinalGrade
  categoryGrades?: Array<GradebookStudentGradesInnerCategoryGradesInner>
}
export interface GradebookStudentGradesInnerCategoryGradesInner {
  category?: GetAssessmentCategoriesResponseCategoriesInner
  percentage?: number
  letter?: string
}
export interface GradebookStudentGradesInnerFinalGrade {
  studentId?: string
  percentage?: number
  letter?: string
}
export interface Group {
  id?: string
  name?: string
  colour?: GroupColourEnum
  createdBy?: string
}

export const GroupColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type GroupColourEnum = (typeof GroupColourEnum)[keyof typeof GroupColourEnum]

export interface HealthReadyResponse {
  status?: string
  environment?: string
  timestamp?: number
}
export interface ImportResult {
  importedCount?: number
  existingAddedCount?: number
  skippedCount?: number
  errors?: Array<ImportResultErrorsInner>
}
export interface ImportResultErrorsInner {
  rowNumber?: number
  message?: string
}
export interface InfoResponse {
  build?: InfoResponseBuild
  deploy?: InfoResponseDeploy
  runtime?: InfoResponseRuntime
}
export interface InfoResponseBuild {
  version?: string
  commit?: string
}
export interface InfoResponseDeploy {
  service?: string
  revision?: string
  configuration?: string
}
export interface InfoResponseRuntime {
  startTime?: string
  uptime?: string
  environment?: string
}
export interface Lesson {
  id?: string
  classDetails?: GetAssignmentDetailsResponseAssignmentClassDetails
  startTime?: string
  endTime?: string
  room?: string
  title?: string
  tag?: string
  createdBy?: string
}
export interface LessonActivity {
  id?: string
  lessonPlanId?: string
  title?: string
  description?: string
  phase?: LessonActivityPhaseEnum
  duration?: number
  position?: number
}

export const LessonActivityPhaseEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type LessonActivityPhaseEnum =
  (typeof LessonActivityPhaseEnum)[keyof typeof LessonActivityPhaseEnum]

export interface LessonObjective {
  id?: string
  objective?: string
  position?: number
}
export interface LessonPlan {
  id?: string
  unitId?: string
  unitTitle?: string
  schemeId?: string
  schemeTitle?: string
  title?: string
  overview?: string
  position?: number
  estimatedDuration?: number
  objectives?: Array<PlanningSchemeObjectivesInner>
  activities?: Array<LessonPlanActivitiesInner>
}
export interface LessonPlanActivitiesInner {
  id?: string
  lessonPlanId?: string
  title?: string
  description?: string
  phase?: string
  duration?: number
  position?: number
}
export interface LessonPlanOverview {
  id?: string
  unitId?: string
  title?: string
  overview?: string
  position?: number
  estimatedDuration?: number
  activityCount?: number
  objectiveCount?: number
}
export interface LoginRequest {
  email?: string
  password?: string
}
export interface LogoutRequest {
  refreshToken?: string
}
export interface MigrationRequest {
  assessmentCategories?: Array<MigrationRequestAssessmentCategoriesInner>
  classes?: Array<MigrationRequestClassesInner>
  students?: Array<MigrationRequestStudentsInner>
  assessments?: Array<MigrationRequestAssessmentsInner>
  scales?: Array<MigrationRequestScalesInner>
  assignments?: Array<MigrationRequestAssignmentsInner>
  relations?: Array<MigrationRequestRelationsInner>
  terms?: Array<MigrationRequestTermsInner>
}
export interface MigrationRequestAssessmentCategoriesInner {
  localId?: number
  name?: string
  colour?: MigrationRequestAssessmentCategoriesInnerColourEnum
}

export const MigrationRequestAssessmentCategoriesInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type MigrationRequestAssessmentCategoriesInnerColourEnum =
  (typeof MigrationRequestAssessmentCategoriesInnerColourEnum)[keyof typeof MigrationRequestAssessmentCategoriesInnerColourEnum]

export interface MigrationRequestAssessmentsInner {
  localId?: number
  name?: string
  categoryLocalId?: number
  markingMethodType?: string
  maxPoints?: number
  scaleLocalId?: number
  rubricLocalId?: number
}
export interface MigrationRequestAssignmentsInner {
  assessmentLocalId?: number
  classLocalId?: number
  weight?: number
  dateAssigned?: string
  dateDue?: string
  excludeFromFinalGrade?: boolean
  colour?: MigrationRequestAssignmentsInnerColourEnum
  submissions?: Array<MigrationRequestAssignmentsInnerSubmissionsInner>
}

export const MigrationRequestAssignmentsInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type MigrationRequestAssignmentsInnerColourEnum =
  (typeof MigrationRequestAssignmentsInnerColourEnum)[keyof typeof MigrationRequestAssignmentsInnerColourEnum]

export interface MigrationRequestAssignmentsInnerSubmissionsInner {
  studentLocalId?: number
  marking?: object
  comment?: string
}
export interface MigrationRequestClassesInner {
  localId?: number
  name?: string
  colour?: MigrationRequestClassesInnerColourEnum
  lessons?: Array<MigrationRequestClassesInnerLessonsInner>
  notes?: Array<MigrationRequestClassesInnerNotesInner>
  gradingSetup?: MigrationRequestClassesInnerGradingSetup
}

export const MigrationRequestClassesInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type MigrationRequestClassesInnerColourEnum =
  (typeof MigrationRequestClassesInnerColourEnum)[keyof typeof MigrationRequestClassesInnerColourEnum]

export interface MigrationRequestClassesInnerGradingSetup {
  isByCategory?: boolean
  categories?: Array<MigrationRequestClassesInnerGradingSetupCategoriesInner>
}
export interface MigrationRequestClassesInnerGradingSetupCategoriesInner {
  categoryLocalId?: number
  weight?: number
}
export interface MigrationRequestClassesInnerLessonsInner {
  localId?: number
  date?: string
  tag?: string
}
export interface MigrationRequestClassesInnerNotesInner {
  title?: string
  text?: string
  date?: string
}
export interface MigrationRequestRelationsInner {
  localId?: number
  name?: string
  relationship?: string
  email?: string
  mobile?: string
}
export interface MigrationRequestScalesInner {
  localId?: number
  name?: string
  levels?: Array<MigrationRequestScalesInnerLevelsInner>
}
export interface MigrationRequestScalesInnerLevelsInner {
  localId?: number
  name?: string
  grade?: string
  colour?: MigrationRequestScalesInnerLevelsInnerColourEnum
  weight?: number
}

export const MigrationRequestScalesInnerLevelsInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type MigrationRequestScalesInnerLevelsInnerColourEnum =
  (typeof MigrationRequestScalesInnerLevelsInnerColourEnum)[keyof typeof MigrationRequestScalesInnerLevelsInnerColourEnum]

export interface MigrationRequestStudentsInner {
  localId?: number
  data?: CreateStudentsBatchRequestStudentsInner
  classIds?: Array<number>
  attendance?: Array<MigrationRequestStudentsInnerAttendanceInner>
  notes?: Array<MigrationRequestClassesInnerNotesInner>
  relationIds?: Array<number>
}
export interface MigrationRequestStudentsInnerAttendanceInner {
  lessonLocalId?: number
  state?: string
}
export interface MigrationRequestTermsInner {
  localId?: number
  name?: string
  startDate?: MigrationRequestTermsInnerStartDate
  endDate?: MigrationRequestTermsInnerStartDate
}
export interface MigrationRequestTermsInnerStartDate {
  dayOfMonth?: number
  dayOfWeek?: string
  dayOfYear?: number
  month?: string
  monthNumber?: number
  value?: MigrationRequestTermsInnerStartDateValue
  year?: number
}
export interface MigrationRequestTermsInnerStartDateValue {
  year?: number
  month?: number
  day?: number
}
export interface MigrationResponse {
  success?: boolean
  message?: string
  stats?: MigrationResponseStats
}
export interface MigrationResponseStats {
  studentsCreated?: number
  classesCreated?: number
  lessonsCreated?: number
  assessmentsCreated?: number
  assignmentsCreated?: number
  submissionsCreated?: number
  relationsCreated?: number
  termsCreated?: number
}
export interface Note {
  id?: string
  title?: string
  text?: string
  date?: string
}
export interface ParseFileResponse {
  parseId?: string
  fileName?: string
  fileType?: ParseFileResponseFileTypeEnum
  headers?: Array<string>
  rowCount?: number
  previewRows?: Array<{ [key: string]: string }>
  suggestedMappings?: { [key: string]: ParseFileResponseSuggestedMappingsValue }
  warnings?: Array<string>
}

export const ParseFileResponseFileTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type ParseFileResponseFileTypeEnum =
  (typeof ParseFileResponseFileTypeEnum)[keyof typeof ParseFileResponseFileTypeEnum]

export interface ParseFileResponseSuggestedMappingsValue {
  displayName?: string
  name?: string
  ordinal?: number
}
export interface PermissionOverridesResponse {
  overrides?: Array<PermissionOverridesResponseOverridesInner>
}
export interface PermissionOverridesResponseOverridesInner {
  role?: string
  permission?: string
  granted?: boolean
}
export interface PlanningScheme {
  id?: string
  name?: string
  description?: string
  courseId?: string
  courseName?: string
  colour?: PlanningSchemeColourEnum
  iconId?: string
  objectives?: Array<PlanningSchemeObjectivesInner>
  topics?: Array<PlanningSchemeTopicsInner>
  units?: Array<PlanningSchemeUnitsInner>
}

export const PlanningSchemeColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type PlanningSchemeColourEnum =
  (typeof PlanningSchemeColourEnum)[keyof typeof PlanningSchemeColourEnum]

export interface PlanningSchemeObjectivesInner {
  id?: string
  objective?: string
  position?: number
}
export interface PlanningSchemeOverview {
  id?: string
  name?: string
  description?: string
  courseId?: string
  courseName?: string
  colour?: PlanningSchemeOverviewColourEnum
  iconId?: string
  unitCount?: number
  lessonPlanCount?: number
}

export const PlanningSchemeOverviewColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type PlanningSchemeOverviewColourEnum =
  (typeof PlanningSchemeOverviewColourEnum)[keyof typeof PlanningSchemeOverviewColourEnum]

export interface PlanningSchemeTopicsInner {
  id?: string
  topic?: string
  position?: number
}
export interface PlanningSchemeUnitsInner {
  id?: string
  schemeId?: string
  title?: string
  aim?: string
  position?: number
  objectives?: Array<PlanningSchemeObjectivesInner>
  lessonPlans?: Array<PlanningSchemeUnitsInnerLessonPlansInner>
}
export interface PlanningSchemeUnitsInnerLessonPlansInner {
  id?: string
  unitId?: string
  title?: string
  overview?: string
  position?: number
  estimatedDuration?: number
  activityCount?: number
  objectiveCount?: number
}
export interface PlanningUnit {
  id?: string
  schemeId?: string
  title?: string
  aim?: string
  position?: number
  objectives?: Array<PlanningSchemeObjectivesInner>
  lessonPlans?: Array<PlanningSchemeUnitsInnerLessonPlansInner>
}
export interface RecordAttendanceRequest {
  entries?: Array<RecordAttendanceRequestEntriesInner>
}
export interface RecordAttendanceRequestEntriesInner {
  studentId?: string
  state?: string
}
export interface RefreshTokenRequest {
  refreshToken?: string
}
export interface RegisterRequest {
  email?: string
  password?: string
  role?: RegisterRequestRoleEnum
}

export const RegisterRequestRoleEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type RegisterRequestRoleEnum =
  (typeof RegisterRequestRoleEnum)[keyof typeof RegisterRequestRoleEnum]

export interface Relation {
  id?: string
  name?: string
  relationship?: string
  email?: string
  mobile?: string
}
export interface RemovedCountResponse {
  removed?: number
}
export interface ReportsResponse {
  summary?: ReportsResponseSummary
  reports?: Array<ReportsResponseReportsInner>
}
export interface ReportsResponseReportsInner {
  id?: string
  termId?: string
  classId?: string
  studentId?: string
  createdAt?: string
  sections?: Array<ReportsResponseReportsInnerSectionsInner>
}
export interface ReportsResponseReportsInnerSectionsInner {
  id?: string
  position?: number
  title?: string
  comment?: string
}
export interface ReportsResponseSummary {
  summary?: ReportsResponseSummarySummary
  students?: Array<ReportsResponseSummaryStudentsInner>
}
export interface ReportsResponseSummaryStudentsInner {
  student?: GetAssignmentDetailsResponseAssignmentStudentsInnerStudent
  report?: ReportsResponseSummaryStudentsInnerReport
  finalGradePercentage?: number
  finalGradeLetter?: string
}
export interface ReportsResponseSummaryStudentsInnerReport {
  id?: string
  termId?: string
  classId?: string
  studentId?: string
  title?: string
  comment?: string
  position?: number
}
export interface ReportsResponseSummarySummary {
  classId?: string
  className?: string
  term?: ReportsResponseSummarySummaryTerm
  totalStudents?: number
  submittedReports?: number
}
export interface ReportsResponseSummarySummaryTerm {
  id?: string
  name?: string
  start?: string
  end?: string
}
export interface ResetPasswordRequest {
  token?: string
  newPassword?: string
}
export interface RoleDefaultsResponse {
  roleDefaults?: { [key: string]: Array<string> }
}
export interface Scale {
  id?: string
  name?: string
  levels?: Array<GetAssessmentSetupResponseScalesInnerLevelsInner>
}
export interface ScaleInUseError {
  error?: string
  message?: string
  assessmentCount?: number
}
export interface ScaleUsageResponse {
  assessmentCount?: number
}
export interface ScheduleResponse {
  items?: Array<ScheduleResponseItemsInner>
  lessonCount?: number
  assignmentCount?: number
}
export interface ScheduleResponseItemsInner {
  id?: string
  type?: string
  title?: string
  dateTime?: string
  endDateTime?: string
  classId?: string
  className?: string
  classColour?: ScheduleResponseItemsInnerClassColourEnum
  room?: string
  dateDue?: string
}

export const ScheduleResponseItemsInnerClassColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type ScheduleResponseItemsInnerClassColourEnum =
  (typeof ScheduleResponseItemsInnerClassColourEnum)[keyof typeof ScheduleResponseItemsInnerClassColourEnum]

export interface SchemeObjective {
  id?: string
  objective?: string
  position?: number
}
export interface SchemeTopic {
  id?: string
  topic?: string
  position?: number
}
export interface SetPermissionOverrideRequest {
  role?: string
  permission?: string
  granted?: boolean
}
export interface Student {
  id?: string
  firstName?: string
  middleName?: string
  lastName?: string
  displayName?: string
  schoolId?: string
  gender?: string
  dob?: string
  nationality?: string
  mobile?: string
  email?: string
  photoUrl?: string
  relations?: Array<GetAssignmentDetailsResponseAssignmentStudentsInnerStudentRelationsInner>
  classes?: Array<GetAssignmentDetailsResponseAssignmentClassDetails>
}
export interface StudentAcademicOverviewResponse {
  overallAttendancePercentage?: number
  totalAttendanceRecords?: number
  enrolledAt?: string
  classes?: Array<StudentAcademicOverviewResponseClassesInner>
}
export interface StudentAcademicOverviewResponseClassesInner {
  classId?: string
  className?: string
  attendancePercentage?: number
  attendanceRecords?: number
  finalGrade?: string
}
export interface StudentRelation {
  studentId?: string
  relationId?: string
  relationshipType?: StudentRelationRelationshipTypeEnum
  relationName?: string
  relationEmail?: string
  relationMobile?: string
}

export const StudentRelationRelationshipTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type StudentRelationRelationshipTypeEnum =
  (typeof StudentRelationRelationshipTypeEnum)[keyof typeof StudentRelationRelationshipTypeEnum]

export interface StudentReportCard {
  student?: GetAssignmentDetailsResponseAssignmentStudentsInnerStudent
  classDetails?: GetAssignmentDetailsResponseAssignmentClassDetails
  term?: ReportsResponseSummarySummaryTerm
  report?: ReportsResponseReportsInnerSectionsInner
  reportId?: string
  finalGrade?: GradebookStudentGradesInnerFinalGrade
  categoryGrades?: Array<GradebookStudentGradesInnerCategoryGradesInner>
  attendance?: StudentReportCardAttendance
}
export interface StudentReportCardAttendance {
  presentPercentage?: number
  totalLessons?: number
  presentCount?: number
  absentCount?: number
  lateCount?: number
}
export interface StudentReportContextResponse {
  student?: GetAssignmentDetailsResponseAssignmentStudentsInnerStudent
  classDetails?: GetAssignmentDetailsResponseAssignmentClassDetails
  terms?: Array<ReportsResponseSummarySummaryTerm>
  selectedTerm?: ReportsResponseSummarySummaryTerm
  report?: ReportsResponseReportsInner
}
export interface SubmissionResponse {
  id?: string
  assignmentId?: string
  studentId?: string
  fileName?: string
  contentType?: string
  fileSize?: number
  viewUrl?: string
  downloadUrl?: string
  submittedAt?: string
  submittedBy?: string
  notes?: string
}
export interface SubscriptionStatusResponse {
  isPremium?: boolean
  subscription?: SubscriptionStatusResponseSubscription
}
export interface SubscriptionStatusResponseSubscription {
  productId?: string
  source?: string
  active?: boolean
  expiresAt?: string
  autoRenewing?: boolean
  cancelReason?: string
}
export interface SuccessResponse {
  success?: boolean
  message?: string
}
export interface Teacher {
  id?: string
  firstName?: string
  lastName?: string
  displayName?: string
  email?: string
  mobile?: string
  photoUrl?: string
  userId?: string
  isRegistered?: boolean
  classes?: Array<TeacherClassesInner>
}
export interface TeacherClassesInner {
  classId?: string
  className?: string
  colour?: TeacherClassesInnerColourEnum
  subject?: string
  isPrimary?: boolean
}

export const TeacherClassesInnerColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type TeacherClassesInnerColourEnum =
  (typeof TeacherClassesInnerColourEnum)[keyof typeof TeacherClassesInnerColourEnum]

export interface TeacherInvite {
  id?: string
  teacherId?: string
  email?: string
  token?: string
  expiresAt?: string
  acceptedAt?: string
  invitedBy?: string
  createdAt?: string
}
export interface TeacherInviteDetails {
  teacherId?: string
  teacherName?: string
  tenantName?: string
  email?: string
  isExpired?: boolean
  isAccepted?: boolean
}
export interface TeacherInviteResponse {
  id?: string
  teacherId?: string
  email?: string
  expiresAt?: string
  createdAt?: string
}
export interface TeacherSummary {
  id?: string
  displayName?: string
  email?: string
  isRegistered?: boolean
}
export interface Tenant {
  id?: string
  name?: string
  type?: TenantTypeEnum
  createdBy?: string
  createdAt?: string
}

export const TenantTypeEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type TenantTypeEnum = (typeof TenantTypeEnum)[keyof typeof TenantTypeEnum]

export interface TenantSettings {
  settings?: { [key: string]: string }
}
export interface Term {
  id?: string
  name?: string
  start?: string
  end?: string
}
export interface TokenSet {
  accessToken?: string
  refreshToken?: string
  accessTokenExpiresIn?: number
}
export interface UnitObjective {
  id?: string
  objective?: string
  position?: number
}
export interface UpcomingBirthdaysResponse {
  students?: Array<GetAssignmentDetailsResponseAssignmentStudentsInnerStudent>
}
export interface UpdateAcademicYearRequest {
  label?: string
  startsAt?: string
  endsAt?: string
}
export interface UpdateActivityRequest {
  title?: string
  description?: string
  phase?: UpdateActivityRequestPhaseEnum
  duration?: number
  position?: number
}

export const UpdateActivityRequestPhaseEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type UpdateActivityRequestPhaseEnum =
  (typeof UpdateActivityRequestPhaseEnum)[keyof typeof UpdateActivityRequestPhaseEnum]

export interface UpdateAssessmentCategoryRequest {
  name?: string
  colour?: UpdateAssessmentCategoryRequestColourEnum
}

export const UpdateAssessmentCategoryRequestColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type UpdateAssessmentCategoryRequestColourEnum =
  (typeof UpdateAssessmentCategoryRequestColourEnum)[keyof typeof UpdateAssessmentCategoryRequestColourEnum]

export interface UpdateAssessmentRequest {
  name?: string
  categoryId?: string
}
export interface UpdateGroupRequest {
  name?: string
  colour?: UpdateGroupRequestColourEnum
}

export const UpdateGroupRequestColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type UpdateGroupRequestColourEnum =
  (typeof UpdateGroupRequestColourEnum)[keyof typeof UpdateGroupRequestColourEnum]

export interface UpdateLessonPlanRequest {
  title?: string
  overview?: string
  position?: number
  estimatedDuration?: number
}
export interface UpdateLessonRequest {
  startTime?: string
  endTime?: string
  room?: string
  title?: string
  tag?: string
}
export interface UpdateNoteRequest {
  title?: string
  text?: string
  date?: string
}
export interface UpdateReportCommentRequest {
  comment?: string
}
export interface UpdateScaleRequest {
  name?: string
  levels?: Array<CreateScaleRequestLevelsInner>
}
export interface UpdateSchemeRequest {
  name?: string
  description?: string
  courseId?: string
  colour?: UpdateSchemeRequestColourEnum
  iconId?: string
}

export const UpdateSchemeRequestColourEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type UpdateSchemeRequestColourEnum =
  (typeof UpdateSchemeRequestColourEnum)[keyof typeof UpdateSchemeRequestColourEnum]

export interface UpdateSettingRequest {
  value?: string
}
export interface UpdateSettingsRequest {
  settings?: { [key: string]: string }
}
export interface UpdateStudentRequest {
  firstName?: string
  middleName?: string
  lastName?: string
  gender?: string
  dob?: string
  schoolId?: string
  nationality?: string
  mobile?: string
  email?: string
}
export interface UpdateTeacherRequest {
  firstName?: string
  lastName?: string
  email?: string
  mobile?: string
}
export interface UpdateTenantRequest {
  name?: string
}
export interface UpdateTermRequest {
  name?: string
  start?: string
  end?: string
}
export interface UpdateUnitRequest {
  title?: string
  aim?: string
  position?: number
}
export interface UpdateUserRequest {
  name?: string
}
export interface UpsertGradeRequest {
  assignmentId?: string
  studentId?: string
  numericPoints?: number
  scaleLevelId?: string
  markedAt?: string
  submittedAt?: string
  comment?: string
}
export interface User {
  id?: string
  tenantId?: string
  email?: string
  name?: string
  photoUrl?: string
  role?: UserRoleEnum
  createdAt?: string
  isPremium?: boolean
  authProvider?: UserAuthProviderEnum
  emailVerified?: boolean
}

export const UserRoleEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type UserRoleEnum = (typeof UserRoleEnum)[keyof typeof UserRoleEnum]
export const UserAuthProviderEnum = {
  Red: 'RED',
  Blue: 'BLUE',
  Indigo: 'INDIGO',
  Green: 'GREEN',
  Lime: 'LIME',
  Purple: 'PURPLE',
  Orange: 'ORANGE',
  Yellow: 'YELLOW',
  Pink: 'PINK',
  Teal: 'TEAL',
  Brown: 'BROWN',
  Grey: 'GREY',
} as const

export type UserAuthProviderEnum = (typeof UserAuthProviderEnum)[keyof typeof UserAuthProviderEnum]

export interface VerifySubscriptionRequest {
  purchaseToken?: string
  productId?: string
  source?: string
  isSubscription?: boolean
}

/**
 * AcademicYearsApi - axios parameter creator
 */
export const AcademicYearsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete an academic year by ID. - 204 No Content if deleted - 404 Not Found if not found
     * @param {string} academicYearId path The ID of the academic year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsAcademicYearIdDelete: async (
      academicYearId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'academicYearId' is not null or undefined
      assertParamExists('academicYearsAcademicYearIdDelete', 'academicYearId', academicYearId)
      const localVarPath = `/academic-years/{academicYearId}`.replace(
        `{${'academicYearId'}}`,
        encodeURIComponent(String(academicYearId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update an existing academic year by ID. - 200 OK if updated - 404 Not Found if not found
     * @param {string} academicYearId path The ID of the academic year.
     * @param {UpdateAcademicYearRequest} [updateAcademicYearRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsAcademicYearIdPut: async (
      academicYearId: string,
      updateAcademicYearRequest?: UpdateAcademicYearRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'academicYearId' is not null or undefined
      assertParamExists('academicYearsAcademicYearIdPut', 'academicYearId', academicYearId)
      const localVarPath = `/academic-years/{academicYearId}`.replace(
        `{${'academicYearId'}}`,
        encodeURIComponent(String(academicYearId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateAcademicYearRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all academic years for current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/academic-years`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new academic year for the current tenant.
     * @param {CreateAcademicYearRequest} [createAcademicYearRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsPost: async (
      createAcademicYearRequest?: CreateAcademicYearRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/academic-years`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAcademicYearRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AcademicYearsApi - functional programming interface
 */
export const AcademicYearsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AcademicYearsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete an academic year by ID. - 204 No Content if deleted - 404 Not Found if not found
     * @param {string} academicYearId path The ID of the academic year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async academicYearsAcademicYearIdDelete(
      academicYearId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.academicYearsAcademicYearIdDelete(
        academicYearId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AcademicYearsApi.academicYearsAcademicYearIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update an existing academic year by ID. - 200 OK if updated - 404 Not Found if not found
     * @param {string} academicYearId path The ID of the academic year.
     * @param {UpdateAcademicYearRequest} [updateAcademicYearRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async academicYearsAcademicYearIdPut(
      academicYearId: string,
      updateAcademicYearRequest?: UpdateAcademicYearRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.academicYearsAcademicYearIdPut(
        academicYearId,
        updateAcademicYearRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AcademicYearsApi.academicYearsAcademicYearIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all academic years for current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async academicYearsGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAcademicYearsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.academicYearsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AcademicYearsApi.academicYearsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new academic year for the current tenant.
     * @param {CreateAcademicYearRequest} [createAcademicYearRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async academicYearsPost(
      createAcademicYearRequest?: CreateAcademicYearRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.academicYearsPost(
        createAcademicYearRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AcademicYearsApi.academicYearsPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AcademicYearsApi - factory interface
 */
export const AcademicYearsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AcademicYearsApiFp(configuration)
  return {
    /**
     *
     * @summary Delete an academic year by ID. - 204 No Content if deleted - 404 Not Found if not found
     * @param {string} academicYearId path The ID of the academic year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsAcademicYearIdDelete(
      academicYearId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .academicYearsAcademicYearIdDelete(academicYearId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update an existing academic year by ID. - 200 OK if updated - 404 Not Found if not found
     * @param {string} academicYearId path The ID of the academic year.
     * @param {UpdateAcademicYearRequest} [updateAcademicYearRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsAcademicYearIdPut(
      academicYearId: string,
      updateAcademicYearRequest?: UpdateAcademicYearRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .academicYearsAcademicYearIdPut(academicYearId, updateAcademicYearRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all academic years for current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsGet(options?: RawAxiosRequestConfig): AxiosPromise<GetAcademicYearsResponse> {
      return localVarFp.academicYearsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new academic year for the current tenant.
     * @param {CreateAcademicYearRequest} [createAcademicYearRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    academicYearsPost(
      createAcademicYearRequest?: CreateAcademicYearRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .academicYearsPost(createAcademicYearRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AcademicYearsApi - object-oriented interface
 */
export class AcademicYearsApi extends BaseAPI {
  /**
   *
   * @summary Delete an academic year by ID. - 204 No Content if deleted - 404 Not Found if not found
   * @param {string} academicYearId path The ID of the academic year.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public academicYearsAcademicYearIdDelete(
    academicYearId: string,
    options?: RawAxiosRequestConfig
  ) {
    return AcademicYearsApiFp(this.configuration)
      .academicYearsAcademicYearIdDelete(academicYearId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update an existing academic year by ID. - 200 OK if updated - 404 Not Found if not found
   * @param {string} academicYearId path The ID of the academic year.
   * @param {UpdateAcademicYearRequest} [updateAcademicYearRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public academicYearsAcademicYearIdPut(
    academicYearId: string,
    updateAcademicYearRequest?: UpdateAcademicYearRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AcademicYearsApiFp(this.configuration)
      .academicYearsAcademicYearIdPut(academicYearId, updateAcademicYearRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all academic years for current tenant.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public academicYearsGet(options?: RawAxiosRequestConfig) {
    return AcademicYearsApiFp(this.configuration)
      .academicYearsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new academic year for the current tenant.
   * @param {CreateAcademicYearRequest} [createAcademicYearRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public academicYearsPost(
    createAcademicYearRequest?: CreateAcademicYearRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AcademicYearsApiFp(this.configuration)
      .academicYearsPost(createAcademicYearRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AdministrationApi - axios parameter creator
 */
export const AdministrationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Migrate legacy SmartTeacher data to the BrightClass server. This is an \"all-or-nothing\" transactional migration. Either all data is successfully migrated, or none of it is (rolled back on failure).
     * @param {MigrationRequest} [migrationRequest] Complete migration payload containing all legacy data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrationPost: async (
      migrationRequest?: MigrationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/migration`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        migrationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AdministrationApi - functional programming interface
 */
export const AdministrationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AdministrationApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Migrate legacy SmartTeacher data to the BrightClass server. This is an \"all-or-nothing\" transactional migration. Either all data is successfully migrated, or none of it is (rolled back on failure).
     * @param {MigrationRequest} [migrationRequest] Complete migration payload containing all legacy data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async migrationPost(
      migrationRequest?: MigrationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MigrationResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.migrationPost(
        migrationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AdministrationApi.migrationPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AdministrationApi - factory interface
 */
export const AdministrationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AdministrationApiFp(configuration)
  return {
    /**
     *
     * @summary Migrate legacy SmartTeacher data to the BrightClass server. This is an \"all-or-nothing\" transactional migration. Either all data is successfully migrated, or none of it is (rolled back on failure).
     * @param {MigrationRequest} [migrationRequest] Complete migration payload containing all legacy data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrationPost(
      migrationRequest?: MigrationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<MigrationResponse> {
      return localVarFp
        .migrationPost(migrationRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AdministrationApi - object-oriented interface
 */
export class AdministrationApi extends BaseAPI {
  /**
   *
   * @summary Migrate legacy SmartTeacher data to the BrightClass server. This is an \"all-or-nothing\" transactional migration. Either all data is successfully migrated, or none of it is (rolled back on failure).
   * @param {MigrationRequest} [migrationRequest] Complete migration payload containing all legacy data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public migrationPost(migrationRequest?: MigrationRequest, options?: RawAxiosRequestConfig) {
    return AdministrationApiFp(this.configuration)
      .migrationPost(migrationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AssessmentCategoriesApi - axios parameter creator
 */
export const AssessmentCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete an assessment category by ID.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesAssessmentCategoryIdDelete: async (
      assessmentCategoryId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assessmentCategoryId' is not null or undefined
      assertParamExists(
        'assessmentCategoriesAssessmentCategoryIdDelete',
        'assessmentCategoryId',
        assessmentCategoryId
      )
      const localVarPath = `/assessment-categories/{assessmentCategoryId}`.replace(
        `{${'assessmentCategoryId'}}`,
        encodeURIComponent(String(assessmentCategoryId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a specific assessment category by ID.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesAssessmentCategoryIdGet: async (
      assessmentCategoryId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assessmentCategoryId' is not null or undefined
      assertParamExists(
        'assessmentCategoriesAssessmentCategoryIdGet',
        'assessmentCategoryId',
        assessmentCategoryId
      )
      const localVarPath = `/assessment-categories/{assessmentCategoryId}`.replace(
        `{${'assessmentCategoryId'}}`,
        encodeURIComponent(String(assessmentCategoryId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update an assessment category.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {UpdateAssessmentCategoryRequest} [updateAssessmentCategoryRequest] The category update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesAssessmentCategoryIdPut: async (
      assessmentCategoryId: string,
      updateAssessmentCategoryRequest?: UpdateAssessmentCategoryRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assessmentCategoryId' is not null or undefined
      assertParamExists(
        'assessmentCategoriesAssessmentCategoryIdPut',
        'assessmentCategoryId',
        assessmentCategoryId
      )
      const localVarPath = `/assessment-categories/{assessmentCategoryId}`.replace(
        `{${'assessmentCategoryId'}}`,
        encodeURIComponent(String(assessmentCategoryId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateAssessmentCategoryRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all assessment categories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/assessment-categories`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new assessment category.
     * @param {CreateAssessmentCategoryRequest} [createAssessmentCategoryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesPost: async (
      createAssessmentCategoryRequest?: CreateAssessmentCategoryRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/assessment-categories`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAssessmentCategoryRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AssessmentCategoriesApi - functional programming interface
 */
export const AssessmentCategoriesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssessmentCategoriesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete an assessment category by ID.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentCategoriesAssessmentCategoryIdDelete(
      assessmentCategoryId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assessmentCategoriesAssessmentCategoryIdDelete(
          assessmentCategoryId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'AssessmentCategoriesApi.assessmentCategoriesAssessmentCategoryIdDelete'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a specific assessment category by ID.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentCategoriesAssessmentCategoryIdGet(
      assessmentCategoryId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentCategory>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assessmentCategoriesAssessmentCategoryIdGet(
          assessmentCategoryId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentCategoriesApi.assessmentCategoriesAssessmentCategoryIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update an assessment category.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {UpdateAssessmentCategoryRequest} [updateAssessmentCategoryRequest] The category update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentCategoriesAssessmentCategoryIdPut(
      assessmentCategoryId: string,
      updateAssessmentCategoryRequest?: UpdateAssessmentCategoryRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentCategory>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assessmentCategoriesAssessmentCategoryIdPut(
          assessmentCategoryId,
          updateAssessmentCategoryRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentCategoriesApi.assessmentCategoriesAssessmentCategoryIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all assessment categories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentCategoriesGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssessmentCategoriesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentCategoriesGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentCategoriesApi.assessmentCategoriesGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new assessment category.
     * @param {CreateAssessmentCategoryRequest} [createAssessmentCategoryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentCategoriesPost(
      createAssessmentCategoryRequest?: CreateAssessmentCategoryRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentCategoriesPost(
        createAssessmentCategoryRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentCategoriesApi.assessmentCategoriesPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AssessmentCategoriesApi - factory interface
 */
export const AssessmentCategoriesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssessmentCategoriesApiFp(configuration)
  return {
    /**
     *
     * @summary Delete an assessment category by ID.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesAssessmentCategoryIdDelete(
      assessmentCategoryId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assessmentCategoriesAssessmentCategoryIdDelete(assessmentCategoryId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a specific assessment category by ID.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesAssessmentCategoryIdGet(
      assessmentCategoryId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssessmentCategory> {
      return localVarFp
        .assessmentCategoriesAssessmentCategoryIdGet(assessmentCategoryId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update an assessment category.
     * @param {string} assessmentCategoryId path The ID of the assessment category.
     * @param {UpdateAssessmentCategoryRequest} [updateAssessmentCategoryRequest] The category update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesAssessmentCategoryIdPut(
      assessmentCategoryId: string,
      updateAssessmentCategoryRequest?: UpdateAssessmentCategoryRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssessmentCategory> {
      return localVarFp
        .assessmentCategoriesAssessmentCategoryIdPut(
          assessmentCategoryId,
          updateAssessmentCategoryRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all assessment categories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesGet(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetAssessmentCategoriesResponse> {
      return localVarFp.assessmentCategoriesGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new assessment category.
     * @param {CreateAssessmentCategoryRequest} [createAssessmentCategoryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentCategoriesPost(
      createAssessmentCategoryRequest?: CreateAssessmentCategoryRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assessmentCategoriesPost(createAssessmentCategoryRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AssessmentCategoriesApi - object-oriented interface
 */
export class AssessmentCategoriesApi extends BaseAPI {
  /**
   *
   * @summary Delete an assessment category by ID.
   * @param {string} assessmentCategoryId path The ID of the assessment category.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentCategoriesAssessmentCategoryIdDelete(
    assessmentCategoryId: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssessmentCategoriesApiFp(this.configuration)
      .assessmentCategoriesAssessmentCategoryIdDelete(assessmentCategoryId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a specific assessment category by ID.
   * @param {string} assessmentCategoryId path The ID of the assessment category.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentCategoriesAssessmentCategoryIdGet(
    assessmentCategoryId: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssessmentCategoriesApiFp(this.configuration)
      .assessmentCategoriesAssessmentCategoryIdGet(assessmentCategoryId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update an assessment category.
   * @param {string} assessmentCategoryId path The ID of the assessment category.
   * @param {UpdateAssessmentCategoryRequest} [updateAssessmentCategoryRequest] The category update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentCategoriesAssessmentCategoryIdPut(
    assessmentCategoryId: string,
    updateAssessmentCategoryRequest?: UpdateAssessmentCategoryRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssessmentCategoriesApiFp(this.configuration)
      .assessmentCategoriesAssessmentCategoryIdPut(
        assessmentCategoryId,
        updateAssessmentCategoryRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all assessment categories.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentCategoriesGet(options?: RawAxiosRequestConfig) {
    return AssessmentCategoriesApiFp(this.configuration)
      .assessmentCategoriesGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new assessment category.
   * @param {CreateAssessmentCategoryRequest} [createAssessmentCategoryRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentCategoriesPost(
    createAssessmentCategoryRequest?: CreateAssessmentCategoryRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssessmentCategoriesApiFp(this.configuration)
      .assessmentCategoriesPost(createAssessmentCategoryRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AssessmentsApi - axios parameter creator
 */
export const AssessmentsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete an assessment.
     * @param {string} assessmentId path The ID of the assessment to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsAssessmentIdDelete: async (
      assessmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assessmentId' is not null or undefined
      assertParamExists('assessmentsAssessmentIdDelete', 'assessmentId', assessmentId)
      const localVarPath = `/assessments/{assessmentId}`.replace(
        `{${'assessmentId'}}`,
        encodeURIComponent(String(assessmentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details of a specific assessment.
     * @param {string} assessmentId path The ID of the assessment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsAssessmentIdGet: async (
      assessmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assessmentId' is not null or undefined
      assertParamExists('assessmentsAssessmentIdGet', 'assessmentId', assessmentId)
      const localVarPath = `/assessments/{assessmentId}`.replace(
        `{${'assessmentId'}}`,
        encodeURIComponent(String(assessmentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update an existing assessment.
     * @param {string} assessmentId path The ID of the assessment to update.
     * @param {UpdateAssessmentRequest} [updateAssessmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsAssessmentIdPut: async (
      assessmentId: string,
      updateAssessmentRequest?: UpdateAssessmentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assessmentId' is not null or undefined
      assertParamExists('assessmentsAssessmentIdPut', 'assessmentId', assessmentId)
      const localVarPath = `/assessments/{assessmentId}`.replace(
        `{${'assessmentId'}}`,
        encodeURIComponent(String(assessmentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateAssessmentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all assessments based on optional filters.
     * @param {string} [filter] path An optional query parameter to filter the results (e.g., classId, studentId).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsGet: async (
      filter?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/assessments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (filter !== undefined) {
        localVarQueryParameter['filter'] = filter
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new assessment.
     * @param {CreateAssessmentRequest} [createAssessmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsPost: async (
      createAssessmentRequest?: CreateAssessmentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/assessments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAssessmentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get available marking scales and assessment categories used for creating assessments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsSetupGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/assessments/setup`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AssessmentsApi - functional programming interface
 */
export const AssessmentsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssessmentsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete an assessment.
     * @param {string} assessmentId path The ID of the assessment to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentsAssessmentIdDelete(
      assessmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsAssessmentIdDelete(
        assessmentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentsApi.assessmentsAssessmentIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details of a specific assessment.
     * @param {string} assessmentId path The ID of the assessment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentsAssessmentIdGet(
      assessmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsAssessmentIdGet(
        assessmentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentsApi.assessmentsAssessmentIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update an existing assessment.
     * @param {string} assessmentId path The ID of the assessment to update.
     * @param {UpdateAssessmentRequest} [updateAssessmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentsAssessmentIdPut(
      assessmentId: string,
      updateAssessmentRequest?: UpdateAssessmentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsAssessmentIdPut(
        assessmentId,
        updateAssessmentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentsApi.assessmentsAssessmentIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all assessments based on optional filters.
     * @param {string} [filter] path An optional query parameter to filter the results (e.g., classId, studentId).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentsGet(
      filter?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssessmentsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsGet(filter, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentsApi.assessmentsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new assessment.
     * @param {CreateAssessmentRequest} [createAssessmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentsPost(
      createAssessmentRequest?: CreateAssessmentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsPost(
        createAssessmentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentsApi.assessmentsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get available marking scales and assessment categories used for creating assessments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assessmentsSetupGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssessmentSetupResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsSetupGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssessmentsApi.assessmentsSetupGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AssessmentsApi - factory interface
 */
export const AssessmentsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssessmentsApiFp(configuration)
  return {
    /**
     *
     * @summary Delete an assessment.
     * @param {string} assessmentId path The ID of the assessment to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsAssessmentIdDelete(
      assessmentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assessmentsAssessmentIdDelete(assessmentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details of a specific assessment.
     * @param {string} assessmentId path The ID of the assessment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsAssessmentIdGet(
      assessmentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Assessment> {
      return localVarFp
        .assessmentsAssessmentIdGet(assessmentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update an existing assessment.
     * @param {string} assessmentId path The ID of the assessment to update.
     * @param {UpdateAssessmentRequest} [updateAssessmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsAssessmentIdPut(
      assessmentId: string,
      updateAssessmentRequest?: UpdateAssessmentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assessmentsAssessmentIdPut(assessmentId, updateAssessmentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all assessments based on optional filters.
     * @param {string} [filter] path An optional query parameter to filter the results (e.g., classId, studentId).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsGet(
      filter?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetAssessmentsResponse> {
      return localVarFp.assessmentsGet(filter, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new assessment.
     * @param {CreateAssessmentRequest} [createAssessmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsPost(
      createAssessmentRequest?: CreateAssessmentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assessmentsPost(createAssessmentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get available marking scales and assessment categories used for creating assessments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assessmentsSetupGet(options?: RawAxiosRequestConfig): AxiosPromise<GetAssessmentSetupResponse> {
      return localVarFp.assessmentsSetupGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * AssessmentsApi - object-oriented interface
 */
export class AssessmentsApi extends BaseAPI {
  /**
   *
   * @summary Delete an assessment.
   * @param {string} assessmentId path The ID of the assessment to delete.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentsAssessmentIdDelete(assessmentId: string, options?: RawAxiosRequestConfig) {
    return AssessmentsApiFp(this.configuration)
      .assessmentsAssessmentIdDelete(assessmentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details of a specific assessment.
   * @param {string} assessmentId path The ID of the assessment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentsAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig) {
    return AssessmentsApiFp(this.configuration)
      .assessmentsAssessmentIdGet(assessmentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update an existing assessment.
   * @param {string} assessmentId path The ID of the assessment to update.
   * @param {UpdateAssessmentRequest} [updateAssessmentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentsAssessmentIdPut(
    assessmentId: string,
    updateAssessmentRequest?: UpdateAssessmentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssessmentsApiFp(this.configuration)
      .assessmentsAssessmentIdPut(assessmentId, updateAssessmentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all assessments based on optional filters.
   * @param {string} [filter] path An optional query parameter to filter the results (e.g., classId, studentId).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentsGet(filter?: string, options?: RawAxiosRequestConfig) {
    return AssessmentsApiFp(this.configuration)
      .assessmentsGet(filter, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new assessment.
   * @param {CreateAssessmentRequest} [createAssessmentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentsPost(
    createAssessmentRequest?: CreateAssessmentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssessmentsApiFp(this.configuration)
      .assessmentsPost(createAssessmentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get available marking scales and assessment categories used for creating assessments.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assessmentsSetupGet(options?: RawAxiosRequestConfig) {
    return AssessmentsApiFp(this.configuration)
      .assessmentsSetupGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AssignmentsApi - axios parameter creator
 */
export const AssignmentsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete an assignment.
     * @param {string} assignmentId path The ID of the assignment to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdDelete: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('assignmentsAssignmentIdDelete', 'assignmentId', assignmentId)
      const localVarPath = `/assignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get full details of a specific assignment.
     * @param {string} assignmentId path The ID of the assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdDetailsGet: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('assignmentsAssignmentIdDetailsGet', 'assignmentId', assignmentId)
      const localVarPath = `/assignments/{assignmentId}/details`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details of a specific assignment.
     * @param {string} assignmentId path The ID of the assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdGet: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('assignmentsAssignmentIdGet', 'assignmentId', assignmentId)
      const localVarPath = `/assignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all assignments.
     * @param {string} [classId] path Optional: Filter assignments by the class they were assigned to.
     * @param {string} [studentId] path Optional: Filter assignments assigned to a specific student.
     * @param {string} [termId] path Optional: Filter assignments by the academic term they belong to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsGet: async (
      classId?: string,
      studentId?: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/assignments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (classId !== undefined) {
        localVarQueryParameter['classId'] = classId
      }

      if (studentId !== undefined) {
        localVarQueryParameter['studentId'] = studentId
      }

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new assignment.
     * @param {CreateAssignmentRequest} [createAssignmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsPost: async (
      createAssignmentRequest?: CreateAssignmentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/assignments`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createAssignmentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get assignment summaries.
     * @param {string} [classId] path Optional: Filter summaries by class ID.
     * @param {string} [termId] path Optional: Filter summaries by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsSummariesGet: async (
      classId?: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/assignments/summaries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (classId !== undefined) {
        localVarQueryParameter['classId'] = classId
      }

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new assignment and immediately assign it to all students in a class.
     * @param {string} classId path The ID of the class to assign the new assignment to.
     * @param {CreateClassAssignmentRequest} [createClassAssignmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdAssignmentsPost: async (
      classId: string,
      createClassAssignmentRequest?: CreateClassAssignmentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdAssignmentsPost', 'classId', classId)
      const localVarPath = `/classes/{classId}/assignments`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createClassAssignmentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AssignmentsApi - functional programming interface
 */
export const AssignmentsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssignmentsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete an assignment.
     * @param {string} assignmentId path The ID of the assignment to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignmentsAssignmentIdDelete(
      assignmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdDelete(
        assignmentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssignmentsApi.assignmentsAssignmentIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get full details of a specific assignment.
     * @param {string} assignmentId path The ID of the assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignmentsAssignmentIdDetailsGet(
      assignmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssignmentDetailsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdDetailsGet(
        assignmentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssignmentsApi.assignmentsAssignmentIdDetailsGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details of a specific assignment.
     * @param {string} assignmentId path The ID of the assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignmentsAssignmentIdGet(
      assignmentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsAssignmentIdGet(
        assignmentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssignmentsApi.assignmentsAssignmentIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all assignments.
     * @param {string} [classId] path Optional: Filter assignments by the class they were assigned to.
     * @param {string} [studentId] path Optional: Filter assignments assigned to a specific student.
     * @param {string} [termId] path Optional: Filter assignments by the academic term they belong to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignmentsGet(
      classId?: string,
      studentId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssignmentsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsGet(
        classId,
        studentId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssignmentsApi.assignmentsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new assignment.
     * @param {CreateAssignmentRequest} [createAssignmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignmentsPost(
      createAssignmentRequest?: CreateAssignmentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsPost(
        createAssignmentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssignmentsApi.assignmentsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get assignment summaries.
     * @param {string} [classId] path Optional: Filter summaries by class ID.
     * @param {string} [termId] path Optional: Filter summaries by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignmentsSummariesGet(
      classId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAssignmentSummariesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentsSummariesGet(
        classId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssignmentsApi.assignmentsSummariesGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new assignment and immediately assign it to all students in a class.
     * @param {string} classId path The ID of the class to assign the new assignment to.
     * @param {CreateClassAssignmentRequest} [createClassAssignmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdAssignmentsPost(
      classId: string,
      createClassAssignmentRequest?: CreateClassAssignmentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdAssignmentsPost(
        classId,
        createClassAssignmentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssignmentsApi.classesClassIdAssignmentsPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AssignmentsApi - factory interface
 */
export const AssignmentsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssignmentsApiFp(configuration)
  return {
    /**
     *
     * @summary Delete an assignment.
     * @param {string} assignmentId path The ID of the assignment to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdDelete(
      assignmentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assignmentsAssignmentIdDelete(assignmentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get full details of a specific assignment.
     * @param {string} assignmentId path The ID of the assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdDetailsGet(
      assignmentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetAssignmentDetailsResponse> {
      return localVarFp
        .assignmentsAssignmentIdDetailsGet(assignmentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details of a specific assignment.
     * @param {string} assignmentId path The ID of the assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdGet(
      assignmentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Assignment> {
      return localVarFp
        .assignmentsAssignmentIdGet(assignmentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all assignments.
     * @param {string} [classId] path Optional: Filter assignments by the class they were assigned to.
     * @param {string} [studentId] path Optional: Filter assignments assigned to a specific student.
     * @param {string} [termId] path Optional: Filter assignments by the academic term they belong to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsGet(
      classId?: string,
      studentId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetAssignmentsResponse> {
      return localVarFp
        .assignmentsGet(classId, studentId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new assignment.
     * @param {CreateAssignmentRequest} [createAssignmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsPost(
      createAssignmentRequest?: CreateAssignmentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assignmentsPost(createAssignmentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get assignment summaries.
     * @param {string} [classId] path Optional: Filter summaries by class ID.
     * @param {string} [termId] path Optional: Filter summaries by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsSummariesGet(
      classId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetAssignmentSummariesResponse> {
      return localVarFp
        .assignmentsSummariesGet(classId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new assignment and immediately assign it to all students in a class.
     * @param {string} classId path The ID of the class to assign the new assignment to.
     * @param {CreateClassAssignmentRequest} [createClassAssignmentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdAssignmentsPost(
      classId: string,
      createClassAssignmentRequest?: CreateClassAssignmentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdAssignmentsPost(classId, createClassAssignmentRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AssignmentsApi - object-oriented interface
 */
export class AssignmentsApi extends BaseAPI {
  /**
   *
   * @summary Delete an assignment.
   * @param {string} assignmentId path The ID of the assignment to delete.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignmentsAssignmentIdDelete(assignmentId: string, options?: RawAxiosRequestConfig) {
    return AssignmentsApiFp(this.configuration)
      .assignmentsAssignmentIdDelete(assignmentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get full details of a specific assignment.
   * @param {string} assignmentId path The ID of the assignment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignmentsAssignmentIdDetailsGet(assignmentId: string, options?: RawAxiosRequestConfig) {
    return AssignmentsApiFp(this.configuration)
      .assignmentsAssignmentIdDetailsGet(assignmentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details of a specific assignment.
   * @param {string} assignmentId path The ID of the assignment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignmentsAssignmentIdGet(assignmentId: string, options?: RawAxiosRequestConfig) {
    return AssignmentsApiFp(this.configuration)
      .assignmentsAssignmentIdGet(assignmentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all assignments.
   * @param {string} [classId] path Optional: Filter assignments by the class they were assigned to.
   * @param {string} [studentId] path Optional: Filter assignments assigned to a specific student.
   * @param {string} [termId] path Optional: Filter assignments by the academic term they belong to.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignmentsGet(
    classId?: string,
    studentId?: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssignmentsApiFp(this.configuration)
      .assignmentsGet(classId, studentId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new assignment.
   * @param {CreateAssignmentRequest} [createAssignmentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignmentsPost(
    createAssignmentRequest?: CreateAssignmentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssignmentsApiFp(this.configuration)
      .assignmentsPost(createAssignmentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get assignment summaries.
   * @param {string} [classId] path Optional: Filter summaries by class ID.
   * @param {string} [termId] path Optional: Filter summaries by term ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignmentsSummariesGet(
    classId?: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AssignmentsApiFp(this.configuration)
      .assignmentsSummariesGet(classId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new assignment and immediately assign it to all students in a class.
   * @param {string} classId path The ID of the class to assign the new assignment to.
   * @param {CreateClassAssignmentRequest} [createClassAssignmentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdAssignmentsPost(
    classId: string,
    createClassAssignmentRequest?: CreateClassAssignmentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssignmentsApiFp(this.configuration)
      .classesClassIdAssignmentsPost(classId, createClassAssignmentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AttendanceApi - axios parameter creator
 */
export const AttendanceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete a specific attendance record.
     * @param {string} [lessonId] path Required: The ID of the lesson.
     * @param {string} [studentId] path Required: The ID of the student.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendanceDelete: async (
      lessonId?: string,
      studentId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/attendance`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (lessonId !== undefined) {
        localVarQueryParameter['lessonId'] = lessonId
      }

      if (studentId !== undefined) {
        localVarQueryParameter['studentId'] = studentId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get attendance records.
     * @param {string} [classId] path Optional: Filter records by class ID.
     * @param {string} [studentId] path Optional: Filter records by student ID.
     * @param {string} [lessonId] path Optional: Filter records by lesson ID.
     * @param {string} [termId] path Optional: Filter records by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendanceGet: async (
      classId?: string,
      studentId?: string,
      lessonId?: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/attendance`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (classId !== undefined) {
        localVarQueryParameter['classId'] = classId
      }

      if (studentId !== undefined) {
        localVarQueryParameter['studentId'] = studentId
      }

      if (lessonId !== undefined) {
        localVarQueryParameter['lessonId'] = lessonId
      }

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Export attendance register for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {string} [termId] query Optional: Filter the register to a specific academic term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdRegisterExportGet: async (
      classId: string,
      format?: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdRegisterExportGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/register/export`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (format !== undefined) {
        localVarQueryParameter['format'] = format
      }

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a register for a class.
     * @param {string} classId path The ID of the class.
     * @param {string} [termId] path Optional: Filter the register to a specific academic term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdRegisterGet: async (
      classId: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdRegisterGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/register`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all attendance for a lesson.
     * @param {string} lessonId path The ID of the lesson.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdAttendanceGet: async (
      lessonId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonId' is not null or undefined
      assertParamExists('lessonsLessonIdAttendanceGet', 'lessonId', lessonId)
      const localVarPath = `/lessons/{lessonId}/attendance`.replace(
        `{${'lessonId'}}`,
        encodeURIComponent(String(lessonId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Record or update full attendance for a lesson.
     * @param {string} lessonId path The ID of the lesson.
     * @param {RecordAttendanceRequest} [recordAttendanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdAttendancePut: async (
      lessonId: string,
      recordAttendanceRequest?: RecordAttendanceRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonId' is not null or undefined
      assertParamExists('lessonsLessonIdAttendancePut', 'lessonId', lessonId)
      const localVarPath = `/lessons/{lessonId}/attendance`.replace(
        `{${'lessonId'}}`,
        encodeURIComponent(String(lessonId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        recordAttendanceRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AttendanceApi - functional programming interface
 */
export const AttendanceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AttendanceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete a specific attendance record.
     * @param {string} [lessonId] path Required: The ID of the lesson.
     * @param {string} [studentId] path Required: The ID of the student.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async attendanceDelete(
      lessonId?: string,
      studentId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.attendanceDelete(
        lessonId,
        studentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AttendanceApi.attendanceDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get attendance records.
     * @param {string} [classId] path Optional: Filter records by class ID.
     * @param {string} [studentId] path Optional: Filter records by student ID.
     * @param {string} [lessonId] path Optional: Filter records by lesson ID.
     * @param {string} [termId] path Optional: Filter records by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async attendanceGet(
      classId?: string,
      studentId?: string,
      lessonId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAttendanceResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.attendanceGet(
        classId,
        studentId,
        lessonId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AttendanceApi.attendanceGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Export attendance register for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {string} [termId] query Optional: Filter the register to a specific academic term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdRegisterExportGet(
      classId: string,
      format?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdRegisterExportGet(
        classId,
        format,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AttendanceApi.classesClassIdRegisterExportGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a register for a class.
     * @param {string} classId path The ID of the class.
     * @param {string} [termId] path Optional: Filter the register to a specific academic term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdRegisterGet(
      classId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClassRegisterResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdRegisterGet(
        classId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AttendanceApi.classesClassIdRegisterGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all attendance for a lesson.
     * @param {string} lessonId path The ID of the lesson.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsLessonIdAttendanceGet(
      lessonId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLessonAttendanceResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsLessonIdAttendanceGet(
        lessonId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AttendanceApi.lessonsLessonIdAttendanceGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Record or update full attendance for a lesson.
     * @param {string} lessonId path The ID of the lesson.
     * @param {RecordAttendanceRequest} [recordAttendanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsLessonIdAttendancePut(
      lessonId: string,
      recordAttendanceRequest?: RecordAttendanceRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsLessonIdAttendancePut(
        lessonId,
        recordAttendanceRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AttendanceApi.lessonsLessonIdAttendancePut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AttendanceApi - factory interface
 */
export const AttendanceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AttendanceApiFp(configuration)
  return {
    /**
     *
     * @summary Delete a specific attendance record.
     * @param {string} [lessonId] path Required: The ID of the lesson.
     * @param {string} [studentId] path Required: The ID of the student.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendanceDelete(
      lessonId?: string,
      studentId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .attendanceDelete(lessonId, studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get attendance records.
     * @param {string} [classId] path Optional: Filter records by class ID.
     * @param {string} [studentId] path Optional: Filter records by student ID.
     * @param {string} [lessonId] path Optional: Filter records by lesson ID.
     * @param {string} [termId] path Optional: Filter records by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    attendanceGet(
      classId?: string,
      studentId?: string,
      lessonId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetAttendanceResponse> {
      return localVarFp
        .attendanceGet(classId, studentId, lessonId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Export attendance register for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {string} [termId] query Optional: Filter the register to a specific academic term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdRegisterExportGet(
      classId: string,
      format?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdRegisterExportGet(classId, format, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a register for a class.
     * @param {string} classId path The ID of the class.
     * @param {string} [termId] path Optional: Filter the register to a specific academic term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdRegisterGet(
      classId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetClassRegisterResponse> {
      return localVarFp
        .classesClassIdRegisterGet(classId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all attendance for a lesson.
     * @param {string} lessonId path The ID of the lesson.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdAttendanceGet(
      lessonId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<GetLessonAttendanceResponse> {
      return localVarFp
        .lessonsLessonIdAttendanceGet(lessonId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Record or update full attendance for a lesson.
     * @param {string} lessonId path The ID of the lesson.
     * @param {RecordAttendanceRequest} [recordAttendanceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdAttendancePut(
      lessonId: string,
      recordAttendanceRequest?: RecordAttendanceRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .lessonsLessonIdAttendancePut(lessonId, recordAttendanceRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AttendanceApi - object-oriented interface
 */
export class AttendanceApi extends BaseAPI {
  /**
   *
   * @summary Delete a specific attendance record.
   * @param {string} [lessonId] path Required: The ID of the lesson.
   * @param {string} [studentId] path Required: The ID of the student.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public attendanceDelete(lessonId?: string, studentId?: string, options?: RawAxiosRequestConfig) {
    return AttendanceApiFp(this.configuration)
      .attendanceDelete(lessonId, studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get attendance records.
   * @param {string} [classId] path Optional: Filter records by class ID.
   * @param {string} [studentId] path Optional: Filter records by student ID.
   * @param {string} [lessonId] path Optional: Filter records by lesson ID.
   * @param {string} [termId] path Optional: Filter records by term ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public attendanceGet(
    classId?: string,
    studentId?: string,
    lessonId?: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AttendanceApiFp(this.configuration)
      .attendanceGet(classId, studentId, lessonId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Export attendance register for a class in various formats.
   * @param {string} classId path The class ID.
   * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
   * @param {string} [termId] query Optional: Filter the register to a specific academic term.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdRegisterExportGet(
    classId: string,
    format?: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AttendanceApiFp(this.configuration)
      .classesClassIdRegisterExportGet(classId, format, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a register for a class.
   * @param {string} classId path The ID of the class.
   * @param {string} [termId] path Optional: Filter the register to a specific academic term.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdRegisterGet(
    classId: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return AttendanceApiFp(this.configuration)
      .classesClassIdRegisterGet(classId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all attendance for a lesson.
   * @param {string} lessonId path The ID of the lesson.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsLessonIdAttendanceGet(lessonId: string, options?: RawAxiosRequestConfig) {
    return AttendanceApiFp(this.configuration)
      .lessonsLessonIdAttendanceGet(lessonId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Record or update full attendance for a lesson.
   * @param {string} lessonId path The ID of the lesson.
   * @param {RecordAttendanceRequest} [recordAttendanceRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsLessonIdAttendancePut(
    lessonId: string,
    recordAttendanceRequest?: RecordAttendanceRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AttendanceApiFp(this.configuration)
      .lessonsLessonIdAttendancePut(lessonId, recordAttendanceRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Change password while logged in.
     * @param {ChangePasswordRequest} [changePasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authChangePasswordPost: async (
      changePasswordRequest?: ChangePasswordRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/change-password`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        changePasswordRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Request a password reset email.
     * @param {ForgotPasswordRequest} [forgotPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authForgotPasswordPost: async (
      forgotPasswordRequest?: ForgotPasswordRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/forgot-password`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        forgotPasswordRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Login or register using a Google ID token.
     * @param {GoogleLoginRequest} [googleLoginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authGooglePost: async (
      googleLoginRequest?: GoogleLoginRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/google`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        googleLoginRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Login with email and password.
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLoginPost: async (
      loginRequest?: LoginRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/login`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        loginRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Logout and revoke a refresh token.
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLogoutPost: async (
      logoutRequest?: LogoutRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/logout`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        logoutRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Exchange a refresh token for a new access token.
     * @param {RefreshTokenRequest} [refreshTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRefreshPost: async (
      refreshTokenRequest?: RefreshTokenRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/refresh`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        refreshTokenRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Register with email and password.
     * @param {RegisterRequest} [registerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRegisterPost: async (
      registerRequest?: RegisterRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/register`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password using token from email link.
     * @param {ResetPasswordRequest} [resetPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authResetPasswordPost: async (
      resetPasswordRequest?: ResetPasswordRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/reset-password`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        resetPasswordRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Send email verification link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSendVerificationPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/auth/send-verification`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Verify email with token.
     * @param {string} [token] path Required: The unique token from the verification link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authVerifyEmailGet: async (
      token?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth/verify-email`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (token !== undefined) {
        localVarQueryParameter['token'] = token
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete authenticated user account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meDelete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get authenticated user details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Change password while logged in.
     * @param {ChangePasswordRequest} [changePasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authChangePasswordPost(
      changePasswordRequest?: ChangePasswordRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authChangePasswordPost(
        changePasswordRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authChangePasswordPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Request a password reset email.
     * @param {ForgotPasswordRequest} [forgotPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authForgotPasswordPost(
      forgotPasswordRequest?: ForgotPasswordRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authForgotPasswordPost(
        forgotPasswordRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authForgotPasswordPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Login or register using a Google ID token.
     * @param {GoogleLoginRequest} [googleLoginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authGooglePost(
      googleLoginRequest?: GoogleLoginRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenSet>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authGooglePost(
        googleLoginRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authGooglePost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Login with email and password.
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authLoginPost(
      loginRequest?: LoginRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenSet>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authLoginPost(loginRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authLoginPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Logout and revoke a refresh token.
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authLogoutPost(
      logoutRequest?: LogoutRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authLogoutPost(
        logoutRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authLogoutPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Exchange a refresh token for a new access token.
     * @param {RefreshTokenRequest} [refreshTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authRefreshPost(
      refreshTokenRequest?: RefreshTokenRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenSet>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authRefreshPost(
        refreshTokenRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authRefreshPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Register with email and password.
     * @param {RegisterRequest} [registerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authRegisterPost(
      registerRequest?: RegisterRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenSet>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authRegisterPost(
        registerRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authRegisterPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Reset password using token from email link.
     * @param {ResetPasswordRequest} [resetPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authResetPasswordPost(
      resetPasswordRequest?: ResetPasswordRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authResetPasswordPost(
        resetPasswordRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authResetPasswordPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Send email verification link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authSendVerificationPost(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authSendVerificationPost(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authSendVerificationPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Verify email with token.
     * @param {string} [token] path Required: The unique token from the verification link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authVerifyEmailGet(
      token?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authVerifyEmailGet(token, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.authVerifyEmailGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete authenticated user account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meDelete(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meDelete(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.meDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get authenticated user details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AuthApi.meGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthApiFp(configuration)
  return {
    /**
     *
     * @summary Change password while logged in.
     * @param {ChangePasswordRequest} [changePasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authChangePasswordPost(
      changePasswordRequest?: ChangePasswordRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .authChangePasswordPost(changePasswordRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Request a password reset email.
     * @param {ForgotPasswordRequest} [forgotPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authForgotPasswordPost(
      forgotPasswordRequest?: ForgotPasswordRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .authForgotPasswordPost(forgotPasswordRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Login or register using a Google ID token.
     * @param {GoogleLoginRequest} [googleLoginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authGooglePost(
      googleLoginRequest?: GoogleLoginRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TokenSet> {
      return localVarFp
        .authGooglePost(googleLoginRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Login with email and password.
     * @param {LoginRequest} [loginRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLoginPost(
      loginRequest?: LoginRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TokenSet> {
      return localVarFp
        .authLoginPost(loginRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Logout and revoke a refresh token.
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authLogoutPost(
      logoutRequest?: LogoutRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .authLogoutPost(logoutRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Exchange a refresh token for a new access token.
     * @param {RefreshTokenRequest} [refreshTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRefreshPost(
      refreshTokenRequest?: RefreshTokenRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TokenSet> {
      return localVarFp
        .authRefreshPost(refreshTokenRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Register with email and password.
     * @param {RegisterRequest} [registerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authRegisterPost(
      registerRequest?: RegisterRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TokenSet> {
      return localVarFp
        .authRegisterPost(registerRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Reset password using token from email link.
     * @param {ResetPasswordRequest} [resetPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authResetPasswordPost(
      resetPasswordRequest?: ResetPasswordRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .authResetPasswordPost(resetPasswordRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Send email verification link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSendVerificationPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .authSendVerificationPost(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Verify email with token.
     * @param {string} [token] path Required: The unique token from the verification link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authVerifyEmailGet(token?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
      return localVarFp
        .authVerifyEmailGet(token, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete authenticated user account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meDelete(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.meDelete(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get authenticated user details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meGet(options?: RawAxiosRequestConfig): AxiosPromise<User> {
      return localVarFp.meGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI {
  /**
   *
   * @summary Change password while logged in.
   * @param {ChangePasswordRequest} [changePasswordRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authChangePasswordPost(
    changePasswordRequest?: ChangePasswordRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authChangePasswordPost(changePasswordRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Request a password reset email.
   * @param {ForgotPasswordRequest} [forgotPasswordRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authForgotPasswordPost(
    forgotPasswordRequest?: ForgotPasswordRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authForgotPasswordPost(forgotPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Login or register using a Google ID token.
   * @param {GoogleLoginRequest} [googleLoginRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authGooglePost(googleLoginRequest?: GoogleLoginRequest, options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authGooglePost(googleLoginRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Login with email and password.
   * @param {LoginRequest} [loginRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authLoginPost(loginRequest?: LoginRequest, options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authLoginPost(loginRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Logout and revoke a refresh token.
   * @param {LogoutRequest} [logoutRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authLogoutPost(logoutRequest?: LogoutRequest, options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authLogoutPost(logoutRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Exchange a refresh token for a new access token.
   * @param {RefreshTokenRequest} [refreshTokenRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authRefreshPost(
    refreshTokenRequest?: RefreshTokenRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authRefreshPost(refreshTokenRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Register with email and password.
   * @param {RegisterRequest} [registerRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authRegisterPost(registerRequest?: RegisterRequest, options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authRegisterPost(registerRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Reset password using token from email link.
   * @param {ResetPasswordRequest} [resetPasswordRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authResetPasswordPost(
    resetPasswordRequest?: ResetPasswordRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authResetPasswordPost(resetPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Send email verification link.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authSendVerificationPost(options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authSendVerificationPost(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Verify email with token.
   * @param {string} [token] path Required: The unique token from the verification link.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public authVerifyEmailGet(token?: string, options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .authVerifyEmailGet(token, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete authenticated user account.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public meDelete(options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .meDelete(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get authenticated user details.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public meGet(options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .meGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ClassesApi - axios parameter creator
 */
export const ClassesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create multiple classes in one batch request.
     * @param {CreateClassesRequest} [createClassesRequest] The batch of class creation requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesBatchPost: async (
      createClassesRequest?: CreateClassesRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/classes/batch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createClassesRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a class and all associated data.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdDelete: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdDelete', 'classId', classId)
      const localVarPath = `/classes/{classId}`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details of a specific class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdGet', 'classId', classId)
      const localVarPath = `/classes/{classId}`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all notes for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdNotesGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/notes`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a class note.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesNoteIdDelete: async (
      classId: string,
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdNotesNoteIdDelete', 'classId', classId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('classesClassIdNotesNoteIdDelete', 'noteId', noteId)
      const localVarPath = `/classes/{classId}/notes/{noteId}`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'noteId'}}`, encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a single class note by ID.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesNoteIdGet: async (
      classId: string,
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdNotesNoteIdGet', 'classId', classId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('classesClassIdNotesNoteIdGet', 'noteId', noteId)
      const localVarPath = `/classes/{classId}/notes/{noteId}`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'noteId'}}`, encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a class note.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesNoteIdPut: async (
      classId: string,
      noteId: string,
      updateNoteRequest?: UpdateNoteRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdNotesNoteIdPut', 'classId', classId)
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('classesClassIdNotesNoteIdPut', 'noteId', noteId)
      const localVarPath = `/classes/{classId}/notes/{noteId}`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'noteId'}}`, encodeURIComponent(String(noteId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateNoteRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new note for a class.
     * @param {string} classId path The class ID.
     * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesPost: async (
      classId: string,
      createClassNoteRequest?: CreateClassNoteRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdNotesPost', 'classId', classId)
      const localVarPath = `/classes/{classId}/notes`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createClassNoteRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get overview data for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdOverviewGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdOverviewGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/overview`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get planner items for a class within a date range.
     * @param {string} classId path The class ID.
     * @param {string} [start] query optional Start date (ISO 8601).
     * @param {string} [end] query optional End date (ISO 8601).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdPlannerGet: async (
      classId: string,
      start?: string,
      end?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdPlannerGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/planner`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (start !== undefined) {
        localVarQueryParameter['start'] = start
      }

      if (end !== undefined) {
        localVarQueryParameter['end'] = end
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a class.
     * @param {string} classId path The class ID.
     * @param {CreateClassRequest} [createClassRequest] The class update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdPut: async (
      classId: string,
      createClassRequest?: CreateClassRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdPut', 'classId', classId)
      const localVarPath = `/classes/{classId}`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createClassRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create multiple students and enroll them in the class.
     * @param {string} classId path The class ID.
     * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] Batch of students to enroll.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsBatchPost: async (
      classId: string,
      createStudentsBatchRequest?: CreateStudentsBatchRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsBatchPost', 'classId', classId)
      const localVarPath = `/classes/{classId}/students/batch`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStudentsBatchRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Export student list for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsExportGet: async (
      classId: string,
      format?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsExportGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/students/export`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (format !== undefined) {
        localVarQueryParameter['format'] = format
      }

      localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get students enrolled in a specific class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/students`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a student and enroll them in the class.
     * @param {string} classId path The class ID.
     * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsPost: async (
      classId: string,
      createStudentRequest?: CreateStudentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsPost', 'classId', classId)
      const localVarPath = `/classes/{classId}/students`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStudentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Remove a student from a class.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdDelete: async (
      classId: string,
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdDelete', 'classId', classId)
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdDelete', 'studentId', studentId)
      const localVarPath = `/classes/{classId}/students/{studentId}`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Enroll (add) an existing student into a class.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdPut: async (
      classId: string,
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdPut', 'classId', classId)
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdPut', 'studentId', studentId)
      const localVarPath = `/classes/{classId}/students/{studentId}`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the timeline of events for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdTimelineGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdTimelineGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/timeline`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all classes visible to the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/classes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new class.
     * @param {CreateClassRequest} [createClassRequest] The class creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesPost: async (
      createClassRequest?: CreateClassRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/classes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createClassRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ClassesApi - functional programming interface
 */
export const ClassesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ClassesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Create multiple classes in one batch request.
     * @param {CreateClassesRequest} [createClassesRequest] The batch of class creation requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesBatchPost(
      createClassesRequest?: CreateClassesRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassDetails>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesBatchPost(
        createClassesRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesBatchPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a class and all associated data.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdDelete(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdDelete(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details of a specific class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdGet(classId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all notes for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdNotesGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassNotes>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdNotesGet(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdNotesGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a class note.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdNotesNoteIdDelete(
      classId: string,
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdNotesNoteIdDelete(
        classId,
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdNotesNoteIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a single class note by ID.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdNotesNoteIdGet(
      classId: string,
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdNotesNoteIdGet(
        classId,
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdNotesNoteIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a class note.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdNotesNoteIdPut(
      classId: string,
      noteId: string,
      updateNoteRequest?: UpdateNoteRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdNotesNoteIdPut(
        classId,
        noteId,
        updateNoteRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdNotesNoteIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new note for a class.
     * @param {string} classId path The class ID.
     * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdNotesPost(
      classId: string,
      createClassNoteRequest?: CreateClassNoteRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdNotesPost(
        classId,
        createClassNoteRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdNotesPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get overview data for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdOverviewGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassOverview>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdOverviewGet(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdOverviewGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get planner items for a class within a date range.
     * @param {string} classId path The class ID.
     * @param {string} [start] query optional Start date (ISO 8601).
     * @param {string} [end] query optional End date (ISO 8601).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdPlannerGet(
      classId: string,
      start?: string,
      end?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassPlanner>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdPlannerGet(
        classId,
        start,
        end,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdPlannerGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a class.
     * @param {string} classId path The class ID.
     * @param {CreateClassRequest} [createClassRequest] The class update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdPut(
      classId: string,
      createClassRequest?: CreateClassRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdPut(
        classId,
        createClassRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create multiple students and enroll them in the class.
     * @param {string} classId path The class ID.
     * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] Batch of students to enroll.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsBatchPost(
      classId: string,
      createStudentsBatchRequest?: CreateStudentsBatchRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Student>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdStudentsBatchPost(
        classId,
        createStudentsBatchRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdStudentsBatchPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Export student list for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsExportGet(
      classId: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdStudentsExportGet(
        classId,
        format,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdStudentsExportGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get students enrolled in a specific class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Student>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdStudentsGet(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdStudentsGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a student and enroll them in the class.
     * @param {string} classId path The class ID.
     * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsPost(
      classId: string,
      createStudentRequest?: CreateStudentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdStudentsPost(
        classId,
        createStudentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdStudentsPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Remove a student from a class.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsStudentIdDelete(
      classId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.classesClassIdStudentsStudentIdDelete(
          classId,
          studentId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdStudentsStudentIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Enroll (add) an existing student into a class.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsStudentIdPut(
      classId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdStudentsStudentIdPut(
        classId,
        studentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdStudentsStudentIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the timeline of events for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdTimelineGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassTimeline>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdTimelineGet(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesClassIdTimelineGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all classes visible to the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClassDetails>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new class.
     * @param {CreateClassRequest} [createClassRequest] The class creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesPost(
      createClassRequest?: CreateClassRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesPost(
        createClassRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ClassesApi.classesPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ClassesApi - factory interface
 */
export const ClassesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ClassesApiFp(configuration)
  return {
    /**
     *
     * @summary Create multiple classes in one batch request.
     * @param {CreateClassesRequest} [createClassesRequest] The batch of class creation requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesBatchPost(
      createClassesRequest?: CreateClassesRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<ClassDetails>> {
      return localVarFp
        .classesBatchPost(createClassesRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a class and all associated data.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdDelete(classId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .classesClassIdDelete(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details of a specific class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassDetails> {
      return localVarFp
        .classesClassIdGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all notes for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassNotes> {
      return localVarFp
        .classesClassIdNotesGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a class note.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesNoteIdDelete(
      classId: string,
      noteId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdNotesNoteIdDelete(classId, noteId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a single class note by ID.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesNoteIdGet(
      classId: string,
      noteId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .classesClassIdNotesNoteIdGet(classId, noteId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a class note.
     * @param {string} classId path The class ID.
     * @param {string} noteId path The note ID.
     * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesNoteIdPut(
      classId: string,
      noteId: string,
      updateNoteRequest?: UpdateNoteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .classesClassIdNotesNoteIdPut(classId, noteId, updateNoteRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new note for a class.
     * @param {string} classId path The class ID.
     * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdNotesPost(
      classId: string,
      createClassNoteRequest?: CreateClassNoteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdNotesPost(classId, createClassNoteRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get overview data for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdOverviewGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassOverview> {
      return localVarFp
        .classesClassIdOverviewGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get planner items for a class within a date range.
     * @param {string} classId path The class ID.
     * @param {string} [start] query optional Start date (ISO 8601).
     * @param {string} [end] query optional End date (ISO 8601).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdPlannerGet(
      classId: string,
      start?: string,
      end?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassPlanner> {
      return localVarFp
        .classesClassIdPlannerGet(classId, start, end, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a class.
     * @param {string} classId path The class ID.
     * @param {CreateClassRequest} [createClassRequest] The class update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdPut(
      classId: string,
      createClassRequest?: CreateClassRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassDetails> {
      return localVarFp
        .classesClassIdPut(classId, createClassRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create multiple students and enroll them in the class.
     * @param {string} classId path The class ID.
     * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] Batch of students to enroll.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsBatchPost(
      classId: string,
      createStudentsBatchRequest?: CreateStudentsBatchRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Student>> {
      return localVarFp
        .classesClassIdStudentsBatchPost(classId, createStudentsBatchRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Export student list for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsExportGet(
      classId: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdStudentsExportGet(classId, format, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get students enrolled in a specific class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Student>> {
      return localVarFp
        .classesClassIdStudentsGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a student and enroll them in the class.
     * @param {string} classId path The class ID.
     * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsPost(
      classId: string,
      createStudentRequest?: CreateStudentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdStudentsPost(classId, createStudentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Remove a student from a class.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdDelete(
      classId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdStudentsStudentIdDelete(classId, studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Enroll (add) an existing student into a class.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdPut(
      classId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdStudentsStudentIdPut(classId, studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the timeline of events for a class.
     * @param {string} classId path The class ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdTimelineGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassTimeline> {
      return localVarFp
        .classesClassIdTimelineGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all classes visible to the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ClassDetails>> {
      return localVarFp.classesGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new class.
     * @param {CreateClassRequest} [createClassRequest] The class creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesPost(
      createClassRequest?: CreateClassRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassDetails> {
      return localVarFp
        .classesPost(createClassRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ClassesApi - object-oriented interface
 */
export class ClassesApi extends BaseAPI {
  /**
   *
   * @summary Create multiple classes in one batch request.
   * @param {CreateClassesRequest} [createClassesRequest] The batch of class creation requests.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesBatchPost(
    createClassesRequest?: CreateClassesRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesBatchPost(createClassesRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a class and all associated data.
   * @param {string} classId path The class ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdDelete(classId: string, options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesClassIdDelete(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details of a specific class.
   * @param {string} classId path The class ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdGet(classId: string, options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesClassIdGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all notes for a class.
   * @param {string} classId path The class ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdNotesGet(classId: string, options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesClassIdNotesGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a class note.
   * @param {string} classId path The class ID.
   * @param {string} noteId path The note ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdNotesNoteIdDelete(
    classId: string,
    noteId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdNotesNoteIdDelete(classId, noteId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a single class note by ID.
   * @param {string} classId path The class ID.
   * @param {string} noteId path The note ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdNotesNoteIdGet(
    classId: string,
    noteId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdNotesNoteIdGet(classId, noteId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a class note.
   * @param {string} classId path The class ID.
   * @param {string} noteId path The note ID.
   * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdNotesNoteIdPut(
    classId: string,
    noteId: string,
    updateNoteRequest?: UpdateNoteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdNotesNoteIdPut(classId, noteId, updateNoteRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new note for a class.
   * @param {string} classId path The class ID.
   * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdNotesPost(
    classId: string,
    createClassNoteRequest?: CreateClassNoteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdNotesPost(classId, createClassNoteRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get overview data for a class.
   * @param {string} classId path The class ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdOverviewGet(classId: string, options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesClassIdOverviewGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get planner items for a class within a date range.
   * @param {string} classId path The class ID.
   * @param {string} [start] query optional Start date (ISO 8601).
   * @param {string} [end] query optional End date (ISO 8601).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdPlannerGet(
    classId: string,
    start?: string,
    end?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdPlannerGet(classId, start, end, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a class.
   * @param {string} classId path The class ID.
   * @param {CreateClassRequest} [createClassRequest] The class update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdPut(
    classId: string,
    createClassRequest?: CreateClassRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdPut(classId, createClassRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create multiple students and enroll them in the class.
   * @param {string} classId path The class ID.
   * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] Batch of students to enroll.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsBatchPost(
    classId: string,
    createStudentsBatchRequest?: CreateStudentsBatchRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdStudentsBatchPost(classId, createStudentsBatchRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Export student list for a class in various formats.
   * @param {string} classId path The class ID.
   * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsExportGet(
    classId: string,
    format?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdStudentsExportGet(classId, format, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get students enrolled in a specific class.
   * @param {string} classId path The class ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsGet(classId: string, options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesClassIdStudentsGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a student and enroll them in the class.
   * @param {string} classId path The class ID.
   * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsPost(
    classId: string,
    createStudentRequest?: CreateStudentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdStudentsPost(classId, createStudentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Remove a student from a class.
   * @param {string} classId path The class ID.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsStudentIdDelete(
    classId: string,
    studentId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdStudentsStudentIdDelete(classId, studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Enroll (add) an existing student into a class.
   * @param {string} classId path The class ID.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsStudentIdPut(
    classId: string,
    studentId: string,
    options?: RawAxiosRequestConfig
  ) {
    return ClassesApiFp(this.configuration)
      .classesClassIdStudentsStudentIdPut(classId, studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the timeline of events for a class.
   * @param {string} classId path The class ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdTimelineGet(classId: string, options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesClassIdTimelineGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all classes visible to the current user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesGet(options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new class.
   * @param {CreateClassRequest} [createClassRequest] The class creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesPost(createClassRequest?: CreateClassRequest, options?: RawAxiosRequestConfig) {
    return ClassesApiFp(this.configuration)
      .classesPost(createClassRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Confirm and execute student import with the specified column mappings.
     * @param {ConfirmImportRequest} [confirmImportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importsStudentsConfirmPost: async (
      confirmImportRequest?: ConfirmImportRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/imports/students/confirm`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        confirmImportRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload and parse a file for student import. Accepts multipart/form-data with a file field named \"file\". Returns parsed headers, preview rows, and suggested column mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importsStudentsParsePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/imports/students/parse`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [stripeSignature]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksStripePost: async (
      stripeSignature?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/webhooks/stripe`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      if (stripeSignature != null) {
        localVarHeaderParameter['Stripe-Signature'] = String(stripeSignature)
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Confirm and execute student import with the specified column mappings.
     * @param {ConfirmImportRequest} [confirmImportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async importsStudentsConfirmPost(
      confirmImportRequest?: ConfirmImportRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.importsStudentsConfirmPost(
        confirmImportRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DefaultApi.importsStudentsConfirmPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Upload and parse a file for student import. Accepts multipart/form-data with a file field named \"file\". Returns parsed headers, preview rows, and suggested column mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async importsStudentsParsePost(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ParseFileResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.importsStudentsParsePost(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DefaultApi.importsStudentsParsePost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [stripeSignature]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async webhooksStripePost(
      stripeSignature?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.webhooksStripePost(
        stripeSignature,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DefaultApi.webhooksStripePost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DefaultApiFp(configuration)
  return {
    /**
     *
     * @summary Confirm and execute student import with the specified column mappings.
     * @param {ConfirmImportRequest} [confirmImportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importsStudentsConfirmPost(
      confirmImportRequest?: ConfirmImportRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ImportResult> {
      return localVarFp
        .importsStudentsConfirmPost(confirmImportRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Upload and parse a file for student import. Accepts multipart/form-data with a file field named \"file\". Returns parsed headers, preview rows, and suggested column mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importsStudentsParsePost(options?: RawAxiosRequestConfig): AxiosPromise<ParseFileResponse> {
      return localVarFp
        .importsStudentsParsePost(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} [stripeSignature]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    webhooksStripePost(
      stripeSignature?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .webhooksStripePost(stripeSignature, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary Confirm and execute student import with the specified column mappings.
   * @param {ConfirmImportRequest} [confirmImportRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public importsStudentsConfirmPost(
    confirmImportRequest?: ConfirmImportRequest,
    options?: RawAxiosRequestConfig
  ) {
    return DefaultApiFp(this.configuration)
      .importsStudentsConfirmPost(confirmImportRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Upload and parse a file for student import. Accepts multipart/form-data with a file field named \"file\". Returns parsed headers, preview rows, and suggested column mappings.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public importsStudentsParsePost(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .importsStudentsParsePost(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [stripeSignature]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public webhooksStripePost(stripeSignature?: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .webhooksStripePost(stripeSignature, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * GeneralApi - axios parameter creator
 */
export const GeneralApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get a fun, unauthenticated cheese message.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cheeseGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/cheese`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'text/plain'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a welcome message from the server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rootGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'text/plain'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a fun, authenticated secret cheese message.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    secretCheeseGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/secret-cheese`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'text/plain'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * GeneralApi - functional programming interface
 */
export const GeneralApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GeneralApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get a fun, unauthenticated cheese message.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cheeseGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cheeseGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GeneralApi.cheeseGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a welcome message from the server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rootGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.rootGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GeneralApi.rootGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a fun, authenticated secret cheese message.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async secretCheeseGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.secretCheeseGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GeneralApi.secretCheeseGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * GeneralApi - factory interface
 */
export const GeneralApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = GeneralApiFp(configuration)
  return {
    /**
     *
     * @summary Get a fun, unauthenticated cheese message.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cheeseGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
      return localVarFp.cheeseGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a welcome message from the server.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rootGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
      return localVarFp.rootGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a fun, authenticated secret cheese message.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    secretCheeseGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
      return localVarFp.secretCheeseGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * GeneralApi - object-oriented interface
 */
export class GeneralApi extends BaseAPI {
  /**
   *
   * @summary Get a fun, unauthenticated cheese message.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public cheeseGet(options?: RawAxiosRequestConfig) {
    return GeneralApiFp(this.configuration)
      .cheeseGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a welcome message from the server.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public rootGet(options?: RawAxiosRequestConfig) {
    return GeneralApiFp(this.configuration)
      .rootGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a fun, authenticated secret cheese message.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public secretCheeseGet(options?: RawAxiosRequestConfig) {
    return GeneralApiFp(this.configuration)
      .secretCheeseGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * GradebookApi - axios parameter creator
 */
export const GradebookApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Export gradebook for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradebookExportGet: async (
      classId: string,
      format?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdGradebookExportGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/gradebook/export`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (format !== undefined) {
        localVarQueryParameter['format'] = format
      }

      localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the full gradebook for a class.
     * @param {string} classId path The ID of the class whose gradebook to load.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradebookGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdGradebookGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/gradebook`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradingSetupDelete: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdGradingSetupDelete', 'classId', classId)
      const localVarPath = `/classes/{classId}/grading-setup`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to load.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradingSetupGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdGradingSetupGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/grading-setup`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Save (create or overwrite) the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to save.
     * @param {CreateGradingSetupRequest} [createGradingSetupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradingSetupPut: async (
      classId: string,
      createGradingSetupRequest?: CreateGradingSetupRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdGradingSetupPut', 'classId', classId)
      const localVarPath = `/classes/{classId}/grading-setup`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createGradingSetupRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * GradebookApi - functional programming interface
 */
export const GradebookApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GradebookApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Export gradebook for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdGradebookExportGet(
      classId: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdGradebookExportGet(
        classId,
        format,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradebookApi.classesClassIdGradebookExportGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the full gradebook for a class.
     * @param {string} classId path The ID of the class whose gradebook to load.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdGradebookGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Gradebook>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdGradebookGet(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradebookApi.classesClassIdGradebookGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdGradingSetupDelete(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdGradingSetupDelete(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradebookApi.classesClassIdGradingSetupDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to load.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdGradingSetupGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassGradingSetup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdGradingSetupGet(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradebookApi.classesClassIdGradingSetupGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Save (create or overwrite) the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to save.
     * @param {CreateGradingSetupRequest} [createGradingSetupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdGradingSetupPut(
      classId: string,
      createGradingSetupRequest?: CreateGradingSetupRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassGradingSetup>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdGradingSetupPut(
        classId,
        createGradingSetupRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradebookApi.classesClassIdGradingSetupPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * GradebookApi - factory interface
 */
export const GradebookApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = GradebookApiFp(configuration)
  return {
    /**
     *
     * @summary Export gradebook for a class in various formats.
     * @param {string} classId path The class ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradebookExportGet(
      classId: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdGradebookExportGet(classId, format, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the full gradebook for a class.
     * @param {string} classId path The ID of the class whose gradebook to load.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradebookGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Gradebook> {
      return localVarFp
        .classesClassIdGradebookGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to delete.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradingSetupDelete(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdGradingSetupDelete(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to load.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradingSetupGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassGradingSetup> {
      return localVarFp
        .classesClassIdGradingSetupGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Save (create or overwrite) the grading setup for a class.
     * @param {string} classId path The ID of the class whose grading setup to save.
     * @param {CreateGradingSetupRequest} [createGradingSetupRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdGradingSetupPut(
      classId: string,
      createGradingSetupRequest?: CreateGradingSetupRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassGradingSetup> {
      return localVarFp
        .classesClassIdGradingSetupPut(classId, createGradingSetupRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * GradebookApi - object-oriented interface
 */
export class GradebookApi extends BaseAPI {
  /**
   *
   * @summary Export gradebook for a class in various formats.
   * @param {string} classId path The class ID.
   * @param {string} [format] query The export format (pdf, docx, xlsx). Defaults to xlsx.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdGradebookExportGet(
    classId: string,
    format?: string,
    options?: RawAxiosRequestConfig
  ) {
    return GradebookApiFp(this.configuration)
      .classesClassIdGradebookExportGet(classId, format, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the full gradebook for a class.
   * @param {string} classId path The ID of the class whose gradebook to load.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdGradebookGet(classId: string, options?: RawAxiosRequestConfig) {
    return GradebookApiFp(this.configuration)
      .classesClassIdGradebookGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete the grading setup for a class.
   * @param {string} classId path The ID of the class whose grading setup to delete.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdGradingSetupDelete(classId: string, options?: RawAxiosRequestConfig) {
    return GradebookApiFp(this.configuration)
      .classesClassIdGradingSetupDelete(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the grading setup for a class.
   * @param {string} classId path The ID of the class whose grading setup to load.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdGradingSetupGet(classId: string, options?: RawAxiosRequestConfig) {
    return GradebookApiFp(this.configuration)
      .classesClassIdGradingSetupGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Save (create or overwrite) the grading setup for a class.
   * @param {string} classId path The ID of the class whose grading setup to save.
   * @param {CreateGradingSetupRequest} [createGradingSetupRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdGradingSetupPut(
    classId: string,
    createGradingSetupRequest?: CreateGradingSetupRequest,
    options?: RawAxiosRequestConfig
  ) {
    return GradebookApiFp(this.configuration)
      .classesClassIdGradingSetupPut(classId, createGradingSetupRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * GradesApi - axios parameter creator
 */
export const GradesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all grades with optional filters.
     * @param {string} [classId] query Optional filter by class ID.
     * @param {string} [studentId] query Optional filter by student ID.
     * @param {string} [assignmentId] query Optional filter by assignment ID.
     * @param {string} [termId] query Optional filter by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesGet: async (
      classId?: string,
      studentId?: string,
      assignmentId?: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/grades`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (classId !== undefined) {
        localVarQueryParameter['classId'] = classId
      }

      if (studentId !== undefined) {
        localVarQueryParameter['studentId'] = studentId
      }

      if (assignmentId !== undefined) {
        localVarQueryParameter['assignmentId'] = assignmentId
      }

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a grade.
     * @param {string} gradeId path The grade ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesGradeIdDelete: async (
      gradeId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'gradeId' is not null or undefined
      assertParamExists('gradesGradeIdDelete', 'gradeId', gradeId)
      const localVarPath = `/grades/{gradeId}`.replace(
        `{${'gradeId'}}`,
        encodeURIComponent(String(gradeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details of a specific grade.
     * @param {string} gradeId path The grade ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesGradeIdGet: async (
      gradeId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'gradeId' is not null or undefined
      assertParamExists('gradesGradeIdGet', 'gradeId', gradeId)
      const localVarPath = `/grades/{gradeId}`.replace(
        `{${'gradeId'}}`,
        encodeURIComponent(String(gradeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new grade.
     * @param {CreateGradeRequest} [createGradeRequest] The grade creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesPost: async (
      createGradeRequest?: CreateGradeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/grades`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createGradeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Idempotent upsert: create or update a grade for a given (assignmentId, studentId).
     * @param {UpsertGradeRequest} [upsertGradeRequest] The grade upsert request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesPut: async (
      upsertGradeRequest?: UpsertGradeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/grades`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertGradeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * GradesApi - functional programming interface
 */
export const GradesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GradesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get all grades with optional filters.
     * @param {string} [classId] query Optional filter by class ID.
     * @param {string} [studentId] query Optional filter by student ID.
     * @param {string} [assignmentId] query Optional filter by assignment ID.
     * @param {string} [termId] query Optional filter by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gradesGet(
      classId?: string,
      studentId?: string,
      assignmentId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentGrade>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gradesGet(
        classId,
        studentId,
        assignmentId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradesApi.gradesGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a grade.
     * @param {string} gradeId path The grade ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gradesGradeIdDelete(
      gradeId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gradesGradeIdDelete(
        gradeId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradesApi.gradesGradeIdDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details of a specific grade.
     * @param {string} gradeId path The grade ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gradesGradeIdGet(
      gradeId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentGrade>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gradesGradeIdGet(gradeId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradesApi.gradesGradeIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new grade.
     * @param {CreateGradeRequest} [createGradeRequest] The grade creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gradesPost(
      createGradeRequest?: CreateGradeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gradesPost(
        createGradeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradesApi.gradesPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Idempotent upsert: create or update a grade for a given (assignmentId, studentId).
     * @param {UpsertGradeRequest} [upsertGradeRequest] The grade upsert request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gradesPut(
      upsertGradeRequest?: UpsertGradeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentGrade>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gradesPut(
        upsertGradeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GradesApi.gradesPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * GradesApi - factory interface
 */
export const GradesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = GradesApiFp(configuration)
  return {
    /**
     *
     * @summary Get all grades with optional filters.
     * @param {string} [classId] query Optional filter by class ID.
     * @param {string} [studentId] query Optional filter by student ID.
     * @param {string} [assignmentId] query Optional filter by assignment ID.
     * @param {string} [termId] query Optional filter by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesGet(
      classId?: string,
      studentId?: string,
      assignmentId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<AssignmentGrade>> {
      return localVarFp
        .gradesGet(classId, studentId, assignmentId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a grade.
     * @param {string} gradeId path The grade ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesGradeIdDelete(gradeId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .gradesGradeIdDelete(gradeId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details of a specific grade.
     * @param {string} gradeId path The grade ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesGradeIdGet(
      gradeId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssignmentGrade> {
      return localVarFp
        .gradesGradeIdGet(gradeId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new grade.
     * @param {CreateGradeRequest} [createGradeRequest] The grade creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesPost(
      createGradeRequest?: CreateGradeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .gradesPost(createGradeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Idempotent upsert: create or update a grade for a given (assignmentId, studentId).
     * @param {UpsertGradeRequest} [upsertGradeRequest] The grade upsert request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gradesPut(
      upsertGradeRequest?: UpsertGradeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<AssignmentGrade> {
      return localVarFp
        .gradesPut(upsertGradeRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * GradesApi - object-oriented interface
 */
export class GradesApi extends BaseAPI {
  /**
   *
   * @summary Get all grades with optional filters.
   * @param {string} [classId] query Optional filter by class ID.
   * @param {string} [studentId] query Optional filter by student ID.
   * @param {string} [assignmentId] query Optional filter by assignment ID.
   * @param {string} [termId] query Optional filter by term ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gradesGet(
    classId?: string,
    studentId?: string,
    assignmentId?: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return GradesApiFp(this.configuration)
      .gradesGet(classId, studentId, assignmentId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a grade.
   * @param {string} gradeId path The grade ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gradesGradeIdDelete(gradeId: string, options?: RawAxiosRequestConfig) {
    return GradesApiFp(this.configuration)
      .gradesGradeIdDelete(gradeId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details of a specific grade.
   * @param {string} gradeId path The grade ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gradesGradeIdGet(gradeId: string, options?: RawAxiosRequestConfig) {
    return GradesApiFp(this.configuration)
      .gradesGradeIdGet(gradeId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new grade.
   * @param {CreateGradeRequest} [createGradeRequest] The grade creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gradesPost(createGradeRequest?: CreateGradeRequest, options?: RawAxiosRequestConfig) {
    return GradesApiFp(this.configuration)
      .gradesPost(createGradeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Idempotent upsert: create or update a grade for a given (assignmentId, studentId).
   * @param {UpsertGradeRequest} [upsertGradeRequest] The grade upsert request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gradesPut(upsertGradeRequest?: UpsertGradeRequest, options?: RawAxiosRequestConfig) {
    return GradesApiFp(this.configuration)
      .gradesPut(upsertGradeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * GroupsApi - axios parameter creator
 */
export const GroupsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create multiple groups in a batch.
     * @param {CreateGroupsRequest} [createGroupsRequest] The batch of group creation requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsBatchPost: async (
      createGroupsRequest?: CreateGroupsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/groups/batch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createGroupsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all groups visible to the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/groups`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a group.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdDelete: async (
      groupId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('groupsGroupIdDelete', 'groupId', groupId)
      const localVarPath = `/groups/{groupId}`.replace(
        `{${'groupId'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details for a specific group by ID.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdGet: async (
      groupId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('groupsGroupIdGet', 'groupId', groupId)
      const localVarPath = `/groups/{groupId}`.replace(
        `{${'groupId'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a group.
     * @param {string} groupId path The group ID.
     * @param {UpdateGroupRequest} [updateGroupRequest] The group update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdPut: async (
      groupId: string,
      updateGroupRequest?: UpdateGroupRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('groupsGroupIdPut', 'groupId', groupId)
      const localVarPath = `/groups/{groupId}`.replace(
        `{${'groupId'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateGroupRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all students in a group.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdStudentsGet: async (
      groupId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('groupsGroupIdStudentsGet', 'groupId', groupId)
      const localVarPath = `/groups/{groupId}/students`.replace(
        `{${'groupId'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Add a student to a group.
     * @param {string} groupId path The group ID.
     * @param {AddStudentToGroupRequest} [addStudentToGroupRequest] The student ID to add.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdStudentsPost: async (
      groupId: string,
      addStudentToGroupRequest?: AddStudentToGroupRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('groupsGroupIdStudentsPost', 'groupId', groupId)
      const localVarPath = `/groups/{groupId}/students`.replace(
        `{${'groupId'}}`,
        encodeURIComponent(String(groupId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        addStudentToGroupRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Remove a student from a group.
     * @param {string} groupId path The group ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdStudentsStudentIdDelete: async (
      groupId: string,
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists('groupsGroupIdStudentsStudentIdDelete', 'groupId', groupId)
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('groupsGroupIdStudentsStudentIdDelete', 'studentId', studentId)
      const localVarPath = `/groups/{groupId}/students/{studentId}`
        .replace(`{${'groupId'}}`, encodeURIComponent(String(groupId)))
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new group.
     * @param {CreateGroupRequest} [createGroupRequest] The group creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsPost: async (
      createGroupRequest?: CreateGroupRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/groups`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createGroupRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * GroupsApi - functional programming interface
 */
export const GroupsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GroupsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Create multiple groups in a batch.
     * @param {CreateGroupsRequest} [createGroupsRequest] The batch of group creation requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsBatchPost(
      createGroupsRequest?: CreateGroupsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Group>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsBatchPost(
        createGroupsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsBatchPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all groups visible to the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Group>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a group.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsGroupIdDelete(
      groupId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsGroupIdDelete(
        groupId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsGroupIdDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details for a specific group by ID.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsGroupIdGet(
      groupId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Group>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsGroupIdGet(groupId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsGroupIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a group.
     * @param {string} groupId path The group ID.
     * @param {UpdateGroupRequest} [updateGroupRequest] The group update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsGroupIdPut(
      groupId: string,
      updateGroupRequest?: UpdateGroupRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Group>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsGroupIdPut(
        groupId,
        updateGroupRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsGroupIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all students in a group.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsGroupIdStudentsGet(
      groupId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Student>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsGroupIdStudentsGet(
        groupId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsGroupIdStudentsGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add a student to a group.
     * @param {string} groupId path The group ID.
     * @param {AddStudentToGroupRequest} [addStudentToGroupRequest] The student ID to add.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsGroupIdStudentsPost(
      groupId: string,
      addStudentToGroupRequest?: AddStudentToGroupRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsGroupIdStudentsPost(
        groupId,
        addStudentToGroupRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsGroupIdStudentsPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Remove a student from a group.
     * @param {string} groupId path The group ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsGroupIdStudentsStudentIdDelete(
      groupId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.groupsGroupIdStudentsStudentIdDelete(
          groupId,
          studentId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsGroupIdStudentsStudentIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new group.
     * @param {CreateGroupRequest} [createGroupRequest] The group creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async groupsPost(
      createGroupRequest?: CreateGroupRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Group>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.groupsPost(
        createGroupRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GroupsApi.groupsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * GroupsApi - factory interface
 */
export const GroupsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = GroupsApiFp(configuration)
  return {
    /**
     *
     * @summary Create multiple groups in a batch.
     * @param {CreateGroupsRequest} [createGroupsRequest] The batch of group creation requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsBatchPost(
      createGroupsRequest?: CreateGroupsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Group>> {
      return localVarFp
        .groupsBatchPost(createGroupsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all groups visible to the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Group>> {
      return localVarFp.groupsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a group.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdDelete(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .groupsGroupIdDelete(groupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details for a specific group by ID.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdGet(groupId: string, options?: RawAxiosRequestConfig): AxiosPromise<Group> {
      return localVarFp
        .groupsGroupIdGet(groupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a group.
     * @param {string} groupId path The group ID.
     * @param {UpdateGroupRequest} [updateGroupRequest] The group update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdPut(
      groupId: string,
      updateGroupRequest?: UpdateGroupRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Group> {
      return localVarFp
        .groupsGroupIdPut(groupId, updateGroupRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all students in a group.
     * @param {string} groupId path The group ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdStudentsGet(
      groupId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Student>> {
      return localVarFp
        .groupsGroupIdStudentsGet(groupId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Add a student to a group.
     * @param {string} groupId path The group ID.
     * @param {AddStudentToGroupRequest} [addStudentToGroupRequest] The student ID to add.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdStudentsPost(
      groupId: string,
      addStudentToGroupRequest?: AddStudentToGroupRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .groupsGroupIdStudentsPost(groupId, addStudentToGroupRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Remove a student from a group.
     * @param {string} groupId path The group ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsGroupIdStudentsStudentIdDelete(
      groupId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .groupsGroupIdStudentsStudentIdDelete(groupId, studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new group.
     * @param {CreateGroupRequest} [createGroupRequest] The group creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    groupsPost(
      createGroupRequest?: CreateGroupRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Group> {
      return localVarFp
        .groupsPost(createGroupRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * GroupsApi - object-oriented interface
 */
export class GroupsApi extends BaseAPI {
  /**
   *
   * @summary Create multiple groups in a batch.
   * @param {CreateGroupsRequest} [createGroupsRequest] The batch of group creation requests.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsBatchPost(
    createGroupsRequest?: CreateGroupsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return GroupsApiFp(this.configuration)
      .groupsBatchPost(createGroupsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all groups visible to the current user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsGet(options?: RawAxiosRequestConfig) {
    return GroupsApiFp(this.configuration)
      .groupsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a group.
   * @param {string} groupId path The group ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsGroupIdDelete(groupId: string, options?: RawAxiosRequestConfig) {
    return GroupsApiFp(this.configuration)
      .groupsGroupIdDelete(groupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details for a specific group by ID.
   * @param {string} groupId path The group ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsGroupIdGet(groupId: string, options?: RawAxiosRequestConfig) {
    return GroupsApiFp(this.configuration)
      .groupsGroupIdGet(groupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a group.
   * @param {string} groupId path The group ID.
   * @param {UpdateGroupRequest} [updateGroupRequest] The group update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsGroupIdPut(
    groupId: string,
    updateGroupRequest?: UpdateGroupRequest,
    options?: RawAxiosRequestConfig
  ) {
    return GroupsApiFp(this.configuration)
      .groupsGroupIdPut(groupId, updateGroupRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all students in a group.
   * @param {string} groupId path The group ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsGroupIdStudentsGet(groupId: string, options?: RawAxiosRequestConfig) {
    return GroupsApiFp(this.configuration)
      .groupsGroupIdStudentsGet(groupId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add a student to a group.
   * @param {string} groupId path The group ID.
   * @param {AddStudentToGroupRequest} [addStudentToGroupRequest] The student ID to add.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsGroupIdStudentsPost(
    groupId: string,
    addStudentToGroupRequest?: AddStudentToGroupRequest,
    options?: RawAxiosRequestConfig
  ) {
    return GroupsApiFp(this.configuration)
      .groupsGroupIdStudentsPost(groupId, addStudentToGroupRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Remove a student from a group.
   * @param {string} groupId path The group ID.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsGroupIdStudentsStudentIdDelete(
    groupId: string,
    studentId: string,
    options?: RawAxiosRequestConfig
  ) {
    return GroupsApiFp(this.configuration)
      .groupsGroupIdStudentsStudentIdDelete(groupId, studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new group.
   * @param {CreateGroupRequest} [createGroupRequest] The group creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public groupsPost(createGroupRequest?: CreateGroupRequest, options?: RawAxiosRequestConfig) {
    return GroupsApiFp(this.configuration)
      .groupsPost(createGroupRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * HealthApi - axios parameter creator
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Basic health check - returns 200 if server is running. Cloud Run uses this for readiness/liveness probes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/health`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'text/plain'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Detailed health check - includes environment info. Useful for debugging but doesn\'t expose sensitive data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthReadyGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/health/ready`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * HealthApi - functional programming interface
 */
export const HealthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Basic health check - returns 200 if server is running. Cloud Run uses this for readiness/liveness probes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healthGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.healthGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HealthApi.healthGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Detailed health check - includes environment info. Useful for debugging but doesn\'t expose sensitive data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healthReadyGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthReadyResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.healthReadyGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['HealthApi.healthReadyGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * HealthApi - factory interface
 */
export const HealthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HealthApiFp(configuration)
  return {
    /**
     *
     * @summary Basic health check - returns 200 if server is running. Cloud Run uses this for readiness/liveness probes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
      return localVarFp.healthGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Detailed health check - includes environment info. Useful for debugging but doesn\'t expose sensitive data.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthReadyGet(options?: RawAxiosRequestConfig): AxiosPromise<HealthReadyResponse> {
      return localVarFp.healthReadyGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * HealthApi - object-oriented interface
 */
export class HealthApi extends BaseAPI {
  /**
   *
   * @summary Basic health check - returns 200 if server is running. Cloud Run uses this for readiness/liveness probes.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public healthGet(options?: RawAxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .healthGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Detailed health check - includes environment info. Useful for debugging but doesn\'t expose sensitive data.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public healthReadyGet(options?: RawAxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .healthReadyGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * InvitesApi - axios parameter creator
 */
export const InvitesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept an invite. Links the current user\'s account to the teacher record. Requires authentication.
     * @param {string} token path The invite token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitesTokenAcceptPost: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('invitesTokenAcceptPost', 'token', token)
      const localVarPath = `/invites/{token}/accept`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get invite details by token. Public endpoint for the invite accept page. Shows teacher name, school name, and invite status.
     * @param {string} token path The invite token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitesTokenGet: async (
      token: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('invitesTokenGet', 'token', token)
      const localVarPath = `/invites/{token}`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * InvitesApi - functional programming interface
 */
export const InvitesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = InvitesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Accept an invite. Links the current user\'s account to the teacher record. Requires authentication.
     * @param {string} token path The invite token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitesTokenAcceptPost(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitesTokenAcceptPost(
        token,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['InvitesApi.invitesTokenAcceptPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get invite details by token. Public endpoint for the invite accept page. Shows teacher name, school name, and invite status.
     * @param {string} token path The invite token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitesTokenGet(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeacherInviteDetails>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitesTokenGet(token, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['InvitesApi.invitesTokenGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * InvitesApi - factory interface
 */
export const InvitesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = InvitesApiFp(configuration)
  return {
    /**
     *
     * @summary Accept an invite. Links the current user\'s account to the teacher record. Requires authentication.
     * @param {string} token path The invite token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitesTokenAcceptPost(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponse> {
      return localVarFp
        .invitesTokenAcceptPost(token, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get invite details by token. Public endpoint for the invite accept page. Shows teacher name, school name, and invite status.
     * @param {string} token path The invite token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitesTokenGet(
      token: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TeacherInviteDetails> {
      return localVarFp.invitesTokenGet(token, options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * InvitesApi - object-oriented interface
 */
export class InvitesApi extends BaseAPI {
  /**
   *
   * @summary Accept an invite. Links the current user\'s account to the teacher record. Requires authentication.
   * @param {string} token path The invite token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public invitesTokenAcceptPost(token: string, options?: RawAxiosRequestConfig) {
    return InvitesApiFp(this.configuration)
      .invitesTokenAcceptPost(token, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get invite details by token. Public endpoint for the invite accept page. Shows teacher name, school name, and invite status.
   * @param {string} token path The invite token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public invitesTokenGet(token: string, options?: RawAxiosRequestConfig) {
    return InvitesApiFp(this.configuration)
      .invitesTokenGet(token, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * LessonsApi - axios parameter creator
 */
export const LessonsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all lessons (with optional filters: classId, termId, teacherId, etc.).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/lessons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdDelete: async (
      lessonId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonId' is not null or undefined
      assertParamExists('lessonsLessonIdDelete', 'lessonId', lessonId)
      const localVarPath = `/lessons/{lessonId}`.replace(
        `{${'lessonId'}}`,
        encodeURIComponent(String(lessonId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details of a specific lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdGet: async (
      lessonId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonId' is not null or undefined
      assertParamExists('lessonsLessonIdGet', 'lessonId', lessonId)
      const localVarPath = `/lessons/{lessonId}`.replace(
        `{${'lessonId'}}`,
        encodeURIComponent(String(lessonId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all notes for a specific lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdNotesGet: async (
      lessonId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonId' is not null or undefined
      assertParamExists('lessonsLessonIdNotesGet', 'lessonId', lessonId)
      const localVarPath = `/lessons/{lessonId}/notes`.replace(
        `{${'lessonId'}}`,
        encodeURIComponent(String(lessonId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a note for a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdNotesPost: async (
      lessonId: string,
      createClassNoteRequest?: CreateClassNoteRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonId' is not null or undefined
      assertParamExists('lessonsLessonIdNotesPost', 'lessonId', lessonId)
      const localVarPath = `/lessons/{lessonId}/notes`.replace(
        `{${'lessonId'}}`,
        encodeURIComponent(String(lessonId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createClassNoteRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {UpdateLessonRequest} [updateLessonRequest] The lesson update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdPut: async (
      lessonId: string,
      updateLessonRequest?: UpdateLessonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonId' is not null or undefined
      assertParamExists('lessonsLessonIdPut', 'lessonId', lessonId)
      const localVarPath = `/lessons/{lessonId}`.replace(
        `{${'lessonId'}}`,
        encodeURIComponent(String(lessonId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateLessonRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a note.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsNotesNoteIdDelete: async (
      noteId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('lessonsNotesNoteIdDelete', 'noteId', noteId)
      const localVarPath = `/lessons/notes/{noteId}`.replace(
        `{${'noteId'}}`,
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a note.
     * @param {string} noteId path The note ID.
     * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsNotesNoteIdPut: async (
      noteId: string,
      updateNoteRequest?: UpdateNoteRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'noteId' is not null or undefined
      assertParamExists('lessonsNotesNoteIdPut', 'noteId', noteId)
      const localVarPath = `/lessons/notes/{noteId}`.replace(
        `{${'noteId'}}`,
        encodeURIComponent(String(noteId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateNoteRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new lesson.
     * @param {CreateLessonRequest} [createLessonRequest] The lesson creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsPost: async (
      createLessonRequest?: CreateLessonRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/lessons`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createLessonRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new recurring lesson schedule (and generate lessons).
     * @param {CreateLessonScheduleRequest} [createLessonScheduleRequest] The schedule creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsSchedulePost: async (
      createLessonScheduleRequest?: CreateLessonScheduleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/lessons/schedule`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createLessonScheduleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get attendance summaries for lessons (with filters).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsSummaryGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/lessons/summary`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LessonsApi - functional programming interface
 */
export const LessonsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LessonsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get all lessons (with optional filters: classId, termId, teacherId, etc.).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Lesson>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsLessonIdDelete(
      lessonId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsLessonIdDelete(
        lessonId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsLessonIdDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details of a specific lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsLessonIdGet(
      lessonId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lesson>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsLessonIdGet(
        lessonId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsLessonIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all notes for a specific lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsLessonIdNotesGet(
      lessonId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Note>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsLessonIdNotesGet(
        lessonId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsLessonIdNotesGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a note for a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsLessonIdNotesPost(
      lessonId: string,
      createClassNoteRequest?: CreateClassNoteRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsLessonIdNotesPost(
        lessonId,
        createClassNoteRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsLessonIdNotesPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {UpdateLessonRequest} [updateLessonRequest] The lesson update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsLessonIdPut(
      lessonId: string,
      updateLessonRequest?: UpdateLessonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsLessonIdPut(
        lessonId,
        updateLessonRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsLessonIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a note.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsNotesNoteIdDelete(
      noteId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsNotesNoteIdDelete(
        noteId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsNotesNoteIdDelete']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a note.
     * @param {string} noteId path The note ID.
     * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsNotesNoteIdPut(
      noteId: string,
      updateNoteRequest?: UpdateNoteRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsNotesNoteIdPut(
        noteId,
        updateNoteRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsNotesNoteIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new lesson.
     * @param {CreateLessonRequest} [createLessonRequest] The lesson creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsPost(
      createLessonRequest?: CreateLessonRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Lesson>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsPost(
        createLessonRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new recurring lesson schedule (and generate lessons).
     * @param {CreateLessonScheduleRequest} [createLessonScheduleRequest] The schedule creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsSchedulePost(
      createLessonScheduleRequest?: CreateLessonScheduleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsSchedulePost(
        createLessonScheduleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsSchedulePost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get attendance summaries for lessons (with filters).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lessonsSummaryGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassAttendanceSummary>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lessonsSummaryGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LessonsApi.lessonsSummaryGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LessonsApi - factory interface
 */
export const LessonsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = LessonsApiFp(configuration)
  return {
    /**
     *
     * @summary Get all lessons (with optional filters: classId, termId, teacherId, etc.).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Lesson>> {
      return localVarFp.lessonsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdDelete(lessonId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .lessonsLessonIdDelete(lessonId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details of a specific lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdGet(lessonId: string, options?: RawAxiosRequestConfig): AxiosPromise<Lesson> {
      return localVarFp
        .lessonsLessonIdGet(lessonId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all notes for a specific lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdNotesGet(
      lessonId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Note>> {
      return localVarFp
        .lessonsLessonIdNotesGet(lessonId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a note for a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdNotesPost(
      lessonId: string,
      createClassNoteRequest?: CreateClassNoteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .lessonsLessonIdNotesPost(lessonId, createClassNoteRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a lesson.
     * @param {string} lessonId path The lesson ID.
     * @param {UpdateLessonRequest} [updateLessonRequest] The lesson update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsLessonIdPut(
      lessonId: string,
      updateLessonRequest?: UpdateLessonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .lessonsLessonIdPut(lessonId, updateLessonRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a note.
     * @param {string} noteId path The note ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsNotesNoteIdDelete(noteId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .lessonsNotesNoteIdDelete(noteId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a note.
     * @param {string} noteId path The note ID.
     * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsNotesNoteIdPut(
      noteId: string,
      updateNoteRequest?: UpdateNoteRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Note> {
      return localVarFp
        .lessonsNotesNoteIdPut(noteId, updateNoteRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new lesson.
     * @param {CreateLessonRequest} [createLessonRequest] The lesson creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsPost(
      createLessonRequest?: CreateLessonRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Lesson> {
      return localVarFp
        .lessonsPost(createLessonRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new recurring lesson schedule (and generate lessons).
     * @param {CreateLessonScheduleRequest} [createLessonScheduleRequest] The schedule creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsSchedulePost(
      createLessonScheduleRequest?: CreateLessonScheduleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .lessonsSchedulePost(createLessonScheduleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get attendance summaries for lessons (with filters).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lessonsSummaryGet(options?: RawAxiosRequestConfig): AxiosPromise<ClassAttendanceSummary> {
      return localVarFp.lessonsSummaryGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * LessonsApi - object-oriented interface
 */
export class LessonsApi extends BaseAPI {
  /**
   *
   * @summary Get all lessons (with optional filters: classId, termId, teacherId, etc.).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsGet(options?: RawAxiosRequestConfig) {
    return LessonsApiFp(this.configuration)
      .lessonsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a lesson.
   * @param {string} lessonId path The lesson ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsLessonIdDelete(lessonId: string, options?: RawAxiosRequestConfig) {
    return LessonsApiFp(this.configuration)
      .lessonsLessonIdDelete(lessonId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details of a specific lesson.
   * @param {string} lessonId path The lesson ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsLessonIdGet(lessonId: string, options?: RawAxiosRequestConfig) {
    return LessonsApiFp(this.configuration)
      .lessonsLessonIdGet(lessonId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all notes for a specific lesson.
   * @param {string} lessonId path The lesson ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsLessonIdNotesGet(lessonId: string, options?: RawAxiosRequestConfig) {
    return LessonsApiFp(this.configuration)
      .lessonsLessonIdNotesGet(lessonId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a note for a lesson.
   * @param {string} lessonId path The lesson ID.
   * @param {CreateClassNoteRequest} [createClassNoteRequest] The note creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsLessonIdNotesPost(
    lessonId: string,
    createClassNoteRequest?: CreateClassNoteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LessonsApiFp(this.configuration)
      .lessonsLessonIdNotesPost(lessonId, createClassNoteRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a lesson.
   * @param {string} lessonId path The lesson ID.
   * @param {UpdateLessonRequest} [updateLessonRequest] The lesson update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsLessonIdPut(
    lessonId: string,
    updateLessonRequest?: UpdateLessonRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LessonsApiFp(this.configuration)
      .lessonsLessonIdPut(lessonId, updateLessonRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a note.
   * @param {string} noteId path The note ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsNotesNoteIdDelete(noteId: string, options?: RawAxiosRequestConfig) {
    return LessonsApiFp(this.configuration)
      .lessonsNotesNoteIdDelete(noteId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a note.
   * @param {string} noteId path The note ID.
   * @param {UpdateNoteRequest} [updateNoteRequest] The note update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsNotesNoteIdPut(
    noteId: string,
    updateNoteRequest?: UpdateNoteRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LessonsApiFp(this.configuration)
      .lessonsNotesNoteIdPut(noteId, updateNoteRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new lesson.
   * @param {CreateLessonRequest} [createLessonRequest] The lesson creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsPost(createLessonRequest?: CreateLessonRequest, options?: RawAxiosRequestConfig) {
    return LessonsApiFp(this.configuration)
      .lessonsPost(createLessonRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new recurring lesson schedule (and generate lessons).
   * @param {CreateLessonScheduleRequest} [createLessonScheduleRequest] The schedule creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsSchedulePost(
    createLessonScheduleRequest?: CreateLessonScheduleRequest,
    options?: RawAxiosRequestConfig
  ) {
    return LessonsApiFp(this.configuration)
      .lessonsSchedulePost(createLessonScheduleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get attendance summaries for lessons (with filters).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public lessonsSummaryGet(options?: RawAxiosRequestConfig) {
    return LessonsApiFp(this.configuration)
      .lessonsSummaryGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * MarkingScalesApi - axios parameter creator
 */
export const MarkingScalesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all available marking scales.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/marking-scales`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new marking scale.
     * @param {CreateScaleRequest} [createScaleRequest] The scale creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesPost: async (
      createScaleRequest?: CreateScaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/marking-scales`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createScaleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a marking scale.
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdDelete: async (
      scaleId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scaleId' is not null or undefined
      assertParamExists('markingScalesScaleIdDelete', 'scaleId', scaleId)
      const localVarPath = `/marking-scales/{scaleId}`.replace(
        `{${'scaleId'}}`,
        encodeURIComponent(String(scaleId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details for a specific marking scale by ID.
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdGet: async (
      scaleId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scaleId' is not null or undefined
      assertParamExists('markingScalesScaleIdGet', 'scaleId', scaleId)
      const localVarPath = `/marking-scales/{scaleId}`.replace(
        `{${'scaleId'}}`,
        encodeURIComponent(String(scaleId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a marking scale.
     * @param {string} scaleId path The scale ID.
     * @param {UpdateScaleRequest} [updateScaleRequest] The scale update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdPut: async (
      scaleId: string,
      updateScaleRequest?: UpdateScaleRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scaleId' is not null or undefined
      assertParamExists('markingScalesScaleIdPut', 'scaleId', scaleId)
      const localVarPath = `/marking-scales/{scaleId}`.replace(
        `{${'scaleId'}}`,
        encodeURIComponent(String(scaleId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateScaleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get usage count for a marking scale (how many assessments use it).
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdUsageGet: async (
      scaleId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scaleId' is not null or undefined
      assertParamExists('markingScalesScaleIdUsageGet', 'scaleId', scaleId)
      const localVarPath = `/marking-scales/{scaleId}/usage`.replace(
        `{${'scaleId'}}`,
        encodeURIComponent(String(scaleId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MarkingScalesApi - functional programming interface
 */
export const MarkingScalesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MarkingScalesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get all available marking scales.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async markingScalesGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Scale>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.markingScalesGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MarkingScalesApi.markingScalesGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new marking scale.
     * @param {CreateScaleRequest} [createScaleRequest] The scale creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async markingScalesPost(
      createScaleRequest?: CreateScaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.markingScalesPost(
        createScaleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MarkingScalesApi.markingScalesPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a marking scale.
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async markingScalesScaleIdDelete(
      scaleId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.markingScalesScaleIdDelete(
        scaleId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MarkingScalesApi.markingScalesScaleIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details for a specific marking scale by ID.
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async markingScalesScaleIdGet(
      scaleId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.markingScalesScaleIdGet(
        scaleId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MarkingScalesApi.markingScalesScaleIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a marking scale.
     * @param {string} scaleId path The scale ID.
     * @param {UpdateScaleRequest} [updateScaleRequest] The scale update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async markingScalesScaleIdPut(
      scaleId: string,
      updateScaleRequest?: UpdateScaleRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Scale>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.markingScalesScaleIdPut(
        scaleId,
        updateScaleRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MarkingScalesApi.markingScalesScaleIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get usage count for a marking scale (how many assessments use it).
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async markingScalesScaleIdUsageGet(
      scaleId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScaleUsageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.markingScalesScaleIdUsageGet(
        scaleId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MarkingScalesApi.markingScalesScaleIdUsageGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * MarkingScalesApi - factory interface
 */
export const MarkingScalesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MarkingScalesApiFp(configuration)
  return {
    /**
     *
     * @summary Get all available marking scales.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Scale>> {
      return localVarFp.markingScalesGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new marking scale.
     * @param {CreateScaleRequest} [createScaleRequest] The scale creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesPost(
      createScaleRequest?: CreateScaleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Scale> {
      return localVarFp
        .markingScalesPost(createScaleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a marking scale.
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdDelete(
      scaleId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .markingScalesScaleIdDelete(scaleId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details for a specific marking scale by ID.
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdGet(scaleId: string, options?: RawAxiosRequestConfig): AxiosPromise<Scale> {
      return localVarFp
        .markingScalesScaleIdGet(scaleId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a marking scale.
     * @param {string} scaleId path The scale ID.
     * @param {UpdateScaleRequest} [updateScaleRequest] The scale update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdPut(
      scaleId: string,
      updateScaleRequest?: UpdateScaleRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Scale> {
      return localVarFp
        .markingScalesScaleIdPut(scaleId, updateScaleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get usage count for a marking scale (how many assessments use it).
     * @param {string} scaleId path The scale ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markingScalesScaleIdUsageGet(
      scaleId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ScaleUsageResponse> {
      return localVarFp
        .markingScalesScaleIdUsageGet(scaleId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * MarkingScalesApi - object-oriented interface
 */
export class MarkingScalesApi extends BaseAPI {
  /**
   *
   * @summary Get all available marking scales.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public markingScalesGet(options?: RawAxiosRequestConfig) {
    return MarkingScalesApiFp(this.configuration)
      .markingScalesGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new marking scale.
   * @param {CreateScaleRequest} [createScaleRequest] The scale creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public markingScalesPost(
    createScaleRequest?: CreateScaleRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MarkingScalesApiFp(this.configuration)
      .markingScalesPost(createScaleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a marking scale.
   * @param {string} scaleId path The scale ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public markingScalesScaleIdDelete(scaleId: string, options?: RawAxiosRequestConfig) {
    return MarkingScalesApiFp(this.configuration)
      .markingScalesScaleIdDelete(scaleId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details for a specific marking scale by ID.
   * @param {string} scaleId path The scale ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public markingScalesScaleIdGet(scaleId: string, options?: RawAxiosRequestConfig) {
    return MarkingScalesApiFp(this.configuration)
      .markingScalesScaleIdGet(scaleId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a marking scale.
   * @param {string} scaleId path The scale ID.
   * @param {UpdateScaleRequest} [updateScaleRequest] The scale update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public markingScalesScaleIdPut(
    scaleId: string,
    updateScaleRequest?: UpdateScaleRequest,
    options?: RawAxiosRequestConfig
  ) {
    return MarkingScalesApiFp(this.configuration)
      .markingScalesScaleIdPut(scaleId, updateScaleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get usage count for a marking scale (how many assessments use it).
   * @param {string} scaleId path The scale ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public markingScalesScaleIdUsageGet(scaleId: string, options?: RawAxiosRequestConfig) {
    return MarkingScalesApiFp(this.configuration)
      .markingScalesScaleIdUsageGet(scaleId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PermissionsApi - axios parameter creator
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get default permissions for each role. Returns the system-defined default permissions for each role. Only accessible by admins.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    permissionsDefaultsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/permissions/defaults`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the current user\'s effective permissions. This endpoint returns the resolved set of permissions for the current user, taking into account their role, tenant type, and any overrides.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    permissionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/permissions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the tenant\'s permission overrides. Returns all custom permission overrides configured for this tenant. Only accessible by admins.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/tenant/permissions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Set a permission override for a role. Allows admins to grant or revoke specific permissions for roles. Cannot revoke permissions from Admin role.
     * @param {SetPermissionOverrideRequest} [setPermissionOverrideRequest] The override to set.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsPut: async (
      setPermissionOverrideRequest?: SetPermissionOverrideRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/tenant/permissions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        setPermissionOverrideRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset a role\'s permissions to defaults. Removes all overrides for a specific role, reverting to system defaults.
     * @param {string} role path The role name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsRoleDelete: async (
      role: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'role' is not null or undefined
      assertParamExists('tenantPermissionsRoleDelete', 'role', role)
      const localVarPath = `/tenant/permissions/{role}`.replace(
        `{${'role'}}`,
        encodeURIComponent(String(role))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a permission override, reverting to default.
     * @param {string} role path The role name.
     * @param {string} permission path The permission name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsRolePermissionDelete: async (
      role: string,
      permission: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'role' is not null or undefined
      assertParamExists('tenantPermissionsRolePermissionDelete', 'role', role)
      // verify required parameter 'permission' is not null or undefined
      assertParamExists('tenantPermissionsRolePermissionDelete', 'permission', permission)
      const localVarPath = `/tenant/permissions/{role}/{permission}`
        .replace(`{${'role'}}`, encodeURIComponent(String(role)))
        .replace(`{${'permission'}}`, encodeURIComponent(String(permission)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PermissionsApi - functional programming interface
 */
export const PermissionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get default permissions for each role. Returns the system-defined default permissions for each role. Only accessible by admins.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async permissionsDefaultsGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDefaultsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsDefaultsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.permissionsDefaultsGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the current user\'s effective permissions. This endpoint returns the resolved set of permissions for the current user, taking into account their role, tenant type, and any overrides.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async permissionsGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EffectivePermissionsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.permissionsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.permissionsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the tenant\'s permission overrides. Returns all custom permission overrides configured for this tenant. Only accessible by admins.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantPermissionsGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionOverridesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantPermissionsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.tenantPermissionsGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Set a permission override for a role. Allows admins to grant or revoke specific permissions for roles. Cannot revoke permissions from Admin role.
     * @param {SetPermissionOverrideRequest} [setPermissionOverrideRequest] The override to set.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantPermissionsPut(
      setPermissionOverrideRequest?: SetPermissionOverrideRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantPermissionsPut(
        setPermissionOverrideRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.tenantPermissionsPut']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Reset a role\'s permissions to defaults. Removes all overrides for a specific role, reverting to system defaults.
     * @param {string} role path The role name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantPermissionsRoleDelete(
      role: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RemovedCountResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantPermissionsRoleDelete(
        role,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.tenantPermissionsRoleDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a permission override, reverting to default.
     * @param {string} role path The role name.
     * @param {string} permission path The permission name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantPermissionsRolePermissionDelete(
      role: string,
      permission: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.tenantPermissionsRolePermissionDelete(
          role,
          permission,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PermissionsApi.tenantPermissionsRolePermissionDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PermissionsApi - factory interface
 */
export const PermissionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PermissionsApiFp(configuration)
  return {
    /**
     *
     * @summary Get default permissions for each role. Returns the system-defined default permissions for each role. Only accessible by admins.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    permissionsDefaultsGet(options?: RawAxiosRequestConfig): AxiosPromise<RoleDefaultsResponse> {
      return localVarFp.permissionsDefaultsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the current user\'s effective permissions. This endpoint returns the resolved set of permissions for the current user, taking into account their role, tenant type, and any overrides.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    permissionsGet(options?: RawAxiosRequestConfig): AxiosPromise<EffectivePermissionsResponse> {
      return localVarFp.permissionsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the tenant\'s permission overrides. Returns all custom permission overrides configured for this tenant. Only accessible by admins.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsGet(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PermissionOverridesResponse> {
      return localVarFp.tenantPermissionsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Set a permission override for a role. Allows admins to grant or revoke specific permissions for roles. Cannot revoke permissions from Admin role.
     * @param {SetPermissionOverrideRequest} [setPermissionOverrideRequest] The override to set.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsPut(
      setPermissionOverrideRequest?: SetPermissionOverrideRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponse> {
      return localVarFp
        .tenantPermissionsPut(setPermissionOverrideRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Reset a role\'s permissions to defaults. Removes all overrides for a specific role, reverting to system defaults.
     * @param {string} role path The role name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsRoleDelete(
      role: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RemovedCountResponse> {
      return localVarFp
        .tenantPermissionsRoleDelete(role, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a permission override, reverting to default.
     * @param {string} role path The role name.
     * @param {string} permission path The permission name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantPermissionsRolePermissionDelete(
      role: string,
      permission: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .tenantPermissionsRolePermissionDelete(role, permission, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PermissionsApi - object-oriented interface
 */
export class PermissionsApi extends BaseAPI {
  /**
   *
   * @summary Get default permissions for each role. Returns the system-defined default permissions for each role. Only accessible by admins.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public permissionsDefaultsGet(options?: RawAxiosRequestConfig) {
    return PermissionsApiFp(this.configuration)
      .permissionsDefaultsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the current user\'s effective permissions. This endpoint returns the resolved set of permissions for the current user, taking into account their role, tenant type, and any overrides.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public permissionsGet(options?: RawAxiosRequestConfig) {
    return PermissionsApiFp(this.configuration)
      .permissionsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the tenant\'s permission overrides. Returns all custom permission overrides configured for this tenant. Only accessible by admins.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantPermissionsGet(options?: RawAxiosRequestConfig) {
    return PermissionsApiFp(this.configuration)
      .tenantPermissionsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Set a permission override for a role. Allows admins to grant or revoke specific permissions for roles. Cannot revoke permissions from Admin role.
   * @param {SetPermissionOverrideRequest} [setPermissionOverrideRequest] The override to set.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantPermissionsPut(
    setPermissionOverrideRequest?: SetPermissionOverrideRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PermissionsApiFp(this.configuration)
      .tenantPermissionsPut(setPermissionOverrideRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Reset a role\'s permissions to defaults. Removes all overrides for a specific role, reverting to system defaults.
   * @param {string} role path The role name.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantPermissionsRoleDelete(role: string, options?: RawAxiosRequestConfig) {
    return PermissionsApiFp(this.configuration)
      .tenantPermissionsRoleDelete(role, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a permission override, reverting to default.
   * @param {string} role path The role name.
   * @param {string} permission path The permission name.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantPermissionsRolePermissionDelete(
    role: string,
    permission: string,
    options?: RawAxiosRequestConfig
  ) {
    return PermissionsApiFp(this.configuration)
      .tenantPermissionsRolePermissionDelete(role, permission, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PlanningApi - axios parameter creator
 */
export const PlanningApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete an activity.
     * @param {string} activityId path The activity ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningActivitiesActivityIdDelete: async (
      activityId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'activityId' is not null or undefined
      assertParamExists('planningActivitiesActivityIdDelete', 'activityId', activityId)
      const localVarPath = `/planning/activities/{activityId}`.replace(
        `{${'activityId'}}`,
        encodeURIComponent(String(activityId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get an activity by ID.
     * @param {string} activityId path The activity ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningActivitiesActivityIdGet: async (
      activityId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'activityId' is not null or undefined
      assertParamExists('planningActivitiesActivityIdGet', 'activityId', activityId)
      const localVarPath = `/planning/activities/{activityId}`.replace(
        `{${'activityId'}}`,
        encodeURIComponent(String(activityId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update an activity.
     * @param {string} activityId path The activity ID.
     * @param {UpdateActivityRequest} [updateActivityRequest] The activity update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningActivitiesActivityIdPut: async (
      activityId: string,
      updateActivityRequest?: UpdateActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'activityId' is not null or undefined
      assertParamExists('planningActivitiesActivityIdPut', 'activityId', activityId)
      const localVarPath = `/planning/activities/{activityId}`.replace(
        `{${'activityId'}}`,
        encodeURIComponent(String(activityId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Generate a full lesson plan with objectives and activities using AI (long-running job).
     * @param {string} lessonPlanId path The lesson plan ID to flesh out.
     * @param {GenerateLessonPlanRequest} [generateLessonPlanRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningAiLessonPlansLessonPlanIdGeneratePost: async (
      lessonPlanId: string,
      generateLessonPlanRequest?: GenerateLessonPlanRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonPlanId' is not null or undefined
      assertParamExists(
        'planningAiLessonPlansLessonPlanIdGeneratePost',
        'lessonPlanId',
        lessonPlanId
      )
      const localVarPath = `/planning/ai/lesson-plans/{lessonPlanId}/generate`.replace(
        `{${'lessonPlanId'}}`,
        encodeURIComponent(String(lessonPlanId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateLessonPlanRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Generate units for a scheme using AI (long-running job).
     * @param {string} schemeId path The scheme ID to generate units for.
     * @param {GenerateSchemeUnitsRequest} [generateSchemeUnitsRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningAiSchemesSchemeIdGenerateUnitsPost: async (
      schemeId: string,
      generateSchemeUnitsRequest?: GenerateSchemeUnitsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningAiSchemesSchemeIdGenerateUnitsPost', 'schemeId', schemeId)
      const localVarPath = `/planning/ai/schemes/{schemeId}/generate-units`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateSchemeUnitsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Generate lessons for a unit using AI (long-running job).
     * @param {string} unitId path The unit ID to generate lessons for.
     * @param {GenerateUnitLessonsRequest} [generateUnitLessonsRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningAiUnitsUnitIdGenerateLessonsPost: async (
      unitId: string,
      generateUnitLessonsRequest?: GenerateUnitLessonsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('planningAiUnitsUnitIdGenerateLessonsPost', 'unitId', unitId)
      const localVarPath = `/planning/ai/units/{unitId}/generate-lessons`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateUnitLessonsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List all activities for a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdActivitiesGet: async (
      lessonPlanId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonPlanId' is not null or undefined
      assertParamExists(
        'planningLessonPlansLessonPlanIdActivitiesGet',
        'lessonPlanId',
        lessonPlanId
      )
      const localVarPath = `/planning/lesson-plans/{lessonPlanId}/activities`.replace(
        `{${'lessonPlanId'}}`,
        encodeURIComponent(String(lessonPlanId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new activity in a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {CreateActivityRequest} [createActivityRequest] The activity creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdActivitiesPost: async (
      lessonPlanId: string,
      createActivityRequest?: CreateActivityRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonPlanId' is not null or undefined
      assertParamExists(
        'planningLessonPlansLessonPlanIdActivitiesPost',
        'lessonPlanId',
        lessonPlanId
      )
      const localVarPath = `/planning/lesson-plans/{lessonPlanId}/activities`.replace(
        `{${'lessonPlanId'}}`,
        encodeURIComponent(String(lessonPlanId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createActivityRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdDelete: async (
      lessonPlanId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonPlanId' is not null or undefined
      assertParamExists('planningLessonPlansLessonPlanIdDelete', 'lessonPlanId', lessonPlanId)
      const localVarPath = `/planning/lesson-plans/{lessonPlanId}`.replace(
        `{${'lessonPlanId'}}`,
        encodeURIComponent(String(lessonPlanId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a lesson plan by ID with objectives and activities.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdGet: async (
      lessonPlanId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonPlanId' is not null or undefined
      assertParamExists('planningLessonPlansLessonPlanIdGet', 'lessonPlanId', lessonPlanId)
      const localVarPath = `/planning/lesson-plans/{lessonPlanId}`.replace(
        `{${'lessonPlanId'}}`,
        encodeURIComponent(String(lessonPlanId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Add an objective to a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {CreateLessonObjectiveRequest} [createLessonObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdObjectivesPost: async (
      lessonPlanId: string,
      createLessonObjectiveRequest?: CreateLessonObjectiveRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonPlanId' is not null or undefined
      assertParamExists(
        'planningLessonPlansLessonPlanIdObjectivesPost',
        'lessonPlanId',
        lessonPlanId
      )
      const localVarPath = `/planning/lesson-plans/{lessonPlanId}/objectives`.replace(
        `{${'lessonPlanId'}}`,
        encodeURIComponent(String(lessonPlanId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createLessonObjectiveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {UpdateLessonPlanRequest} [updateLessonPlanRequest] The lesson plan update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdPut: async (
      lessonPlanId: string,
      updateLessonPlanRequest?: UpdateLessonPlanRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'lessonPlanId' is not null or undefined
      assertParamExists('planningLessonPlansLessonPlanIdPut', 'lessonPlanId', lessonPlanId)
      const localVarPath = `/planning/lesson-plans/{lessonPlanId}`.replace(
        `{${'lessonPlanId'}}`,
        encodeURIComponent(String(lessonPlanId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateLessonPlanRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete an objective (unit or lesson).
     * @param {string} objectiveId path The objective ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningObjectivesObjectiveIdDelete: async (
      objectiveId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'objectiveId' is not null or undefined
      assertParamExists('planningObjectivesObjectiveIdDelete', 'objectiveId', objectiveId)
      const localVarPath = `/planning/objectives/{objectiveId}`.replace(
        `{${'objectiveId'}}`,
        encodeURIComponent(String(objectiveId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a scheme objective.
     * @param {string} objectiveId path The objective ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemeObjectivesObjectiveIdDelete: async (
      objectiveId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'objectiveId' is not null or undefined
      assertParamExists('planningSchemeObjectivesObjectiveIdDelete', 'objectiveId', objectiveId)
      const localVarPath = `/planning/scheme-objectives/{objectiveId}`.replace(
        `{${'objectiveId'}}`,
        encodeURIComponent(String(objectiveId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a scheme topic.
     * @param {string} topicId path The topic ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemeTopicsTopicIdDelete: async (
      topicId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'topicId' is not null or undefined
      assertParamExists('planningSchemeTopicsTopicIdDelete', 'topicId', topicId)
      const localVarPath = `/planning/scheme-topics/{topicId}`.replace(
        `{${'topicId'}}`,
        encodeURIComponent(String(topicId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List all planning schemes for the tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/planning/schemes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new planning scheme.
     * @param {CreateSchemeRequest} [createSchemeRequest] The scheme creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesPost: async (
      createSchemeRequest?: CreateSchemeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/schemes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createSchemeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a planning scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdDelete: async (
      schemeId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdDelete', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Export a planning scheme to PDF, DOCX, or XLSX format.
     * @param {string} schemeId path The scheme ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdExportGet: async (
      schemeId: string,
      format?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdExportGet', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}/export`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (format !== undefined) {
        localVarQueryParameter['format'] = format
      }

      localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a planning scheme by ID with all its units.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdGet: async (
      schemeId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdGet', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Add an objective to a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateSchemeObjectiveRequest} [createSchemeObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdObjectivesPost: async (
      schemeId: string,
      createSchemeObjectiveRequest?: CreateSchemeObjectiveRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdObjectivesPost', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}/objectives`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createSchemeObjectiveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a planning scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {UpdateSchemeRequest} [updateSchemeRequest] The scheme update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdPut: async (
      schemeId: string,
      updateSchemeRequest?: UpdateSchemeRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdPut', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateSchemeRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Add a topic to a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateSchemeTopicRequest} [createSchemeTopicRequest] The topic creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdTopicsPost: async (
      schemeId: string,
      createSchemeTopicRequest?: CreateSchemeTopicRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdTopicsPost', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}/topics`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createSchemeTopicRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List all units for a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdUnitsGet: async (
      schemeId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdUnitsGet', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}/units`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new unit in a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateUnitRequest} [createUnitRequest] The unit creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdUnitsPost: async (
      schemeId: string,
      createUnitRequest?: CreateUnitRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'schemeId' is not null or undefined
      assertParamExists('planningSchemesSchemeIdUnitsPost', 'schemeId', schemeId)
      const localVarPath = `/planning/schemes/{schemeId}/units`.replace(
        `{${'schemeId'}}`,
        encodeURIComponent(String(schemeId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createUnitRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a unit.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdDelete: async (
      unitId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('planningUnitsUnitIdDelete', 'unitId', unitId)
      const localVarPath = `/planning/units/{unitId}`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a unit by ID.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdGet: async (
      unitId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('planningUnitsUnitIdGet', 'unitId', unitId)
      const localVarPath = `/planning/units/{unitId}`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List all lesson plans for a unit.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdLessonPlansGet: async (
      unitId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('planningUnitsUnitIdLessonPlansGet', 'unitId', unitId)
      const localVarPath = `/planning/units/{unitId}/lesson-plans`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new lesson plan in a unit.
     * @param {string} unitId path The unit ID.
     * @param {CreateLessonPlanRequest} [createLessonPlanRequest] The lesson plan creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdLessonPlansPost: async (
      unitId: string,
      createLessonPlanRequest?: CreateLessonPlanRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('planningUnitsUnitIdLessonPlansPost', 'unitId', unitId)
      const localVarPath = `/planning/units/{unitId}/lesson-plans`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createLessonPlanRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Add an objective to a unit.
     * @param {string} unitId path The unit ID.
     * @param {CreateUnitObjectiveRequest} [createUnitObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdObjectivesPost: async (
      unitId: string,
      createUnitObjectiveRequest?: CreateUnitObjectiveRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('planningUnitsUnitIdObjectivesPost', 'unitId', unitId)
      const localVarPath = `/planning/units/{unitId}/objectives`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createUnitObjectiveRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a unit.
     * @param {string} unitId path The unit ID.
     * @param {UpdateUnitRequest} [updateUnitRequest] The unit update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdPut: async (
      unitId: string,
      updateUnitRequest?: UpdateUnitRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('planningUnitsUnitIdPut', 'unitId', unitId)
      const localVarPath = `/planning/units/{unitId}`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUnitRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PlanningApi - functional programming interface
 */
export const PlanningApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Delete an activity.
     * @param {string} activityId path The activity ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningActivitiesActivityIdDelete(
      activityId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningActivitiesActivityIdDelete(
        activityId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningActivitiesActivityIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get an activity by ID.
     * @param {string} activityId path The activity ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningActivitiesActivityIdGet(
      activityId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonActivity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningActivitiesActivityIdGet(
        activityId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningActivitiesActivityIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update an activity.
     * @param {string} activityId path The activity ID.
     * @param {UpdateActivityRequest} [updateActivityRequest] The activity update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningActivitiesActivityIdPut(
      activityId: string,
      updateActivityRequest?: UpdateActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonActivity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningActivitiesActivityIdPut(
        activityId,
        updateActivityRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningActivitiesActivityIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Generate a full lesson plan with objectives and activities using AI (long-running job).
     * @param {string} lessonPlanId path The lesson plan ID to flesh out.
     * @param {GenerateLessonPlanRequest} [generateLessonPlanRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningAiLessonPlansLessonPlanIdGeneratePost(
      lessonPlanId: string,
      generateLessonPlanRequest?: GenerateLessonPlanRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningAiLessonPlansLessonPlanIdGeneratePost(
          lessonPlanId,
          generateLessonPlanRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningAiLessonPlansLessonPlanIdGeneratePost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Generate units for a scheme using AI (long-running job).
     * @param {string} schemeId path The scheme ID to generate units for.
     * @param {GenerateSchemeUnitsRequest} [generateSchemeUnitsRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningAiSchemesSchemeIdGenerateUnitsPost(
      schemeId: string,
      generateSchemeUnitsRequest?: GenerateSchemeUnitsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningAiSchemesSchemeIdGenerateUnitsPost(
          schemeId,
          generateSchemeUnitsRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningAiSchemesSchemeIdGenerateUnitsPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Generate lessons for a unit using AI (long-running job).
     * @param {string} unitId path The unit ID to generate lessons for.
     * @param {GenerateUnitLessonsRequest} [generateUnitLessonsRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningAiUnitsUnitIdGenerateLessonsPost(
      unitId: string,
      generateUnitLessonsRequest?: GenerateUnitLessonsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningAiUnitsUnitIdGenerateLessonsPost(
          unitId,
          generateUnitLessonsRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningAiUnitsUnitIdGenerateLessonsPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary List all activities for a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningLessonPlansLessonPlanIdActivitiesGet(
      lessonPlanId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LessonActivity>>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningLessonPlansLessonPlanIdActivitiesGet(
          lessonPlanId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningLessonPlansLessonPlanIdActivitiesGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new activity in a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {CreateActivityRequest} [createActivityRequest] The activity creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningLessonPlansLessonPlanIdActivitiesPost(
      lessonPlanId: string,
      createActivityRequest?: CreateActivityRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonActivity>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningLessonPlansLessonPlanIdActivitiesPost(
          lessonPlanId,
          createActivityRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningLessonPlansLessonPlanIdActivitiesPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningLessonPlansLessonPlanIdDelete(
      lessonPlanId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningLessonPlansLessonPlanIdDelete(lessonPlanId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningLessonPlansLessonPlanIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a lesson plan by ID with objectives and activities.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningLessonPlansLessonPlanIdGet(
      lessonPlanId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonPlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningLessonPlansLessonPlanIdGet(
        lessonPlanId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningLessonPlansLessonPlanIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add an objective to a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {CreateLessonObjectiveRequest} [createLessonObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningLessonPlansLessonPlanIdObjectivesPost(
      lessonPlanId: string,
      createLessonObjectiveRequest?: CreateLessonObjectiveRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonObjective>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningLessonPlansLessonPlanIdObjectivesPost(
          lessonPlanId,
          createLessonObjectiveRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningLessonPlansLessonPlanIdObjectivesPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {UpdateLessonPlanRequest} [updateLessonPlanRequest] The lesson plan update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningLessonPlansLessonPlanIdPut(
      lessonPlanId: string,
      updateLessonPlanRequest?: UpdateLessonPlanRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonPlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningLessonPlansLessonPlanIdPut(
        lessonPlanId,
        updateLessonPlanRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningLessonPlansLessonPlanIdPut']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete an objective (unit or lesson).
     * @param {string} objectiveId path The objective ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningObjectivesObjectiveIdDelete(
      objectiveId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningObjectivesObjectiveIdDelete(
        objectiveId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningObjectivesObjectiveIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a scheme objective.
     * @param {string} objectiveId path The objective ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemeObjectivesObjectiveIdDelete(
      objectiveId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningSchemeObjectivesObjectiveIdDelete(
          objectiveId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemeObjectivesObjectiveIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a scheme topic.
     * @param {string} topicId path The topic ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemeTopicsTopicIdDelete(
      topicId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemeTopicsTopicIdDelete(
        topicId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemeTopicsTopicIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary List all planning schemes for the tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanningSchemeOverview>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new planning scheme.
     * @param {CreateSchemeRequest} [createSchemeRequest] The scheme creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesPost(
      createSchemeRequest?: CreateSchemeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningScheme>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesPost(
        createSchemeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a planning scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdDelete(
      schemeId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesSchemeIdDelete(
        schemeId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Export a planning scheme to PDF, DOCX, or XLSX format.
     * @param {string} schemeId path The scheme ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdExportGet(
      schemeId: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesSchemeIdExportGet(
        schemeId,
        format,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdExportGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a planning scheme by ID with all its units.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdGet(
      schemeId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningScheme>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesSchemeIdGet(
        schemeId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add an objective to a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateSchemeObjectiveRequest} [createSchemeObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdObjectivesPost(
      schemeId: string,
      createSchemeObjectiveRequest?: CreateSchemeObjectiveRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchemeObjective>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.planningSchemesSchemeIdObjectivesPost(
          schemeId,
          createSchemeObjectiveRequest,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdObjectivesPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a planning scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {UpdateSchemeRequest} [updateSchemeRequest] The scheme update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdPut(
      schemeId: string,
      updateSchemeRequest?: UpdateSchemeRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningScheme>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesSchemeIdPut(
        schemeId,
        updateSchemeRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdPut']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add a topic to a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateSchemeTopicRequest} [createSchemeTopicRequest] The topic creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdTopicsPost(
      schemeId: string,
      createSchemeTopicRequest?: CreateSchemeTopicRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SchemeTopic>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesSchemeIdTopicsPost(
        schemeId,
        createSchemeTopicRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdTopicsPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary List all units for a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdUnitsGet(
      schemeId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlanningUnit>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesSchemeIdUnitsGet(
        schemeId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdUnitsGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new unit in a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateUnitRequest} [createUnitRequest] The unit creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningSchemesSchemeIdUnitsPost(
      schemeId: string,
      createUnitRequest?: CreateUnitRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningUnit>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningSchemesSchemeIdUnitsPost(
        schemeId,
        createUnitRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningSchemesSchemeIdUnitsPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a unit.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningUnitsUnitIdDelete(
      unitId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningUnitsUnitIdDelete(
        unitId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningUnitsUnitIdDelete']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a unit by ID.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningUnitsUnitIdGet(
      unitId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningUnit>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningUnitsUnitIdGet(
        unitId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningUnitsUnitIdGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary List all lesson plans for a unit.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningUnitsUnitIdLessonPlansGet(
      unitId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LessonPlanOverview>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningUnitsUnitIdLessonPlansGet(
        unitId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningUnitsUnitIdLessonPlansGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new lesson plan in a unit.
     * @param {string} unitId path The unit ID.
     * @param {CreateLessonPlanRequest} [createLessonPlanRequest] The lesson plan creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningUnitsUnitIdLessonPlansPost(
      unitId: string,
      createLessonPlanRequest?: CreateLessonPlanRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LessonPlan>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningUnitsUnitIdLessonPlansPost(
        unitId,
        createLessonPlanRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningUnitsUnitIdLessonPlansPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Add an objective to a unit.
     * @param {string} unitId path The unit ID.
     * @param {CreateUnitObjectiveRequest} [createUnitObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningUnitsUnitIdObjectivesPost(
      unitId: string,
      createUnitObjectiveRequest?: CreateUnitObjectiveRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnitObjective>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningUnitsUnitIdObjectivesPost(
        unitId,
        createUnitObjectiveRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningUnitsUnitIdObjectivesPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a unit.
     * @param {string} unitId path The unit ID.
     * @param {UpdateUnitRequest} [updateUnitRequest] The unit update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async planningUnitsUnitIdPut(
      unitId: string,
      updateUnitRequest?: UpdateUnitRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanningUnit>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.planningUnitsUnitIdPut(
        unitId,
        updateUnitRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PlanningApi.planningUnitsUnitIdPut']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PlanningApi - factory interface
 */
export const PlanningApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PlanningApiFp(configuration)
  return {
    /**
     *
     * @summary Delete an activity.
     * @param {string} activityId path The activity ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningActivitiesActivityIdDelete(
      activityId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .planningActivitiesActivityIdDelete(activityId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get an activity by ID.
     * @param {string} activityId path The activity ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningActivitiesActivityIdGet(
      activityId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LessonActivity> {
      return localVarFp
        .planningActivitiesActivityIdGet(activityId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update an activity.
     * @param {string} activityId path The activity ID.
     * @param {UpdateActivityRequest} [updateActivityRequest] The activity update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningActivitiesActivityIdPut(
      activityId: string,
      updateActivityRequest?: UpdateActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LessonActivity> {
      return localVarFp
        .planningActivitiesActivityIdPut(activityId, updateActivityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Generate a full lesson plan with objectives and activities using AI (long-running job).
     * @param {string} lessonPlanId path The lesson plan ID to flesh out.
     * @param {GenerateLessonPlanRequest} [generateLessonPlanRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningAiLessonPlansLessonPlanIdGeneratePost(
      lessonPlanId: string,
      generateLessonPlanRequest?: GenerateLessonPlanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<{ [key: string]: string }> {
      return localVarFp
        .planningAiLessonPlansLessonPlanIdGeneratePost(
          lessonPlanId,
          generateLessonPlanRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Generate units for a scheme using AI (long-running job).
     * @param {string} schemeId path The scheme ID to generate units for.
     * @param {GenerateSchemeUnitsRequest} [generateSchemeUnitsRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningAiSchemesSchemeIdGenerateUnitsPost(
      schemeId: string,
      generateSchemeUnitsRequest?: GenerateSchemeUnitsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<{ [key: string]: string }> {
      return localVarFp
        .planningAiSchemesSchemeIdGenerateUnitsPost(schemeId, generateSchemeUnitsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Generate lessons for a unit using AI (long-running job).
     * @param {string} unitId path The unit ID to generate lessons for.
     * @param {GenerateUnitLessonsRequest} [generateUnitLessonsRequest] Generation parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningAiUnitsUnitIdGenerateLessonsPost(
      unitId: string,
      generateUnitLessonsRequest?: GenerateUnitLessonsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<{ [key: string]: string }> {
      return localVarFp
        .planningAiUnitsUnitIdGenerateLessonsPost(unitId, generateUnitLessonsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary List all activities for a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdActivitiesGet(
      lessonPlanId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<LessonActivity>> {
      return localVarFp
        .planningLessonPlansLessonPlanIdActivitiesGet(lessonPlanId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new activity in a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {CreateActivityRequest} [createActivityRequest] The activity creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdActivitiesPost(
      lessonPlanId: string,
      createActivityRequest?: CreateActivityRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LessonActivity> {
      return localVarFp
        .planningLessonPlansLessonPlanIdActivitiesPost(lessonPlanId, createActivityRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdDelete(
      lessonPlanId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .planningLessonPlansLessonPlanIdDelete(lessonPlanId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a lesson plan by ID with objectives and activities.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdGet(
      lessonPlanId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LessonPlan> {
      return localVarFp
        .planningLessonPlansLessonPlanIdGet(lessonPlanId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Add an objective to a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {CreateLessonObjectiveRequest} [createLessonObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdObjectivesPost(
      lessonPlanId: string,
      createLessonObjectiveRequest?: CreateLessonObjectiveRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LessonObjective> {
      return localVarFp
        .planningLessonPlansLessonPlanIdObjectivesPost(
          lessonPlanId,
          createLessonObjectiveRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a lesson plan.
     * @param {string} lessonPlanId path The lesson plan ID.
     * @param {UpdateLessonPlanRequest} [updateLessonPlanRequest] The lesson plan update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningLessonPlansLessonPlanIdPut(
      lessonPlanId: string,
      updateLessonPlanRequest?: UpdateLessonPlanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LessonPlan> {
      return localVarFp
        .planningLessonPlansLessonPlanIdPut(lessonPlanId, updateLessonPlanRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete an objective (unit or lesson).
     * @param {string} objectiveId path The objective ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningObjectivesObjectiveIdDelete(
      objectiveId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .planningObjectivesObjectiveIdDelete(objectiveId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a scheme objective.
     * @param {string} objectiveId path The objective ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemeObjectivesObjectiveIdDelete(
      objectiveId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .planningSchemeObjectivesObjectiveIdDelete(objectiveId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a scheme topic.
     * @param {string} topicId path The topic ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemeTopicsTopicIdDelete(
      topicId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .planningSchemeTopicsTopicIdDelete(topicId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary List all planning schemes for the tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesGet(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<PlanningSchemeOverview>> {
      return localVarFp.planningSchemesGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new planning scheme.
     * @param {CreateSchemeRequest} [createSchemeRequest] The scheme creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesPost(
      createSchemeRequest?: CreateSchemeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlanningScheme> {
      return localVarFp
        .planningSchemesPost(createSchemeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a planning scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdDelete(
      schemeId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .planningSchemesSchemeIdDelete(schemeId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Export a planning scheme to PDF, DOCX, or XLSX format.
     * @param {string} schemeId path The scheme ID.
     * @param {string} [format] query The export format (pdf, docx, xlsx).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdExportGet(
      schemeId: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .planningSchemesSchemeIdExportGet(schemeId, format, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a planning scheme by ID with all its units.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdGet(
      schemeId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlanningScheme> {
      return localVarFp
        .planningSchemesSchemeIdGet(schemeId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Add an objective to a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateSchemeObjectiveRequest} [createSchemeObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdObjectivesPost(
      schemeId: string,
      createSchemeObjectiveRequest?: CreateSchemeObjectiveRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SchemeObjective> {
      return localVarFp
        .planningSchemesSchemeIdObjectivesPost(schemeId, createSchemeObjectiveRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a planning scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {UpdateSchemeRequest} [updateSchemeRequest] The scheme update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdPut(
      schemeId: string,
      updateSchemeRequest?: UpdateSchemeRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlanningScheme> {
      return localVarFp
        .planningSchemesSchemeIdPut(schemeId, updateSchemeRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Add a topic to a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateSchemeTopicRequest} [createSchemeTopicRequest] The topic creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdTopicsPost(
      schemeId: string,
      createSchemeTopicRequest?: CreateSchemeTopicRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SchemeTopic> {
      return localVarFp
        .planningSchemesSchemeIdTopicsPost(schemeId, createSchemeTopicRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary List all units for a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdUnitsGet(
      schemeId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<PlanningUnit>> {
      return localVarFp
        .planningSchemesSchemeIdUnitsGet(schemeId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new unit in a scheme.
     * @param {string} schemeId path The scheme ID.
     * @param {CreateUnitRequest} [createUnitRequest] The unit creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningSchemesSchemeIdUnitsPost(
      schemeId: string,
      createUnitRequest?: CreateUnitRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlanningUnit> {
      return localVarFp
        .planningSchemesSchemeIdUnitsPost(schemeId, createUnitRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a unit.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdDelete(unitId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .planningUnitsUnitIdDelete(unitId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a unit by ID.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdGet(
      unitId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlanningUnit> {
      return localVarFp
        .planningUnitsUnitIdGet(unitId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary List all lesson plans for a unit.
     * @param {string} unitId path The unit ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdLessonPlansGet(
      unitId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<LessonPlanOverview>> {
      return localVarFp
        .planningUnitsUnitIdLessonPlansGet(unitId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new lesson plan in a unit.
     * @param {string} unitId path The unit ID.
     * @param {CreateLessonPlanRequest} [createLessonPlanRequest] The lesson plan creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdLessonPlansPost(
      unitId: string,
      createLessonPlanRequest?: CreateLessonPlanRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<LessonPlan> {
      return localVarFp
        .planningUnitsUnitIdLessonPlansPost(unitId, createLessonPlanRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Add an objective to a unit.
     * @param {string} unitId path The unit ID.
     * @param {CreateUnitObjectiveRequest} [createUnitObjectiveRequest] The objective creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdObjectivesPost(
      unitId: string,
      createUnitObjectiveRequest?: CreateUnitObjectiveRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UnitObjective> {
      return localVarFp
        .planningUnitsUnitIdObjectivesPost(unitId, createUnitObjectiveRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a unit.
     * @param {string} unitId path The unit ID.
     * @param {UpdateUnitRequest} [updateUnitRequest] The unit update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    planningUnitsUnitIdPut(
      unitId: string,
      updateUnitRequest?: UpdateUnitRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<PlanningUnit> {
      return localVarFp
        .planningUnitsUnitIdPut(unitId, updateUnitRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PlanningApi - object-oriented interface
 */
export class PlanningApi extends BaseAPI {
  /**
   *
   * @summary Delete an activity.
   * @param {string} activityId path The activity ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningActivitiesActivityIdDelete(activityId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningActivitiesActivityIdDelete(activityId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get an activity by ID.
   * @param {string} activityId path The activity ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningActivitiesActivityIdGet(activityId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningActivitiesActivityIdGet(activityId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update an activity.
   * @param {string} activityId path The activity ID.
   * @param {UpdateActivityRequest} [updateActivityRequest] The activity update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningActivitiesActivityIdPut(
    activityId: string,
    updateActivityRequest?: UpdateActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningActivitiesActivityIdPut(activityId, updateActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Generate a full lesson plan with objectives and activities using AI (long-running job).
   * @param {string} lessonPlanId path The lesson plan ID to flesh out.
   * @param {GenerateLessonPlanRequest} [generateLessonPlanRequest] Generation parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningAiLessonPlansLessonPlanIdGeneratePost(
    lessonPlanId: string,
    generateLessonPlanRequest?: GenerateLessonPlanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningAiLessonPlansLessonPlanIdGeneratePost(
        lessonPlanId,
        generateLessonPlanRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Generate units for a scheme using AI (long-running job).
   * @param {string} schemeId path The scheme ID to generate units for.
   * @param {GenerateSchemeUnitsRequest} [generateSchemeUnitsRequest] Generation parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningAiSchemesSchemeIdGenerateUnitsPost(
    schemeId: string,
    generateSchemeUnitsRequest?: GenerateSchemeUnitsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningAiSchemesSchemeIdGenerateUnitsPost(schemeId, generateSchemeUnitsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Generate lessons for a unit using AI (long-running job).
   * @param {string} unitId path The unit ID to generate lessons for.
   * @param {GenerateUnitLessonsRequest} [generateUnitLessonsRequest] Generation parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningAiUnitsUnitIdGenerateLessonsPost(
    unitId: string,
    generateUnitLessonsRequest?: GenerateUnitLessonsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningAiUnitsUnitIdGenerateLessonsPost(unitId, generateUnitLessonsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary List all activities for a lesson plan.
   * @param {string} lessonPlanId path The lesson plan ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningLessonPlansLessonPlanIdActivitiesGet(
    lessonPlanId: string,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningLessonPlansLessonPlanIdActivitiesGet(lessonPlanId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new activity in a lesson plan.
   * @param {string} lessonPlanId path The lesson plan ID.
   * @param {CreateActivityRequest} [createActivityRequest] The activity creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningLessonPlansLessonPlanIdActivitiesPost(
    lessonPlanId: string,
    createActivityRequest?: CreateActivityRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningLessonPlansLessonPlanIdActivitiesPost(lessonPlanId, createActivityRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a lesson plan.
   * @param {string} lessonPlanId path The lesson plan ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningLessonPlansLessonPlanIdDelete(
    lessonPlanId: string,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningLessonPlansLessonPlanIdDelete(lessonPlanId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a lesson plan by ID with objectives and activities.
   * @param {string} lessonPlanId path The lesson plan ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningLessonPlansLessonPlanIdGet(lessonPlanId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningLessonPlansLessonPlanIdGet(lessonPlanId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add an objective to a lesson plan.
   * @param {string} lessonPlanId path The lesson plan ID.
   * @param {CreateLessonObjectiveRequest} [createLessonObjectiveRequest] The objective creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningLessonPlansLessonPlanIdObjectivesPost(
    lessonPlanId: string,
    createLessonObjectiveRequest?: CreateLessonObjectiveRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningLessonPlansLessonPlanIdObjectivesPost(
        lessonPlanId,
        createLessonObjectiveRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a lesson plan.
   * @param {string} lessonPlanId path The lesson plan ID.
   * @param {UpdateLessonPlanRequest} [updateLessonPlanRequest] The lesson plan update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningLessonPlansLessonPlanIdPut(
    lessonPlanId: string,
    updateLessonPlanRequest?: UpdateLessonPlanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningLessonPlansLessonPlanIdPut(lessonPlanId, updateLessonPlanRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete an objective (unit or lesson).
   * @param {string} objectiveId path The objective ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningObjectivesObjectiveIdDelete(objectiveId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningObjectivesObjectiveIdDelete(objectiveId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a scheme objective.
   * @param {string} objectiveId path The objective ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemeObjectivesObjectiveIdDelete(
    objectiveId: string,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningSchemeObjectivesObjectiveIdDelete(objectiveId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a scheme topic.
   * @param {string} topicId path The topic ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemeTopicsTopicIdDelete(topicId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningSchemeTopicsTopicIdDelete(topicId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary List all planning schemes for the tenant.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesGet(options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningSchemesGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new planning scheme.
   * @param {CreateSchemeRequest} [createSchemeRequest] The scheme creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesPost(
    createSchemeRequest?: CreateSchemeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningSchemesPost(createSchemeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a planning scheme.
   * @param {string} schemeId path The scheme ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdDelete(schemeId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdDelete(schemeId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Export a planning scheme to PDF, DOCX, or XLSX format.
   * @param {string} schemeId path The scheme ID.
   * @param {string} [format] query The export format (pdf, docx, xlsx).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdExportGet(
    schemeId: string,
    format?: string,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdExportGet(schemeId, format, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a planning scheme by ID with all its units.
   * @param {string} schemeId path The scheme ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdGet(schemeId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdGet(schemeId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add an objective to a scheme.
   * @param {string} schemeId path The scheme ID.
   * @param {CreateSchemeObjectiveRequest} [createSchemeObjectiveRequest] The objective creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdObjectivesPost(
    schemeId: string,
    createSchemeObjectiveRequest?: CreateSchemeObjectiveRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdObjectivesPost(schemeId, createSchemeObjectiveRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a planning scheme.
   * @param {string} schemeId path The scheme ID.
   * @param {UpdateSchemeRequest} [updateSchemeRequest] The scheme update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdPut(
    schemeId: string,
    updateSchemeRequest?: UpdateSchemeRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdPut(schemeId, updateSchemeRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add a topic to a scheme.
   * @param {string} schemeId path The scheme ID.
   * @param {CreateSchemeTopicRequest} [createSchemeTopicRequest] The topic creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdTopicsPost(
    schemeId: string,
    createSchemeTopicRequest?: CreateSchemeTopicRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdTopicsPost(schemeId, createSchemeTopicRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary List all units for a scheme.
   * @param {string} schemeId path The scheme ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdUnitsGet(schemeId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdUnitsGet(schemeId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new unit in a scheme.
   * @param {string} schemeId path The scheme ID.
   * @param {CreateUnitRequest} [createUnitRequest] The unit creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningSchemesSchemeIdUnitsPost(
    schemeId: string,
    createUnitRequest?: CreateUnitRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningSchemesSchemeIdUnitsPost(schemeId, createUnitRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a unit.
   * @param {string} unitId path The unit ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningUnitsUnitIdDelete(unitId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningUnitsUnitIdDelete(unitId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a unit by ID.
   * @param {string} unitId path The unit ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningUnitsUnitIdGet(unitId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningUnitsUnitIdGet(unitId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary List all lesson plans for a unit.
   * @param {string} unitId path The unit ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningUnitsUnitIdLessonPlansGet(unitId: string, options?: RawAxiosRequestConfig) {
    return PlanningApiFp(this.configuration)
      .planningUnitsUnitIdLessonPlansGet(unitId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new lesson plan in a unit.
   * @param {string} unitId path The unit ID.
   * @param {CreateLessonPlanRequest} [createLessonPlanRequest] The lesson plan creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningUnitsUnitIdLessonPlansPost(
    unitId: string,
    createLessonPlanRequest?: CreateLessonPlanRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningUnitsUnitIdLessonPlansPost(unitId, createLessonPlanRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Add an objective to a unit.
   * @param {string} unitId path The unit ID.
   * @param {CreateUnitObjectiveRequest} [createUnitObjectiveRequest] The objective creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningUnitsUnitIdObjectivesPost(
    unitId: string,
    createUnitObjectiveRequest?: CreateUnitObjectiveRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningUnitsUnitIdObjectivesPost(unitId, createUnitObjectiveRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a unit.
   * @param {string} unitId path The unit ID.
   * @param {UpdateUnitRequest} [updateUnitRequest] The unit update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public planningUnitsUnitIdPut(
    unitId: string,
    updateUnitRequest?: UpdateUnitRequest,
    options?: RawAxiosRequestConfig
  ) {
    return PlanningApiFp(this.configuration)
      .planningUnitsUnitIdPut(unitId, updateUnitRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * RelationsApi - axios parameter creator
 */
export const RelationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all relations (parents, guardians, etc.).
     * @param {string} [studentId] query Optional filter by student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsGet: async (
      studentId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/relations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (studentId !== undefined) {
        localVarQueryParameter['studentId'] = studentId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new relation (not yet linked to any student).
     * @param {CreateRelationRequest} [createRelationRequest] The relation creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsPost: async (
      createRelationRequest?: CreateRelationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/relations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRelationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a relation (will also remove student links).
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsRelationIdDelete: async (
      relationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'relationId' is not null or undefined
      assertParamExists('relationsRelationIdDelete', 'relationId', relationId)
      const localVarPath = `/relations/{relationId}`.replace(
        `{${'relationId'}}`,
        encodeURIComponent(String(relationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details of a specific relation.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsRelationIdGet: async (
      relationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'relationId' is not null or undefined
      assertParamExists('relationsRelationIdGet', 'relationId', relationId)
      const localVarPath = `/relations/{relationId}`.replace(
        `{${'relationId'}}`,
        encodeURIComponent(String(relationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all students linked to a relation.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsRelationIdStudentsGet: async (
      relationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'relationId' is not null or undefined
      assertParamExists('relationsRelationIdStudentsGet', 'relationId', relationId)
      const localVarPath = `/relations/{relationId}/students`.replace(
        `{${'relationId'}}`,
        encodeURIComponent(String(relationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all relations linked to a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdRelationsGet: async (
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdRelationsGet', 'studentId', studentId)
      const localVarPath = `/students/{studentId}/relations`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Link an existing relation OR create new and link in one shot.
     * @param {string} studentId path The student ID.
     * @param {CreateStudentRelationRequest} [createStudentRelationRequest] The relation link request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdRelationsPost: async (
      studentId: string,
      createStudentRelationRequest?: CreateStudentRelationRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdRelationsPost', 'studentId', studentId)
      const localVarPath = `/students/{studentId}/relations`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStudentRelationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Unlink a relation from a student.
     * @param {string} studentId path The student ID.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdRelationsRelationIdDelete: async (
      studentId: string,
      relationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdRelationsRelationIdDelete', 'studentId', studentId)
      // verify required parameter 'relationId' is not null or undefined
      assertParamExists('studentsStudentIdRelationsRelationIdDelete', 'relationId', relationId)
      const localVarPath = `/students/{studentId}/relations/{relationId}`
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
        .replace(`{${'relationId'}}`, encodeURIComponent(String(relationId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RelationsApi - functional programming interface
 */
export const RelationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RelationsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get all relations (parents, guardians, etc.).
     * @param {string} [studentId] query Optional filter by student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async relationsGet(
      studentId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Relation>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.relationsGet(studentId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.relationsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new relation (not yet linked to any student).
     * @param {CreateRelationRequest} [createRelationRequest] The relation creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async relationsPost(
      createRelationRequest?: CreateRelationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.relationsPost(
        createRelationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.relationsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a relation (will also remove student links).
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async relationsRelationIdDelete(
      relationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.relationsRelationIdDelete(
        relationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.relationsRelationIdDelete']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details of a specific relation.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async relationsRelationIdGet(
      relationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Relation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.relationsRelationIdGet(
        relationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.relationsRelationIdGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all students linked to a relation.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async relationsRelationIdStudentsGet(
      relationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Student>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.relationsRelationIdStudentsGet(
        relationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.relationsRelationIdStudentsGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all relations linked to a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdRelationsGet(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StudentRelation>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsStudentIdRelationsGet(
        studentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.studentsStudentIdRelationsGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Link an existing relation OR create new and link in one shot.
     * @param {string} studentId path The student ID.
     * @param {CreateStudentRelationRequest} [createStudentRelationRequest] The relation link request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdRelationsPost(
      studentId: string,
      createStudentRelationRequest?: CreateStudentRelationRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsStudentIdRelationsPost(
        studentId,
        createStudentRelationRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.studentsStudentIdRelationsPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Unlink a relation from a student.
     * @param {string} studentId path The student ID.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdRelationsRelationIdDelete(
      studentId: string,
      relationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.studentsStudentIdRelationsRelationIdDelete(
          studentId,
          relationId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RelationsApi.studentsStudentIdRelationsRelationIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * RelationsApi - factory interface
 */
export const RelationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RelationsApiFp(configuration)
  return {
    /**
     *
     * @summary Get all relations (parents, guardians, etc.).
     * @param {string} [studentId] query Optional filter by student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsGet(
      studentId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Relation>> {
      return localVarFp.relationsGet(studentId, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new relation (not yet linked to any student).
     * @param {CreateRelationRequest} [createRelationRequest] The relation creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsPost(
      createRelationRequest?: CreateRelationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .relationsPost(createRelationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a relation (will also remove student links).
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsRelationIdDelete(
      relationId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .relationsRelationIdDelete(relationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details of a specific relation.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsRelationIdGet(
      relationId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Relation> {
      return localVarFp
        .relationsRelationIdGet(relationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all students linked to a relation.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    relationsRelationIdStudentsGet(
      relationId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Student>> {
      return localVarFp
        .relationsRelationIdStudentsGet(relationId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all relations linked to a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdRelationsGet(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<StudentRelation>> {
      return localVarFp
        .studentsStudentIdRelationsGet(studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Link an existing relation OR create new and link in one shot.
     * @param {string} studentId path The student ID.
     * @param {CreateStudentRelationRequest} [createStudentRelationRequest] The relation link request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdRelationsPost(
      studentId: string,
      createStudentRelationRequest?: CreateStudentRelationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .studentsStudentIdRelationsPost(studentId, createStudentRelationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Unlink a relation from a student.
     * @param {string} studentId path The student ID.
     * @param {string} relationId path The relation ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdRelationsRelationIdDelete(
      studentId: string,
      relationId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .studentsStudentIdRelationsRelationIdDelete(studentId, relationId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * RelationsApi - object-oriented interface
 */
export class RelationsApi extends BaseAPI {
  /**
   *
   * @summary Get all relations (parents, guardians, etc.).
   * @param {string} [studentId] query Optional filter by student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public relationsGet(studentId?: string, options?: RawAxiosRequestConfig) {
    return RelationsApiFp(this.configuration)
      .relationsGet(studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new relation (not yet linked to any student).
   * @param {CreateRelationRequest} [createRelationRequest] The relation creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public relationsPost(
    createRelationRequest?: CreateRelationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RelationsApiFp(this.configuration)
      .relationsPost(createRelationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a relation (will also remove student links).
   * @param {string} relationId path The relation ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public relationsRelationIdDelete(relationId: string, options?: RawAxiosRequestConfig) {
    return RelationsApiFp(this.configuration)
      .relationsRelationIdDelete(relationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details of a specific relation.
   * @param {string} relationId path The relation ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public relationsRelationIdGet(relationId: string, options?: RawAxiosRequestConfig) {
    return RelationsApiFp(this.configuration)
      .relationsRelationIdGet(relationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all students linked to a relation.
   * @param {string} relationId path The relation ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public relationsRelationIdStudentsGet(relationId: string, options?: RawAxiosRequestConfig) {
    return RelationsApiFp(this.configuration)
      .relationsRelationIdStudentsGet(relationId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all relations linked to a student.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdRelationsGet(studentId: string, options?: RawAxiosRequestConfig) {
    return RelationsApiFp(this.configuration)
      .studentsStudentIdRelationsGet(studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Link an existing relation OR create new and link in one shot.
   * @param {string} studentId path The student ID.
   * @param {CreateStudentRelationRequest} [createStudentRelationRequest] The relation link request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdRelationsPost(
    studentId: string,
    createStudentRelationRequest?: CreateStudentRelationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return RelationsApiFp(this.configuration)
      .studentsStudentIdRelationsPost(studentId, createStudentRelationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Unlink a relation from a student.
   * @param {string} studentId path The student ID.
   * @param {string} relationId path The relation ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdRelationsRelationIdDelete(
    studentId: string,
    relationId: string,
    options?: RawAxiosRequestConfig
  ) {
    return RelationsApiFp(this.configuration)
      .studentsStudentIdRelationsRelationIdDelete(studentId, relationId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ReportsApi - axios parameter creator
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get class reports, with optional term filter.
     * @param {string} classId path The class ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdReportsGet: async (
      classId: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdReportsGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/reports`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Export a student\'s report card as PDF, Word, or Excel.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {string} [format] query Export format: pdf, docx, or xlsx (default: pdf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdReportCardExportGet: async (
      classId: string,
      studentId: string,
      termId?: string,
      format?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdReportCardExportGet', 'classId', classId)
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists(
        'classesClassIdStudentsStudentIdReportCardExportGet',
        'studentId',
        studentId
      )
      const localVarPath = `/classes/{classId}/students/{studentId}/report-card/export`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      if (format !== undefined) {
        localVarQueryParameter['format'] = format
      }

      localVarHeaderParameter['Accept'] = 'application/octet-stream,application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a student\'s complete report card including grades and attendance.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdReportCardGet: async (
      classId: string,
      studentId: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdReportCardGet', 'classId', classId)
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdReportCardGet', 'studentId', studentId)
      const localVarPath = `/classes/{classId}/students/{studentId}/report-card`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a student\'s report in a class, with full context.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdReportGet: async (
      classId: string,
      studentId: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdReportGet', 'classId', classId)
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('classesClassIdStudentsStudentIdReportGet', 'studentId', studentId)
      const localVarPath = `/classes/{classId}/students/{studentId}/report`
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all reports with optional filters.
     * @param {string} [classId] query Optional filter by class ID.
     * @param {string} [studentId] query Optional filter by student ID(s).
     * @param {string} [termId] query Optional filter by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsGet: async (
      classId?: string,
      studentId?: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/reports`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (classId !== undefined) {
        localVarQueryParameter['classId'] = classId
      }

      if (studentId !== undefined) {
        localVarQueryParameter['studentId'] = studentId
      }

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Generate one or more reports (long-running job).
     * @param {GenerateReportsRequest} [generateReportsRequest] The report generation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsPost: async (
      generateReportsRequest?: GenerateReportsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/reports`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateReportsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a report\'s comment (manual edit).
     * @param {string} reportId path The report ID.
     * @param {UpdateReportCommentRequest} [updateReportCommentRequest] The updated comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsReportIdCommentPatch: async (
      reportId: string,
      updateReportCommentRequest?: UpdateReportCommentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('reportsReportIdCommentPatch', 'reportId', reportId)
      const localVarPath = `/reports/{reportId}/comment`.replace(
        `{${'reportId'}}`,
        encodeURIComponent(String(reportId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateReportCommentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a specific report (hard delete).
     * @param {string} reportId path The report ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsReportIdDelete: async (
      reportId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('reportsReportIdDelete', 'reportId', reportId)
      const localVarPath = `/reports/{reportId}`.replace(
        `{${'reportId'}}`,
        encodeURIComponent(String(reportId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get details of a specific report.
     * @param {string} reportId path The report ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsReportIdGet: async (
      reportId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'reportId' is not null or undefined
      assertParamExists('reportsReportIdGet', 'reportId', reportId)
      const localVarPath = `/reports/{reportId}`.replace(
        `{${'reportId'}}`,
        encodeURIComponent(String(reportId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ReportsApi - functional programming interface
 */
export const ReportsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get class reports, with optional term filter.
     * @param {string} classId path The class ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdReportsGet(
      classId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClassReportResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdReportsGet(
        classId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.classesClassIdReportsGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Export a student\'s report card as PDF, Word, or Excel.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {string} [format] query Export format: pdf, docx, or xlsx (default: pdf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsStudentIdReportCardExportGet(
      classId: string,
      studentId: string,
      termId?: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.classesClassIdStudentsStudentIdReportCardExportGet(
          classId,
          studentId,
          termId,
          format,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.classesClassIdStudentsStudentIdReportCardExportGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a student\'s complete report card including grades and attendance.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsStudentIdReportCardGet(
      classId: string,
      studentId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentReportCard>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.classesClassIdStudentsStudentIdReportCardGet(
          classId,
          studentId,
          termId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.classesClassIdStudentsStudentIdReportCardGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a student\'s report in a class, with full context.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdStudentsStudentIdReportGet(
      classId: string,
      studentId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentReportContextResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.classesClassIdStudentsStudentIdReportGet(
          classId,
          studentId,
          termId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.classesClassIdStudentsStudentIdReportGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all reports with optional filters.
     * @param {string} [classId] query Optional filter by class ID.
     * @param {string} [studentId] query Optional filter by student ID(s).
     * @param {string} [termId] query Optional filter by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportsGet(
      classId?: string,
      studentId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportsGet(
        classId,
        studentId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.reportsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Generate one or more reports (long-running job).
     * @param {GenerateReportsRequest} [generateReportsRequest] The report generation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportsPost(
      generateReportsRequest?: GenerateReportsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string }>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportsPost(
        generateReportsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.reportsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a report\'s comment (manual edit).
     * @param {string} reportId path The report ID.
     * @param {UpdateReportCommentRequest} [updateReportCommentRequest] The updated comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportsReportIdCommentPatch(
      reportId: string,
      updateReportCommentRequest?: UpdateReportCommentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportsReportIdCommentPatch(
        reportId,
        updateReportCommentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.reportsReportIdCommentPatch']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a specific report (hard delete).
     * @param {string} reportId path The report ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportsReportIdDelete(
      reportId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportsReportIdDelete(
        reportId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.reportsReportIdDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get details of a specific report.
     * @param {string} reportId path The report ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportsReportIdGet(
      reportId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportsReportIdGet(
        reportId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ReportsApi.reportsReportIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ReportsApi - factory interface
 */
export const ReportsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ReportsApiFp(configuration)
  return {
    /**
     *
     * @summary Get class reports, with optional term filter.
     * @param {string} classId path The class ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdReportsGet(
      classId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ClassReportResponse> {
      return localVarFp
        .classesClassIdReportsGet(classId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Export a student\'s report card as PDF, Word, or Excel.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {string} [format] query Export format: pdf, docx, or xlsx (default: pdf).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdReportCardExportGet(
      classId: string,
      studentId: string,
      termId?: string,
      format?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .classesClassIdStudentsStudentIdReportCardExportGet(
          classId,
          studentId,
          termId,
          format,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a student\'s complete report card including grades and attendance.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdReportCardGet(
      classId: string,
      studentId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<StudentReportCard> {
      return localVarFp
        .classesClassIdStudentsStudentIdReportCardGet(classId, studentId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a student\'s report in a class, with full context.
     * @param {string} classId path The class ID.
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdStudentsStudentIdReportGet(
      classId: string,
      studentId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<StudentReportContextResponse> {
      return localVarFp
        .classesClassIdStudentsStudentIdReportGet(classId, studentId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all reports with optional filters.
     * @param {string} [classId] query Optional filter by class ID.
     * @param {string} [studentId] query Optional filter by student ID(s).
     * @param {string} [termId] query Optional filter by term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsGet(
      classId?: string,
      studentId?: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ReportsResponse> {
      return localVarFp
        .reportsGet(classId, studentId, termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Generate one or more reports (long-running job).
     * @param {GenerateReportsRequest} [generateReportsRequest] The report generation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsPost(
      generateReportsRequest?: GenerateReportsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<{ [key: string]: string }> {
      return localVarFp
        .reportsPost(generateReportsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a report\'s comment (manual edit).
     * @param {string} reportId path The report ID.
     * @param {UpdateReportCommentRequest} [updateReportCommentRequest] The updated comment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsReportIdCommentPatch(
      reportId: string,
      updateReportCommentRequest?: UpdateReportCommentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .reportsReportIdCommentPatch(reportId, updateReportCommentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a specific report (hard delete).
     * @param {string} reportId path The report ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsReportIdDelete(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .reportsReportIdDelete(reportId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get details of a specific report.
     * @param {string} reportId path The report ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportsReportIdGet(reportId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
      return localVarFp
        .reportsReportIdGet(reportId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ReportsApi - object-oriented interface
 */
export class ReportsApi extends BaseAPI {
  /**
   *
   * @summary Get class reports, with optional term filter.
   * @param {string} classId path The class ID.
   * @param {string} [termId] query Optional term ID filter.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdReportsGet(
    classId: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ReportsApiFp(this.configuration)
      .classesClassIdReportsGet(classId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Export a student\'s report card as PDF, Word, or Excel.
   * @param {string} classId path The class ID.
   * @param {string} studentId path The student ID.
   * @param {string} [termId] query Optional term ID filter.
   * @param {string} [format] query Export format: pdf, docx, or xlsx (default: pdf).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsStudentIdReportCardExportGet(
    classId: string,
    studentId: string,
    termId?: string,
    format?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ReportsApiFp(this.configuration)
      .classesClassIdStudentsStudentIdReportCardExportGet(
        classId,
        studentId,
        termId,
        format,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a student\'s complete report card including grades and attendance.
   * @param {string} classId path The class ID.
   * @param {string} studentId path The student ID.
   * @param {string} [termId] query Optional term ID filter.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsStudentIdReportCardGet(
    classId: string,
    studentId: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ReportsApiFp(this.configuration)
      .classesClassIdStudentsStudentIdReportCardGet(classId, studentId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a student\'s report in a class, with full context.
   * @param {string} classId path The class ID.
   * @param {string} studentId path The student ID.
   * @param {string} [termId] query Optional term ID filter.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdStudentsStudentIdReportGet(
    classId: string,
    studentId: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ReportsApiFp(this.configuration)
      .classesClassIdStudentsStudentIdReportGet(classId, studentId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all reports with optional filters.
   * @param {string} [classId] query Optional filter by class ID.
   * @param {string} [studentId] query Optional filter by student ID(s).
   * @param {string} [termId] query Optional filter by term ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reportsGet(
    classId?: string,
    studentId?: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ReportsApiFp(this.configuration)
      .reportsGet(classId, studentId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Generate one or more reports (long-running job).
   * @param {GenerateReportsRequest} [generateReportsRequest] The report generation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reportsPost(
    generateReportsRequest?: GenerateReportsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ReportsApiFp(this.configuration)
      .reportsPost(generateReportsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a report\'s comment (manual edit).
   * @param {string} reportId path The report ID.
   * @param {UpdateReportCommentRequest} [updateReportCommentRequest] The updated comment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reportsReportIdCommentPatch(
    reportId: string,
    updateReportCommentRequest?: UpdateReportCommentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return ReportsApiFp(this.configuration)
      .reportsReportIdCommentPatch(reportId, updateReportCommentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a specific report (hard delete).
   * @param {string} reportId path The report ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reportsReportIdDelete(reportId: string, options?: RawAxiosRequestConfig) {
    return ReportsApiFp(this.configuration)
      .reportsReportIdDelete(reportId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get details of a specific report.
   * @param {string} reportId path The report ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reportsReportIdGet(reportId: string, options?: RawAxiosRequestConfig) {
    return ReportsApiFp(this.configuration)
      .reportsReportIdGet(reportId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ScheduleApi - axios parameter creator
 */
export const ScheduleApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get the teacher\'s schedule (lessons and/or assignments).
     * @param {string} [from] query Optional: Start date (YYYY-MM-DD). Defaults to start of current week.
     * @param {string} [to] query Optional: End date (YYYY-MM-DD). Defaults to end of current week.
     * @param {string} [include] query Optional: Comma-separated list of item types to include (lessons, assignments). Defaults to both.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleGet: async (
      from?: string,
      to?: string,
      include?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/schedule`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (from !== undefined) {
        localVarQueryParameter['from'] = from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = to
      }

      if (include !== undefined) {
        localVarQueryParameter['include'] = include
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ScheduleApi - functional programming interface
 */
export const ScheduleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ScheduleApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get the teacher\'s schedule (lessons and/or assignments).
     * @param {string} [from] query Optional: Start date (YYYY-MM-DD). Defaults to start of current week.
     * @param {string} [to] query Optional: End date (YYYY-MM-DD). Defaults to end of current week.
     * @param {string} [include] query Optional: Comma-separated list of item types to include (lessons, assignments). Defaults to both.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async scheduleGet(
      from?: string,
      to?: string,
      include?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScheduleResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleGet(
        from,
        to,
        include,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['ScheduleApi.scheduleGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * ScheduleApi - factory interface
 */
export const ScheduleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ScheduleApiFp(configuration)
  return {
    /**
     *
     * @summary Get the teacher\'s schedule (lessons and/or assignments).
     * @param {string} [from] query Optional: Start date (YYYY-MM-DD). Defaults to start of current week.
     * @param {string} [to] query Optional: End date (YYYY-MM-DD). Defaults to end of current week.
     * @param {string} [include] query Optional: Comma-separated list of item types to include (lessons, assignments). Defaults to both.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleGet(
      from?: string,
      to?: string,
      include?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<ScheduleResponse> {
      return localVarFp
        .scheduleGet(from, to, include, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ScheduleApi - object-oriented interface
 */
export class ScheduleApi extends BaseAPI {
  /**
   *
   * @summary Get the teacher\'s schedule (lessons and/or assignments).
   * @param {string} [from] query Optional: Start date (YYYY-MM-DD). Defaults to start of current week.
   * @param {string} [to] query Optional: End date (YYYY-MM-DD). Defaults to end of current week.
   * @param {string} [include] query Optional: Comma-separated list of item types to include (lessons, assignments). Defaults to both.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public scheduleGet(
    from?: string,
    to?: string,
    include?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .scheduleGet(from, to, include, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SearchApi - axios parameter creator
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Global search across students, classes, planning schemes, and assignments.
     * @param {string} [q] query The search query string.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchGet: async (q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (q !== undefined) {
        localVarQueryParameter['q'] = q
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SearchApi - functional programming interface
 */
export const SearchApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Global search across students, classes, planning schemes, and assignments.
     * @param {string} [q] query The search query string.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchGet(
      q?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalSearchResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchGet(q, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SearchApi.searchGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SearchApi - factory interface
 */
export const SearchApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SearchApiFp(configuration)
  return {
    /**
     *
     * @summary Global search across students, classes, planning schemes, and assignments.
     * @param {string} [q] query The search query string.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchGet(q?: string, options?: RawAxiosRequestConfig): AxiosPromise<GlobalSearchResponse> {
      return localVarFp.searchGet(q, options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * SearchApi - object-oriented interface
 */
export class SearchApi extends BaseAPI {
  /**
   *
   * @summary Global search across students, classes, planning schemes, and assignments.
   * @param {string} [q] query The search query string.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public searchGet(q?: string, options?: RawAxiosRequestConfig) {
    return SearchApiFp(this.configuration)
      .searchGet(q, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SettingsApi - axios parameter creator
 */
export const SettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all tenant settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a setting.
     * @param {string} key path The setting key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsKeyDelete: async (
      key: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'key' is not null or undefined
      assertParamExists('settingsKeyDelete', 'key', key)
      const localVarPath = `/settings/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a specific setting by key.
     * @param {string} key path The setting key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsKeyGet: async (
      key: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'key' is not null or undefined
      assertParamExists('settingsKeyGet', 'key', key)
      const localVarPath = `/settings/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'text/plain'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a specific setting.
     * @param {string} key path The setting key.
     * @param {UpdateSettingRequest} [updateSettingRequest] The new value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsKeyPut: async (
      key: string,
      updateSettingRequest?: UpdateSettingRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'key' is not null or undefined
      assertParamExists('settingsKeyPut', 'key', key)
      const localVarPath = `/settings/{key}`.replace(`{${'key'}}`, encodeURIComponent(String(key)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateSettingRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update multiple settings at once.
     * @param {UpdateSettingsRequest} [updateSettingsRequest] The settings to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsPut: async (
      updateSettingsRequest?: UpdateSettingsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/settings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateSettingsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SettingsApi - functional programming interface
 */
export const SettingsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SettingsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get all tenant settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async settingsGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.settingsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SettingsApi.settingsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a setting.
     * @param {string} key path The setting key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async settingsKeyDelete(
      key: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.settingsKeyDelete(key, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SettingsApi.settingsKeyDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a specific setting by key.
     * @param {string} key path The setting key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async settingsKeyGet(
      key: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.settingsKeyGet(key, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SettingsApi.settingsKeyGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a specific setting.
     * @param {string} key path The setting key.
     * @param {UpdateSettingRequest} [updateSettingRequest] The new value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async settingsKeyPut(
      key: string,
      updateSettingRequest?: UpdateSettingRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.settingsKeyPut(
        key,
        updateSettingRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SettingsApi.settingsKeyPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update multiple settings at once.
     * @param {UpdateSettingsRequest} [updateSettingsRequest] The settings to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async settingsPut(
      updateSettingsRequest?: UpdateSettingsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.settingsPut(
        updateSettingsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SettingsApi.settingsPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SettingsApi - factory interface
 */
export const SettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SettingsApiFp(configuration)
  return {
    /**
     *
     * @summary Get all tenant settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsGet(options?: RawAxiosRequestConfig): AxiosPromise<TenantSettings> {
      return localVarFp.settingsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a setting.
     * @param {string} key path The setting key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsKeyDelete(key: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.settingsKeyDelete(key, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a specific setting by key.
     * @param {string} key path The setting key.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsKeyGet(key: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
      return localVarFp.settingsKeyGet(key, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a specific setting.
     * @param {string} key path The setting key.
     * @param {UpdateSettingRequest} [updateSettingRequest] The new value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsKeyPut(
      key: string,
      updateSettingRequest?: UpdateSettingRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TenantSettings> {
      return localVarFp
        .settingsKeyPut(key, updateSettingRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update multiple settings at once.
     * @param {UpdateSettingsRequest} [updateSettingsRequest] The settings to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsPut(
      updateSettingsRequest?: UpdateSettingsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TenantSettings> {
      return localVarFp
        .settingsPut(updateSettingsRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * SettingsApi - object-oriented interface
 */
export class SettingsApi extends BaseAPI {
  /**
   *
   * @summary Get all tenant settings.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public settingsGet(options?: RawAxiosRequestConfig) {
    return SettingsApiFp(this.configuration)
      .settingsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a setting.
   * @param {string} key path The setting key.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public settingsKeyDelete(key: string, options?: RawAxiosRequestConfig) {
    return SettingsApiFp(this.configuration)
      .settingsKeyDelete(key, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a specific setting by key.
   * @param {string} key path The setting key.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public settingsKeyGet(key: string, options?: RawAxiosRequestConfig) {
    return SettingsApiFp(this.configuration)
      .settingsKeyGet(key, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a specific setting.
   * @param {string} key path The setting key.
   * @param {UpdateSettingRequest} [updateSettingRequest] The new value.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public settingsKeyPut(
    key: string,
    updateSettingRequest?: UpdateSettingRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SettingsApiFp(this.configuration)
      .settingsKeyPut(key, updateSettingRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update multiple settings at once.
   * @param {UpdateSettingsRequest} [updateSettingsRequest] The settings to update.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public settingsPut(
    updateSettingsRequest?: UpdateSettingsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SettingsApiFp(this.configuration)
      .settingsPut(updateSettingsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * StudentsApi - axios parameter creator
 */
export const StudentsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create multiple students in a batch.
     * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] The batch of students to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsBatchPost: async (
      createStudentsBatchRequest?: CreateStudentsBatchRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/students/batch`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStudentsBatchRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get students with upcoming birthdays (next 2 weeks).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsBirthdaysUpcomingGet: async (
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/students/birthdays/upcoming`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all students for the current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/students`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new student.
     * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsPost: async (
      createStudentRequest?: CreateStudentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/students`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStudentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Search for students by name or other criteria.
     * @param {string} [q] query Optional search query.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsSearchGet: async (
      q?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/students/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (q !== undefined) {
        localVarQueryParameter['q'] = q
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get academic overview for a student including overall attendance and per-class summaries.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdAcademicOverviewGet: async (
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdAcademicOverviewGet', 'studentId', studentId)
      const localVarPath = `/students/{studentId}/academic-overview`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdDelete: async (
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdDelete', 'studentId', studentId)
      const localVarPath = `/students/{studentId}`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a specific student by ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdGet: async (
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdGet', 'studentId', studentId)
      const localVarPath = `/students/{studentId}`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload a profile photo for a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdImagesUploadPost: async (
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdImagesUploadPost', 'studentId', studentId)
      const localVarPath = `/students/{studentId}/images/upload`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update an existing student.
     * @param {string} studentId path The student ID.
     * @param {UpdateStudentRequest} [updateStudentRequest] The student update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdPut: async (
      studentId: string,
      updateStudentRequest?: UpdateStudentRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdPut', 'studentId', studentId)
      const localVarPath = `/students/{studentId}`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateStudentRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a report for a student (with optional term filter).
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdReportGet: async (
      studentId: string,
      termId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists('studentsStudentIdReportGet', 'studentId', studentId)
      const localVarPath = `/students/{studentId}/report`.replace(
        `{${'studentId'}}`,
        encodeURIComponent(String(studentId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (termId !== undefined) {
        localVarQueryParameter['termId'] = termId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * StudentsApi - functional programming interface
 */
export const StudentsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = StudentsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Create multiple students in a batch.
     * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] The batch of students to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsBatchPost(
      createStudentsBatchRequest?: CreateStudentsBatchRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Student>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsBatchPost(
        createStudentsBatchRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsBatchPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get students with upcoming birthdays (next 2 weeks).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsBirthdaysUpcomingGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpcomingBirthdaysResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.studentsBirthdaysUpcomingGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsBirthdaysUpcomingGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all students for the current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Student>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new student.
     * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsPost(
      createStudentRequest?: CreateStudentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Student>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsPost(
        createStudentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Search for students by name or other criteria.
     * @param {string} [q] query Optional search query.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsSearchGet(
      q?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Student>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsSearchGet(q, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsSearchGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get academic overview for a student including overall attendance and per-class summaries.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdAcademicOverviewGet(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudentAcademicOverviewResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.studentsStudentIdAcademicOverviewGet(studentId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsStudentIdAcademicOverviewGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdDelete(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsStudentIdDelete(
        studentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsStudentIdDelete']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a specific student by ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdGet(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Student>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsStudentIdGet(
        studentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsStudentIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Upload a profile photo for a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdImagesUploadPost(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsStudentIdImagesUploadPost(
        studentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsStudentIdImagesUploadPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update an existing student.
     * @param {string} studentId path The student ID.
     * @param {UpdateStudentRequest} [updateStudentRequest] The student update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdPut(
      studentId: string,
      updateStudentRequest?: UpdateStudentRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Student>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsStudentIdPut(
        studentId,
        updateStudentRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsStudentIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a report for a student (with optional term filter).
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async studentsStudentIdReportGet(
      studentId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.studentsStudentIdReportGet(
        studentId,
        termId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StudentsApi.studentsStudentIdReportGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * StudentsApi - factory interface
 */
export const StudentsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = StudentsApiFp(configuration)
  return {
    /**
     *
     * @summary Create multiple students in a batch.
     * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] The batch of students to create.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsBatchPost(
      createStudentsBatchRequest?: CreateStudentsBatchRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Student>> {
      return localVarFp
        .studentsBatchPost(createStudentsBatchRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get students with upcoming birthdays (next 2 weeks).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsBirthdaysUpcomingGet(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<UpcomingBirthdaysResponse> {
      return localVarFp
        .studentsBirthdaysUpcomingGet(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all students for the current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Student>> {
      return localVarFp.studentsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new student.
     * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsPost(
      createStudentRequest?: CreateStudentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Student> {
      return localVarFp
        .studentsPost(createStudentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Search for students by name or other criteria.
     * @param {string} [q] query Optional search query.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsSearchGet(q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Student>> {
      return localVarFp.studentsSearchGet(q, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get academic overview for a student including overall attendance and per-class summaries.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdAcademicOverviewGet(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<StudentAcademicOverviewResponse> {
      return localVarFp
        .studentsStudentIdAcademicOverviewGet(studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdDelete(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .studentsStudentIdDelete(studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a specific student by ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdGet(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Student> {
      return localVarFp
        .studentsStudentIdGet(studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Upload a profile photo for a student.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdImagesUploadPost(
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .studentsStudentIdImagesUploadPost(studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update an existing student.
     * @param {string} studentId path The student ID.
     * @param {UpdateStudentRequest} [updateStudentRequest] The student update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdPut(
      studentId: string,
      updateStudentRequest?: UpdateStudentRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Student> {
      return localVarFp
        .studentsStudentIdPut(studentId, updateStudentRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a report for a student (with optional term filter).
     * @param {string} studentId path The student ID.
     * @param {string} [termId] query Optional term ID to filter by.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    studentsStudentIdReportGet(
      studentId: string,
      termId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<any> {
      return localVarFp
        .studentsStudentIdReportGet(studentId, termId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * StudentsApi - object-oriented interface
 */
export class StudentsApi extends BaseAPI {
  /**
   *
   * @summary Create multiple students in a batch.
   * @param {CreateStudentsBatchRequest} [createStudentsBatchRequest] The batch of students to create.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsBatchPost(
    createStudentsBatchRequest?: CreateStudentsBatchRequest,
    options?: RawAxiosRequestConfig
  ) {
    return StudentsApiFp(this.configuration)
      .studentsBatchPost(createStudentsBatchRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get students with upcoming birthdays (next 2 weeks).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsBirthdaysUpcomingGet(options?: RawAxiosRequestConfig) {
    return StudentsApiFp(this.configuration)
      .studentsBirthdaysUpcomingGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all students for the current tenant.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsGet(options?: RawAxiosRequestConfig) {
    return StudentsApiFp(this.configuration)
      .studentsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new student.
   * @param {CreateStudentRequest} [createStudentRequest] The student creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsPost(
    createStudentRequest?: CreateStudentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return StudentsApiFp(this.configuration)
      .studentsPost(createStudentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Search for students by name or other criteria.
   * @param {string} [q] query Optional search query.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsSearchGet(q?: string, options?: RawAxiosRequestConfig) {
    return StudentsApiFp(this.configuration)
      .studentsSearchGet(q, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get academic overview for a student including overall attendance and per-class summaries.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdAcademicOverviewGet(studentId: string, options?: RawAxiosRequestConfig) {
    return StudentsApiFp(this.configuration)
      .studentsStudentIdAcademicOverviewGet(studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a student.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdDelete(studentId: string, options?: RawAxiosRequestConfig) {
    return StudentsApiFp(this.configuration)
      .studentsStudentIdDelete(studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a specific student by ID.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdGet(studentId: string, options?: RawAxiosRequestConfig) {
    return StudentsApiFp(this.configuration)
      .studentsStudentIdGet(studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Upload a profile photo for a student.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdImagesUploadPost(studentId: string, options?: RawAxiosRequestConfig) {
    return StudentsApiFp(this.configuration)
      .studentsStudentIdImagesUploadPost(studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update an existing student.
   * @param {string} studentId path The student ID.
   * @param {UpdateStudentRequest} [updateStudentRequest] The student update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdPut(
    studentId: string,
    updateStudentRequest?: UpdateStudentRequest,
    options?: RawAxiosRequestConfig
  ) {
    return StudentsApiFp(this.configuration)
      .studentsStudentIdPut(studentId, updateStudentRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a report for a student (with optional term filter).
   * @param {string} studentId path The student ID.
   * @param {string} [termId] query Optional term ID to filter by.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public studentsStudentIdReportGet(
    studentId: string,
    termId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return StudentsApiFp(this.configuration)
      .studentsStudentIdReportGet(studentId, termId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SubmissionsApi - axios parameter creator
 */
export const SubmissionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Upload a file submission for a student on an assignment.
     * @param {string} assignmentId path The assignment ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdStudentsStudentIdSubmissionsPost: async (
      assignmentId: string,
      studentId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists(
        'assignmentsAssignmentIdStudentsStudentIdSubmissionsPost',
        'assignmentId',
        assignmentId
      )
      // verify required parameter 'studentId' is not null or undefined
      assertParamExists(
        'assignmentsAssignmentIdStudentsStudentIdSubmissionsPost',
        'studentId',
        studentId
      )
      const localVarPath = `/assignments/{assignmentId}/students/{studentId}/submissions`
        .replace(`{${'assignmentId'}}`, encodeURIComponent(String(assignmentId)))
        .replace(`{${'studentId'}}`, encodeURIComponent(String(studentId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List submissions with optional filters.
     * @param {string} [assignmentId] query Optional assignment ID filter.
     * @param {string} [studentId] query Optional student ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submissionsGet: async (
      assignmentId?: string,
      studentId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/submissions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (assignmentId !== undefined) {
        localVarQueryParameter['assignmentId'] = assignmentId
      }

      if (studentId !== undefined) {
        localVarQueryParameter['studentId'] = studentId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a submission (removes DB record and GCS blob).
     * @param {string} submissionId path The submission ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submissionsSubmissionIdDelete: async (
      submissionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'submissionId' is not null or undefined
      assertParamExists('submissionsSubmissionIdDelete', 'submissionId', submissionId)
      const localVarPath = `/submissions/{submissionId}`.replace(
        `{${'submissionId'}}`,
        encodeURIComponent(String(submissionId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a single submission by ID.
     * @param {string} submissionId path The submission ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submissionsSubmissionIdGet: async (
      submissionId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'submissionId' is not null or undefined
      assertParamExists('submissionsSubmissionIdGet', 'submissionId', submissionId)
      const localVarPath = `/submissions/{submissionId}`.replace(
        `{${'submissionId'}}`,
        encodeURIComponent(String(submissionId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SubmissionsApi - functional programming interface
 */
export const SubmissionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SubmissionsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Upload a file submission for a student on an assignment.
     * @param {string} assignmentId path The assignment ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignmentsAssignmentIdStudentsStudentIdSubmissionsPost(
      assignmentId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.assignmentsAssignmentIdStudentsStudentIdSubmissionsPost(
          assignmentId,
          studentId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'SubmissionsApi.assignmentsAssignmentIdStudentsStudentIdSubmissionsPost'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary List submissions with optional filters.
     * @param {string} [assignmentId] query Optional assignment ID filter.
     * @param {string} [studentId] query Optional student ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async submissionsGet(
      assignmentId?: string,
      studentId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubmissionResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsGet(
        assignmentId,
        studentId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SubmissionsApi.submissionsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a submission (removes DB record and GCS blob).
     * @param {string} submissionId path The submission ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async submissionsSubmissionIdDelete(
      submissionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsSubmissionIdDelete(
        submissionId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SubmissionsApi.submissionsSubmissionIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a single submission by ID.
     * @param {string} submissionId path The submission ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async submissionsSubmissionIdGet(
      submissionId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.submissionsSubmissionIdGet(
        submissionId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SubmissionsApi.submissionsSubmissionIdGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SubmissionsApi - factory interface
 */
export const SubmissionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SubmissionsApiFp(configuration)
  return {
    /**
     *
     * @summary Upload a file submission for a student on an assignment.
     * @param {string} assignmentId path The assignment ID.
     * @param {string} studentId path The student ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignmentsAssignmentIdStudentsStudentIdSubmissionsPost(
      assignmentId: string,
      studentId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .assignmentsAssignmentIdStudentsStudentIdSubmissionsPost(assignmentId, studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary List submissions with optional filters.
     * @param {string} [assignmentId] query Optional assignment ID filter.
     * @param {string} [studentId] query Optional student ID filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submissionsGet(
      assignmentId?: string,
      studentId?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<SubmissionResponse>> {
      return localVarFp
        .submissionsGet(assignmentId, studentId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a submission (removes DB record and GCS blob).
     * @param {string} submissionId path The submission ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submissionsSubmissionIdDelete(
      submissionId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .submissionsSubmissionIdDelete(submissionId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a single submission by ID.
     * @param {string} submissionId path The submission ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submissionsSubmissionIdGet(
      submissionId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SubmissionResponse> {
      return localVarFp
        .submissionsSubmissionIdGet(submissionId, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * SubmissionsApi - object-oriented interface
 */
export class SubmissionsApi extends BaseAPI {
  /**
   *
   * @summary Upload a file submission for a student on an assignment.
   * @param {string} assignmentId path The assignment ID.
   * @param {string} studentId path The student ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignmentsAssignmentIdStudentsStudentIdSubmissionsPost(
    assignmentId: string,
    studentId: string,
    options?: RawAxiosRequestConfig
  ) {
    return SubmissionsApiFp(this.configuration)
      .assignmentsAssignmentIdStudentsStudentIdSubmissionsPost(assignmentId, studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary List submissions with optional filters.
   * @param {string} [assignmentId] query Optional assignment ID filter.
   * @param {string} [studentId] query Optional student ID filter.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public submissionsGet(
    assignmentId?: string,
    studentId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return SubmissionsApiFp(this.configuration)
      .submissionsGet(assignmentId, studentId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a submission (removes DB record and GCS blob).
   * @param {string} submissionId path The submission ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public submissionsSubmissionIdDelete(submissionId: string, options?: RawAxiosRequestConfig) {
    return SubmissionsApiFp(this.configuration)
      .submissionsSubmissionIdDelete(submissionId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a single submission by ID.
   * @param {string} submissionId path The submission ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public submissionsSubmissionIdGet(submissionId: string, options?: RawAxiosRequestConfig) {
    return SubmissionsApiFp(this.configuration)
      .submissionsSubmissionIdGet(submissionId, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SubscriptionsApi - axios parameter creator
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create a Stripe checkout session for web subscriptions.
     * @param {CreateCheckoutRequest} [createCheckoutRequest] The checkout configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stripeCheckoutPost: async (
      createCheckoutRequest?: CreateCheckoutRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/stripe/checkout`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCheckoutRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the current subscription status for the authenticated user. Returns whether the user has premium access and subscription details if any. Checks tenant-level subscription first, then falls back to user-level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionsStatusGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/subscriptions/status`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Verify and sync a subscription purchase from the client. Called when: - User makes a new purchase on the client - App starts up and has an existing purchase to sync The server becomes the source of truth for subscription status.
     * @param {VerifySubscriptionRequest} [verifySubscriptionRequest] The purchase details to verify and sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionsVerifyPost: async (
      verifySubscriptionRequest?: VerifySubscriptionRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/subscriptions/verify`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        verifySubscriptionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SubscriptionsApi - functional programming interface
 */
export const SubscriptionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Create a Stripe checkout session for web subscriptions.
     * @param {CreateCheckoutRequest} [createCheckoutRequest] The checkout configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async stripeCheckoutPost(
      createCheckoutRequest?: CreateCheckoutRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.stripeCheckoutPost(
        createCheckoutRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.stripeCheckoutPost']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the current subscription status for the authenticated user. Returns whether the user has premium access and subscription details if any. Checks tenant-level subscription first, then falls back to user-level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscriptionsStatusGet(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionStatusResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsStatusGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.subscriptionsStatusGet']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Verify and sync a subscription purchase from the client. Called when: - User makes a new purchase on the client - App starts up and has an existing purchase to sync The server becomes the source of truth for subscription status.
     * @param {VerifySubscriptionRequest} [verifySubscriptionRequest] The purchase details to verify and sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscriptionsVerifyPost(
      verifySubscriptionRequest?: VerifySubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionStatusResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.subscriptionsVerifyPost(
        verifySubscriptionRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SubscriptionsApi.subscriptionsVerifyPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SubscriptionsApi - factory interface
 */
export const SubscriptionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SubscriptionsApiFp(configuration)
  return {
    /**
     *
     * @summary Create a Stripe checkout session for web subscriptions.
     * @param {CreateCheckoutRequest} [createCheckoutRequest] The checkout configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    stripeCheckoutPost(
      createCheckoutRequest?: CreateCheckoutRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CheckoutResponse> {
      return localVarFp
        .stripeCheckoutPost(createCheckoutRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the current subscription status for the authenticated user. Returns whether the user has premium access and subscription details if any. Checks tenant-level subscription first, then falls back to user-level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionsStatusGet(
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SubscriptionStatusResponse> {
      return localVarFp.subscriptionsStatusGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Verify and sync a subscription purchase from the client. Called when: - User makes a new purchase on the client - App starts up and has an existing purchase to sync The server becomes the source of truth for subscription status.
     * @param {VerifySubscriptionRequest} [verifySubscriptionRequest] The purchase details to verify and sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscriptionsVerifyPost(
      verifySubscriptionRequest?: VerifySubscriptionRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SubscriptionStatusResponse> {
      return localVarFp
        .subscriptionsVerifyPost(verifySubscriptionRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * SubscriptionsApi - object-oriented interface
 */
export class SubscriptionsApi extends BaseAPI {
  /**
   *
   * @summary Create a Stripe checkout session for web subscriptions.
   * @param {CreateCheckoutRequest} [createCheckoutRequest] The checkout configuration
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public stripeCheckoutPost(
    createCheckoutRequest?: CreateCheckoutRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .stripeCheckoutPost(createCheckoutRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the current subscription status for the authenticated user. Returns whether the user has premium access and subscription details if any. Checks tenant-level subscription first, then falls back to user-level.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public subscriptionsStatusGet(options?: RawAxiosRequestConfig) {
    return SubscriptionsApiFp(this.configuration)
      .subscriptionsStatusGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Verify and sync a subscription purchase from the client. Called when: - User makes a new purchase on the client - App starts up and has an existing purchase to sync The server becomes the source of truth for subscription status.
   * @param {VerifySubscriptionRequest} [verifySubscriptionRequest] The purchase details to verify and sync.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public subscriptionsVerifyPost(
    verifySubscriptionRequest?: VerifySubscriptionRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SubscriptionsApiFp(this.configuration)
      .subscriptionsVerifyPost(verifySubscriptionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * SystemApi - axios parameter creator
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get server build and runtime information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    infoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/info`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SystemApi - functional programming interface
 */
export const SystemApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get server build and runtime information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async infoGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InfoResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.infoGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SystemApi.infoGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SystemApi - factory interface
 */
export const SystemApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SystemApiFp(configuration)
  return {
    /**
     *
     * @summary Get server build and runtime information.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    infoGet(options?: RawAxiosRequestConfig): AxiosPromise<InfoResponse> {
      return localVarFp.infoGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * SystemApi - object-oriented interface
 */
export class SystemApi extends BaseAPI {
  /**
   *
   * @summary Get server build and runtime information.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public infoGet(options?: RawAxiosRequestConfig) {
    return SystemApiFp(this.configuration)
      .infoGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TeachersApi - axios parameter creator
 */
export const TeachersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get teachers for a class.
     * @param {string} classId path The class UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdTeachersGet: async (
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('classesClassIdTeachersGet', 'classId', classId)
      const localVarPath = `/classes/{classId}/teachers`.replace(
        `{${'classId'}}`,
        encodeURIComponent(String(classId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all teachers for the current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/teachers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new teacher.
     * @param {CreateTeacherRequest} [createTeacherRequest] The teacher creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersPost: async (
      createTeacherRequest?: CreateTeacherRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/teachers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTeacherRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Search for teachers by name or email.
     * @param {string} [q] query Optional search query (name or email).
     * @param {string} [classId] query Optional class ID to filter by.
     * @param {string} [limit] query Max results (default 20).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersSearchGet: async (
      q?: string,
      classId?: string,
      limit?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/teachers/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      if (q !== undefined) {
        localVarQueryParameter['q'] = q
      }

      if (classId !== undefined) {
        localVarQueryParameter['classId'] = classId
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get teacher summaries (for dropdowns and lists).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersSummariesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/teachers/summaries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Remove a teacher from a class.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {string} classId path The class UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdClassesClassIdDelete: async (
      teacherId: string,
      classId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'teacherId' is not null or undefined
      assertParamExists('teachersTeacherIdClassesClassIdDelete', 'teacherId', teacherId)
      // verify required parameter 'classId' is not null or undefined
      assertParamExists('teachersTeacherIdClassesClassIdDelete', 'classId', classId)
      const localVarPath = `/teachers/{teacherId}/classes/{classId}`
        .replace(`{${'teacherId'}}`, encodeURIComponent(String(teacherId)))
        .replace(`{${'classId'}}`, encodeURIComponent(String(classId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Assign a teacher to a class.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {AssignTeacherToClassRequest} [assignTeacherToClassRequest] The assignment details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdClassesPost: async (
      teacherId: string,
      assignTeacherToClassRequest?: AssignTeacherToClassRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'teacherId' is not null or undefined
      assertParamExists('teachersTeacherIdClassesPost', 'teacherId', teacherId)
      const localVarPath = `/teachers/{teacherId}/classes`.replace(
        `{${'teacherId'}}`,
        encodeURIComponent(String(teacherId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignTeacherToClassRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdDelete: async (
      teacherId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'teacherId' is not null or undefined
      assertParamExists('teachersTeacherIdDelete', 'teacherId', teacherId)
      const localVarPath = `/teachers/{teacherId}`.replace(
        `{${'teacherId'}}`,
        encodeURIComponent(String(teacherId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a specific teacher by ID.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdGet: async (
      teacherId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'teacherId' is not null or undefined
      assertParamExists('teachersTeacherIdGet', 'teacherId', teacherId)
      const localVarPath = `/teachers/{teacherId}`.replace(
        `{${'teacherId'}}`,
        encodeURIComponent(String(teacherId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the pending invite for a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdInviteGet: async (
      teacherId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'teacherId' is not null or undefined
      assertParamExists('teachersTeacherIdInviteGet', 'teacherId', teacherId)
      const localVarPath = `/teachers/{teacherId}/invite`.replace(
        `{${'teacherId'}}`,
        encodeURIComponent(String(teacherId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Send an invite to a teacher. Creates an invite and sends an email to the teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdInvitePost: async (
      teacherId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'teacherId' is not null or undefined
      assertParamExists('teachersTeacherIdInvitePost', 'teacherId', teacherId)
      const localVarPath = `/teachers/{teacherId}/invite`.replace(
        `{${'teacherId'}}`,
        encodeURIComponent(String(teacherId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {UpdateTeacherRequest} [updateTeacherRequest] The teacher update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdPut: async (
      teacherId: string,
      updateTeacherRequest?: UpdateTeacherRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'teacherId' is not null or undefined
      assertParamExists('teachersTeacherIdPut', 'teacherId', teacherId)
      const localVarPath = `/teachers/{teacherId}`.replace(
        `{${'teacherId'}}`,
        encodeURIComponent(String(teacherId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateTeacherRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TeachersApi - functional programming interface
 */
export const TeachersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TeachersApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get teachers for a class.
     * @param {string} classId path The class UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async classesClassIdTeachersGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Teacher>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.classesClassIdTeachersGet(
        classId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.classesClassIdTeachersGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all teachers for the current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Teacher>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new teacher.
     * @param {CreateTeacherRequest} [createTeacherRequest] The teacher creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersPost(
      createTeacherRequest?: CreateTeacherRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Teacher>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersPost(
        createTeacherRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Search for teachers by name or email.
     * @param {string} [q] query Optional search query (name or email).
     * @param {string} [classId] query Optional class ID to filter by.
     * @param {string} [limit] query Max results (default 20).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersSearchGet(
      q?: string,
      classId?: string,
      limit?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Teacher>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersSearchGet(
        q,
        classId,
        limit,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersSearchGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get teacher summaries (for dropdowns and lists).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersSummariesGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeacherSummary>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersSummariesGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersSummariesGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Remove a teacher from a class.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {string} classId path The class UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersTeacherIdClassesClassIdDelete(
      teacherId: string,
      classId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.teachersTeacherIdClassesClassIdDelete(
          teacherId,
          classId,
          options
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersTeacherIdClassesClassIdDelete']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Assign a teacher to a class.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {AssignTeacherToClassRequest} [assignTeacherToClassRequest] The assignment details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersTeacherIdClassesPost(
      teacherId: string,
      assignTeacherToClassRequest?: AssignTeacherToClassRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersTeacherIdClassesPost(
        teacherId,
        assignTeacherToClassRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersTeacherIdClassesPost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersTeacherIdDelete(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersTeacherIdDelete(
        teacherId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersTeacherIdDelete']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a specific teacher by ID.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersTeacherIdGet(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Teacher>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersTeacherIdGet(
        teacherId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersTeacherIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the pending invite for a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersTeacherIdInviteGet(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeacherInvite>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersTeacherIdInviteGet(
        teacherId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersTeacherIdInviteGet']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Send an invite to a teacher. Creates an invite and sends an email to the teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersTeacherIdInvitePost(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeacherInviteResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersTeacherIdInvitePost(
        teacherId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersTeacherIdInvitePost']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {UpdateTeacherRequest} [updateTeacherRequest] The teacher update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async teachersTeacherIdPut(
      teacherId: string,
      updateTeacherRequest?: UpdateTeacherRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Teacher>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.teachersTeacherIdPut(
        teacherId,
        updateTeacherRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TeachersApi.teachersTeacherIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TeachersApi - factory interface
 */
export const TeachersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TeachersApiFp(configuration)
  return {
    /**
     *
     * @summary Get teachers for a class.
     * @param {string} classId path The class UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    classesClassIdTeachersGet(
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Teacher>> {
      return localVarFp
        .classesClassIdTeachersGet(classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all teachers for the current tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Teacher>> {
      return localVarFp.teachersGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new teacher.
     * @param {CreateTeacherRequest} [createTeacherRequest] The teacher creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersPost(
      createTeacherRequest?: CreateTeacherRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Teacher> {
      return localVarFp
        .teachersPost(createTeacherRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Search for teachers by name or email.
     * @param {string} [q] query Optional search query (name or email).
     * @param {string} [classId] query Optional class ID to filter by.
     * @param {string} [limit] query Max results (default 20).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersSearchGet(
      q?: string,
      classId?: string,
      limit?: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Teacher>> {
      return localVarFp
        .teachersSearchGet(q, classId, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get teacher summaries (for dropdowns and lists).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersSummariesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<TeacherSummary>> {
      return localVarFp.teachersSummariesGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Remove a teacher from a class.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {string} classId path The class UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdClassesClassIdDelete(
      teacherId: string,
      classId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .teachersTeacherIdClassesClassIdDelete(teacherId, classId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Assign a teacher to a class.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {AssignTeacherToClassRequest} [assignTeacherToClassRequest] The assignment details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdClassesPost(
      teacherId: string,
      assignTeacherToClassRequest?: AssignTeacherToClassRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<SuccessResponse> {
      return localVarFp
        .teachersTeacherIdClassesPost(teacherId, assignTeacherToClassRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdDelete(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .teachersTeacherIdDelete(teacherId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a specific teacher by ID.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdGet(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Teacher> {
      return localVarFp
        .teachersTeacherIdGet(teacherId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the pending invite for a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdInviteGet(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TeacherInvite> {
      return localVarFp
        .teachersTeacherIdInviteGet(teacherId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Send an invite to a teacher. Creates an invite and sends an email to the teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdInvitePost(
      teacherId: string,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<TeacherInviteResponse> {
      return localVarFp
        .teachersTeacherIdInvitePost(teacherId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update a teacher.
     * @param {string} teacherId path The teacher\&#39;s UUID.
     * @param {UpdateTeacherRequest} [updateTeacherRequest] The teacher update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    teachersTeacherIdPut(
      teacherId: string,
      updateTeacherRequest?: UpdateTeacherRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Teacher> {
      return localVarFp
        .teachersTeacherIdPut(teacherId, updateTeacherRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * TeachersApi - object-oriented interface
 */
export class TeachersApi extends BaseAPI {
  /**
   *
   * @summary Get teachers for a class.
   * @param {string} classId path The class UUID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public classesClassIdTeachersGet(classId: string, options?: RawAxiosRequestConfig) {
    return TeachersApiFp(this.configuration)
      .classesClassIdTeachersGet(classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all teachers for the current tenant.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersGet(options?: RawAxiosRequestConfig) {
    return TeachersApiFp(this.configuration)
      .teachersGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new teacher.
   * @param {CreateTeacherRequest} [createTeacherRequest] The teacher creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersPost(
    createTeacherRequest?: CreateTeacherRequest,
    options?: RawAxiosRequestConfig
  ) {
    return TeachersApiFp(this.configuration)
      .teachersPost(createTeacherRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Search for teachers by name or email.
   * @param {string} [q] query Optional search query (name or email).
   * @param {string} [classId] query Optional class ID to filter by.
   * @param {string} [limit] query Max results (default 20).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersSearchGet(
    q?: string,
    classId?: string,
    limit?: string,
    options?: RawAxiosRequestConfig
  ) {
    return TeachersApiFp(this.configuration)
      .teachersSearchGet(q, classId, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get teacher summaries (for dropdowns and lists).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersSummariesGet(options?: RawAxiosRequestConfig) {
    return TeachersApiFp(this.configuration)
      .teachersSummariesGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Remove a teacher from a class.
   * @param {string} teacherId path The teacher\&#39;s UUID.
   * @param {string} classId path The class UUID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersTeacherIdClassesClassIdDelete(
    teacherId: string,
    classId: string,
    options?: RawAxiosRequestConfig
  ) {
    return TeachersApiFp(this.configuration)
      .teachersTeacherIdClassesClassIdDelete(teacherId, classId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Assign a teacher to a class.
   * @param {string} teacherId path The teacher\&#39;s UUID.
   * @param {AssignTeacherToClassRequest} [assignTeacherToClassRequest] The assignment details.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersTeacherIdClassesPost(
    teacherId: string,
    assignTeacherToClassRequest?: AssignTeacherToClassRequest,
    options?: RawAxiosRequestConfig
  ) {
    return TeachersApiFp(this.configuration)
      .teachersTeacherIdClassesPost(teacherId, assignTeacherToClassRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a teacher.
   * @param {string} teacherId path The teacher\&#39;s UUID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersTeacherIdDelete(teacherId: string, options?: RawAxiosRequestConfig) {
    return TeachersApiFp(this.configuration)
      .teachersTeacherIdDelete(teacherId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a specific teacher by ID.
   * @param {string} teacherId path The teacher\&#39;s UUID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersTeacherIdGet(teacherId: string, options?: RawAxiosRequestConfig) {
    return TeachersApiFp(this.configuration)
      .teachersTeacherIdGet(teacherId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the pending invite for a teacher.
   * @param {string} teacherId path The teacher\&#39;s UUID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersTeacherIdInviteGet(teacherId: string, options?: RawAxiosRequestConfig) {
    return TeachersApiFp(this.configuration)
      .teachersTeacherIdInviteGet(teacherId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Send an invite to a teacher. Creates an invite and sends an email to the teacher.
   * @param {string} teacherId path The teacher\&#39;s UUID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersTeacherIdInvitePost(teacherId: string, options?: RawAxiosRequestConfig) {
    return TeachersApiFp(this.configuration)
      .teachersTeacherIdInvitePost(teacherId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update a teacher.
   * @param {string} teacherId path The teacher\&#39;s UUID.
   * @param {UpdateTeacherRequest} [updateTeacherRequest] The teacher update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public teachersTeacherIdPut(
    teacherId: string,
    updateTeacherRequest?: UpdateTeacherRequest,
    options?: RawAxiosRequestConfig
  ) {
    return TeachersApiFp(this.configuration)
      .teachersTeacherIdPut(teacherId, updateTeacherRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TenantsApi - axios parameter creator
 */
export const TenantsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Bootstrap a new tenant with all defaults (academic year, terms, etc.).
     * @param {BootstrapTenantRequest} [bootstrapTenantRequest] The bootstrap configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsBootstrapPost: async (
      bootstrapTenantRequest?: BootstrapTenantRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/tenants/bootstrap`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        bootstrapTenantRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update an existing tenant.
     * @param {string} id path The tenant ID.
     * @param {UpdateTenantRequest} [updateTenantRequest] The tenant update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsIdPut: async (
      id: string,
      updateTenantRequest?: UpdateTenantRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('tenantsIdPut', 'id', id)
      const localVarPath = `/tenants/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateTenantRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get the current user\'s tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsMeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/tenants/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new tenant (individual or school).
     * @param {CreateTenantRequest} [createTenantRequest] The tenant creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsPost: async (
      createTenantRequest?: CreateTenantRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/tenants`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTenantRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TenantsApi - functional programming interface
 */
export const TenantsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TenantsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Bootstrap a new tenant with all defaults (academic year, terms, etc.).
     * @param {BootstrapTenantRequest} [bootstrapTenantRequest] The bootstrap configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsBootstrapPost(
      bootstrapTenantRequest?: BootstrapTenantRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsBootstrapPost(
        bootstrapTenantRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TenantsApi.tenantsBootstrapPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update an existing tenant.
     * @param {string} id path The tenant ID.
     * @param {UpdateTenantRequest} [updateTenantRequest] The tenant update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsIdPut(
      id: string,
      updateTenantRequest?: UpdateTenantRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsIdPut(
        id,
        updateTenantRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TenantsApi.tenantsIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get the current user\'s tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsMeGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsMeGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TenantsApi.tenantsMeGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new tenant (individual or school).
     * @param {CreateTenantRequest} [createTenantRequest] The tenant creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async tenantsPost(
      createTenantRequest?: CreateTenantRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tenant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.tenantsPost(
        createTenantRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TenantsApi.tenantsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TenantsApi - factory interface
 */
export const TenantsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TenantsApiFp(configuration)
  return {
    /**
     *
     * @summary Bootstrap a new tenant with all defaults (academic year, terms, etc.).
     * @param {BootstrapTenantRequest} [bootstrapTenantRequest] The bootstrap configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsBootstrapPost(
      bootstrapTenantRequest?: BootstrapTenantRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Tenant> {
      return localVarFp
        .tenantsBootstrapPost(bootstrapTenantRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update an existing tenant.
     * @param {string} id path The tenant ID.
     * @param {UpdateTenantRequest} [updateTenantRequest] The tenant update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsIdPut(
      id: string,
      updateTenantRequest?: UpdateTenantRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Tenant> {
      return localVarFp
        .tenantsIdPut(id, updateTenantRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get the current user\'s tenant.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsMeGet(options?: RawAxiosRequestConfig): AxiosPromise<Tenant> {
      return localVarFp.tenantsMeGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new tenant (individual or school).
     * @param {CreateTenantRequest} [createTenantRequest] The tenant creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tenantsPost(
      createTenantRequest?: CreateTenantRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Tenant> {
      return localVarFp
        .tenantsPost(createTenantRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * TenantsApi - object-oriented interface
 */
export class TenantsApi extends BaseAPI {
  /**
   *
   * @summary Bootstrap a new tenant with all defaults (academic year, terms, etc.).
   * @param {BootstrapTenantRequest} [bootstrapTenantRequest] The bootstrap configuration.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantsBootstrapPost(
    bootstrapTenantRequest?: BootstrapTenantRequest,
    options?: RawAxiosRequestConfig
  ) {
    return TenantsApiFp(this.configuration)
      .tenantsBootstrapPost(bootstrapTenantRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update an existing tenant.
   * @param {string} id path The tenant ID.
   * @param {UpdateTenantRequest} [updateTenantRequest] The tenant update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantsIdPut(
    id: string,
    updateTenantRequest?: UpdateTenantRequest,
    options?: RawAxiosRequestConfig
  ) {
    return TenantsApiFp(this.configuration)
      .tenantsIdPut(id, updateTenantRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get the current user\'s tenant.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantsMeGet(options?: RawAxiosRequestConfig) {
    return TenantsApiFp(this.configuration)
      .tenantsMeGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new tenant (individual or school).
   * @param {CreateTenantRequest} [createTenantRequest] The tenant creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public tenantsPost(createTenantRequest?: CreateTenantRequest, options?: RawAxiosRequestConfig) {
    return TenantsApiFp(this.configuration)
      .tenantsPost(createTenantRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TermsApi - axios parameter creator
 */
export const TermsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all terms for the current academic year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/terms`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create a new term.
     * @param {CreateTermsRequest} [createTermsRequest] The term creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsPost: async (
      createTermsRequest?: CreateTermsRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/terms`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTermsRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete a term.
     * @param {string} termId path The term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermIdDelete: async (
      termId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'termId' is not null or undefined
      assertParamExists('termsTermIdDelete', 'termId', termId)
      const localVarPath = `/terms/{termId}`.replace(
        `{${'termId'}}`,
        encodeURIComponent(String(termId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get a specific term by ID.
     * @param {string} termId path The term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermIdGet: async (
      termId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'termId' is not null or undefined
      assertParamExists('termsTermIdGet', 'termId', termId)
      const localVarPath = `/terms/{termId}`.replace(
        `{${'termId'}}`,
        encodeURIComponent(String(termId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update an existing term.
     * @param {string} termId path The term ID.
     * @param {UpdateTermRequest} [updateTermRequest] The term update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermIdPut: async (
      termId: string,
      updateTermRequest?: UpdateTermRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'termId' is not null or undefined
      assertParamExists('termsTermIdPut', 'termId', termId)
      const localVarPath = `/terms/{termId}`.replace(
        `{${'termId'}}`,
        encodeURIComponent(String(termId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateTermRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TermsApi - functional programming interface
 */
export const TermsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TermsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get all terms for the current academic year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termsGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Term>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termsGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termsGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Create a new term.
     * @param {CreateTermsRequest} [createTermsRequest] The term creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termsPost(
      createTermsRequest?: CreateTermsRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termsPost(
        createTermsRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termsPost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Delete a term.
     * @param {string} termId path The term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termsTermIdDelete(
      termId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termsTermIdDelete(termId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termsTermIdDelete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get a specific term by ID.
     * @param {string} termId path The term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termsTermIdGet(
      termId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Term>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termsTermIdGet(termId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termsTermIdGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update an existing term.
     * @param {string} termId path The term ID.
     * @param {UpdateTermRequest} [updateTermRequest] The term update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async termsTermIdPut(
      termId: string,
      updateTermRequest?: UpdateTermRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Term>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.termsTermIdPut(
        termId,
        updateTermRequest,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['TermsApi.termsTermIdPut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * TermsApi - factory interface
 */
export const TermsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TermsApiFp(configuration)
  return {
    /**
     *
     * @summary Get all terms for the current academic year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Term>> {
      return localVarFp.termsGet(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Create a new term.
     * @param {CreateTermsRequest} [createTermsRequest] The term creation request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsPost(
      createTermsRequest?: CreateTermsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .termsPost(createTermsRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Delete a term.
     * @param {string} termId path The term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermIdDelete(termId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .termsTermIdDelete(termId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get a specific term by ID.
     * @param {string} termId path The term ID.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermIdGet(termId: string, options?: RawAxiosRequestConfig): AxiosPromise<Term> {
      return localVarFp.termsTermIdGet(termId, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update an existing term.
     * @param {string} termId path The term ID.
     * @param {UpdateTermRequest} [updateTermRequest] The term update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    termsTermIdPut(
      termId: string,
      updateTermRequest?: UpdateTermRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Term> {
      return localVarFp
        .termsTermIdPut(termId, updateTermRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * TermsApi - object-oriented interface
 */
export class TermsApi extends BaseAPI {
  /**
   *
   * @summary Get all terms for the current academic year.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termsGet(options?: RawAxiosRequestConfig) {
    return TermsApiFp(this.configuration)
      .termsGet(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Create a new term.
   * @param {CreateTermsRequest} [createTermsRequest] The term creation request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termsPost(createTermsRequest?: CreateTermsRequest, options?: RawAxiosRequestConfig) {
    return TermsApiFp(this.configuration)
      .termsPost(createTermsRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Delete a term.
   * @param {string} termId path The term ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termsTermIdDelete(termId: string, options?: RawAxiosRequestConfig) {
    return TermsApiFp(this.configuration)
      .termsTermIdDelete(termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get a specific term by ID.
   * @param {string} termId path The term ID.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termsTermIdGet(termId: string, options?: RawAxiosRequestConfig) {
    return TermsApiFp(this.configuration)
      .termsTermIdGet(termId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update an existing term.
   * @param {string} termId path The term ID.
   * @param {UpdateTermRequest} [updateTermRequest] The term update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public termsTermIdPut(
    termId: string,
    updateTermRequest?: UpdateTermRequest,
    options?: RawAxiosRequestConfig
  ) {
    return TermsApiFp(this.configuration)
      .termsTermIdPut(termId, updateTermRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Partially update current user profile.
     * @param {UpdateUserRequest} [updateUserRequest] The fields to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePatch: async (
      updateUserRequest?: UpdateUserRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload profile photo for current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meProfilePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me/profile`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update current user profile (placeholder).
     * @param {UpdateUserRequest} [updateUserRequest] The user update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePut: async (
      updateUserRequest?: UpdateUserRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateUserRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get all users (dev only).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/users`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration)

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Partially update current user profile.
     * @param {UpdateUserRequest} [updateUserRequest] The fields to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePatch(
      updateUserRequest?: UpdateUserRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePatch(updateUserRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.mePatch']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Upload profile photo for current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meProfilePost(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meProfilePost(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.meProfilePost']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update current user profile (placeholder).
     * @param {UpdateUserRequest} [updateUserRequest] The user update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mePut(
      updateUserRequest?: UpdateUserRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mePut(updateUserRequest, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.mePut']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all users (dev only).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersGet(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<User>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersGet(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['UsersApi.usersGet']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UsersApiFp(configuration)
  return {
    /**
     *
     * @summary Partially update current user profile.
     * @param {UpdateUserRequest} [updateUserRequest] The fields to update.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePatch(
      updateUserRequest?: UpdateUserRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<User> {
      return localVarFp
        .mePatch(updateUserRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Upload profile photo for current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meProfilePost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp.meProfilePost(options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Update current user profile (placeholder).
     * @param {UpdateUserRequest} [updateUserRequest] The user update request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mePut(
      updateUserRequest?: UpdateUserRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<void> {
      return localVarFp
        .mePut(updateUserRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get all users (dev only).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<User>> {
      return localVarFp.usersGet(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @summary Partially update current user profile.
   * @param {UpdateUserRequest} [updateUserRequest] The fields to update.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public mePatch(updateUserRequest?: UpdateUserRequest, options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .mePatch(updateUserRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Upload profile photo for current user.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public meProfilePost(options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .meProfilePost(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update current user profile (placeholder).
   * @param {UpdateUserRequest} [updateUserRequest] The user update request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public mePut(updateUserRequest?: UpdateUserRequest, options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .mePut(updateUserRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all users (dev only).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public usersGet(options?: RawAxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersGet(options)
      .then((request) => request(this.axios, this.basePath))
  }
}
